import { Questions } from '../types/group';

export const questions: Questions = [
  {
    id: 747,
    alias: 'ticket747',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-21',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Пострадавшего в аварии следует вынести из автомобиля, если:',
    answer_a:
      'У пострадавшего наблюдаются серьезные травмы.',
    answer_b:
      'Место происшествия небезопасно, например возможен взрыв.',
    answer_c: 'На автомобиль упал электрический провод.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 296,
    alias: 'ticket296',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_41',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещается, если:',
    answer_a:
      'Шины автобусов имеют остаточную высоту рисунка протектора 1.8 мм.',
    answer_b:
      'Нарушена герметичность гидравлического тормозного привода.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 642,
    alias: 'ticket642',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-7',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При отсутствии или неисправности светового указателя поворота подача предупредительного сигнала рукой прекращается:',
    answer_a: 'Непосредственно перед выполнением маневра.',
    answer_b: 'Незамедлительно после завершения маневра.',
    answer_c: 'Во время выполнения маневра.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 537,
    alias: 'ticket537',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367317224-51.jpeg',
    image_original: '1367237447-31.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-30',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Кто из водителей обязан остановиться?',
    answer_a: 'Водитель легкового автомобиля.',
    answer_b: 'Водитель автобуса.',
    answer_c: 'Оба водителя.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 464,
    alias: 'ticket464',
    position: 3,
    correct_answer: 'answer_c',
    image: '1367225435-46.jpeg',
    image_original: '1367225435-61.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-9',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Каким транспортным средствам разрешается повернуть направо?',
    answer_a: 'Только красному автомобилю.',
    answer_b: 'Всем транспортным средствам.',
    answer_c: 'Красному и зеленому автомобилям.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 165,
    alias: 'ticket165',
    position: 0,
    correct_answer: 'answer_e',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_23',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Разворот запрещается:',
    answer_a: 'На пешеходных переходах и в тоннелях.',
    answer_b:
      'На мостах, путепроводах, эстакадах и под ними.',
    answer_c: 'На железнодорожных переездах.',
    answer_d:
      'При видимости дороги менее 100 м хотя бы в одном направлении.',
    answer_e: 'Во всех перечисленных случаях.',
  },
  {
    id: 606,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-33',
    created_at: null,
    updated_at: '2020-03-20 11:05:45',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли перевозить детей, не достигших 12-летнего возраста в кабине грузового автомобиля?',
    answer_a: 'Разрешается.',
    answer_b:
      'Разрешается только в сопровождении взрослого пассажира.',
    answer_c: 'Запрещается.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 189,
    alias: 'ticket189',
    position: 0,
    correct_answer: 'answer_b',
    image: '1370603538-85.jpeg',
    image_original: '1371025966-53.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1-47',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какому транспортному средству Вы должны уступить дорогу, если намерены продолжить движение прямо?',
    answer_a: 'Только легковому автомобилю.',
    answer_b: 'Только автобусу и легковому автомобилю.',
    answer_c: 'Всем транспортным средствам.',
    answer_d: 'Только мотоциклу.',
    answer_e: '',
  },
  {
    id: 710,
    alias: 'ticket710',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367319285-28.jpeg',
    image_original: '1367319285-34.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-75',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'О чем информирует сигнал, поданный рукой водителя легкового автомобиля?',
    answer_a: 'Поворачивает направо.',
    answer_b: 'Продолжает движение по прямой.',
    answer_c: 'Тормозит.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 325,
    alias: 'ticket325',
    position: 9,
    correct_answer: 'answer_c',
    image: '1366979377-27.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-11',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что означает табличка под знаком?',
    answer_a:
      'Расстояние от знака до начала первого поворота.',
    answer_b:
      'Расстояние от первого поворота до начала второго поворота.',
    answer_c:
      'Протяженность участка дороги с опасными поворотами.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 652,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image:
      '30ef30b64204a3088a26bc2e6ecf7602_1585129088.jpeg',
    image_original: '1367318774-08.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-17',
    created_at: null,
    updated_at: '2020-03-25 13:38:08',
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства должен уступить дорогу?',
    answer_a: 'Водитель автомобиля скорой помощи.',
    answer_b: 'Водитель легкового автомобиля.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 358,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image:
      'aa942ab2bfa6ebda4840e7360ce6e7ef_1583955296.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-44',
    created_at: null,
    updated_at: '2020-03-11 23:34:56',
    hint_for_correct_answer: '',
    question:
      'Какой из этих дорожных знаков не является запрещающим?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 357,
    alias: 'ticket357',
    position: 0,
    correct_answer: 'answer_c',
    image: '1366984437-44.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-43',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Каким транспортным средствам разрешено движение по дороге, на которой установлен этот знак?',
    answer_a: 'Механическим транспортным средствам.',
    answer_b: 'Всем транспортным средствам.',
    answer_c: 'Автомобилям и мотоциклам.',
    answer_d:
      'Транспортным средствам максимальная скорость которых более 40 км/ч.',
    answer_e: '',
  },
  {
    id: 213,
    alias: 'ticket213',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_9',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» к пешeходaм приравниваются:',
    answer_a:
      'Инвалиды, передвигающиеся в инвалидных колясках без двигателя.',
    answer_b:
      'Лицa, ведущие (толкающие) тележку, санки, детскую или инвалидную коляску.',
    answer_c: 'Все перечисленные лицa.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 365,
    alias: null,
    position: 0,
    correct_answer: 'answer_e',
    image:
      '9be40cee5b0eee1462c82c6964087ff9_1583955745.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-51',
    created_at: null,
    updated_at: '2020-03-11 23:42:25',
    hint_for_correct_answer: '',
    question:
      'Какой из знаков указывает объезд препятствия справа или слева?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 468,
    alias: 'ticket468',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-13',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Если руки регулировщика вытянуты в стороны или опущены, то движение безрельсовым транспортным средствам разрешено:',
    answer_a: 'Со стороны груди и спины - только направо.',
    answer_b:
      'Со стороны левого и правого боков - прямо и направо.',
    answer_c:
      'Со стороны левого и правого боков - только прямо.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 664,
    alias: 'ticket664',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367318903-93.jpeg',
    image_original: '1367318903-99.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-29',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли водителю красного автомобиля выполнить обгон в данной ситуации?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c:
      'Разрешается, при условии, что скорость обгоняемого менее 30 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 479,
    alias: 'ticket479',
    position: 8,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-24',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Если руки регулировщика вытянуты в стороны или опущены, то движение безрельсовым транспортным средствам со стороны левого и правого боков разрешено:',
    answer_a: 'Прямо и направо.',
    answer_b: 'Только прямо.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 246,
    alias: 'ticket246',
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_42',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» водительское удостоверение на право управления транспортными средствами категории «D» и подкатегории «D1» может быть выдано лицам, достигшим:',
    answer_a: '18 - летнего возраста.',
    answer_b: '19 - летнего возраста.',
    answer_c: '20 - летнего возраста.',
    answer_d: '21 - летнего возраста.',
    answer_e: '',
  },
  {
    id: 450,
    alias: 'ticket450',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367010081.jpeg',
    image_original: '1367010081-21.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-56',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a:
      'Грузовой автомобиль и мотоцикл, автобус, троллейбус.',
    answer_b:
      'Грузовой автомобиль и автобус, мотоцикл, троллейбус.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 186,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '1370603347-49.jpeg',
    image_original: '1366747737-31.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_44',
    created_at: null,
    updated_at: '2020-03-14 00:22:08',
    hint_for_correct_answer: '',
    question:
      'Обязан ли водитель автобуса уступить дорогу грузовому автомобилю на перекрестке, где организовано кольцевое движение?',
    answer_a: 'Обязан.',
    answer_b: 'Не обязан.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 359,
    alias: 'ticket359',
    position: 0,
    correct_answer: 'answer_c',
    image: '1366963747-46.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-45',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что обозначает данный опознавательный знак:',
    answer_a:
      'Впереди участок дороги, имеющий неровность на проезжей части.',
    answer_b:
      'Впереди участок дороги с тремя полосами для движения в данном направлении.',
    answer_c:
      'На механическом транспортном средстве установлены шины с шипами.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 257,
    alias: 'ticket257',
    position: 7,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_2',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Шины грузового автомобиля имеют остаточную высоту рисунка протектора 1.6 мм.',
    answer_b:
      'Не действует манометр пневматического тормозного привода.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 549,
    alias: null,
    position: 0,
    correct_answer: 'answer_d',
    image: '1367317350-64.jpeg',
    image_original: '1367237811-44.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-42',
    created_at: null,
    updated_at: '2020-03-19 23:16:45',
    hint_for_correct_answer: '',
    question:
      'Водители каких транспортных средств неправильно остановились для высадки пассажиров?',
    answer_a: 'Водитель легкового автомобиля.',
    answer_b: 'Водитель мотоцикла.',
    answer_c: 'Водитель автобуса.',
    answer_d: 'Все водители.',
    answer_e: '',
  },
  {
    id: 471,
    alias: 'ticket471',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367230254-43.jpeg',
    image_original: '1367230254-61.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-16',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При каком сигнале светофора водителю автомобиля можно закончить разворот?',
    answer_a: 'При красном.',
    answer_b: 'При зеленом.',
    answer_c: 'При любом.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 667,
    alias: 'ticket667',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-32',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В темное время суток и в условиях недостаточной видимости, независимо от освещения дороги, на движущемся механическом транспортном средстве должны быть включены:',
    answer_a: 'Фары дальнего света.',
    answer_b: 'Фары ближнего света.',
    answer_c: 'Фары дальнего или ближнего света.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 634,
    alias: 'ticket634',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-61',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой скоростью разрешается движение транспортных средств на территориях, обозначенных дорожными знаками «Жилая зона» и «Конец жилой зоны» ?',
    answer_a: 'Не более 5 км/ч.',
    answer_b: 'Не более 10 км/ч.',
    answer_c: 'Не более 20 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 335,
    alias: 'ticket335',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366983678-15.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-21',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что указывает табличка под знаком?',
    answer_a: 'Протяженность узкого участка дороги.',
    answer_b:
      'Расстояние от знака до узкого участка дороги.',
    answer_c:
      'Расстояние до объезда узкого участка дороги.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 646,
    alias: 'ticket646',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-11',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Для чего служат установленные на транспортных средствах проблесковые маячки оранжевого или желтого цветов?',
    answer_a:
      'Для получения преимущества перед другими участниками дорожного движения.',
    answer_b:
      'Для предупреждения других участников дорожного движения об опасности.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 526,
    alias: null,
    position: 7,
    correct_answer: 'answer_a',
    image: '1367317079-75.jpeg',
    image_original: '1367237018-5.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-19',
    created_at: null,
    updated_at: '2020-03-19 22:07:24',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли водителю туристического автобуса заезжать на полосу «А» при наличии данной разметки?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 614,
    alias: 'ticket614',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-41',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой максимальной скоростью разрешается движение междугородних и межобластных автобусов на всех дорогах вне населенных пунктов:',
    answer_a: '60 км/ч.',
    answer_b: '70 км/ч.',
    answer_c: '90 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 315,
    alias: 'ticket315',
    position: 9,
    correct_answer: 'answer_d',
    image: '1366914593-45.jpeg',
    image_original: '1366914593-65.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-1',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эти знаки разрешают движение:',
    answer_a: 'Только налево.',
    answer_b: 'Только прямо.',
    answer_c: 'Только направо.',
    answer_d: 'Прямо, направо и в обратном направлении.',
    answer_e: '',
  },
  {
    id: 387,
    alias: 'ticket387',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366973213-2.jpeg',
    image_original: '1366973213-36.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-73',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Как должен поступить водитель в данной ситуации?',
    answer_a:
      'Необходимо остановиться около первого знака.',
    answer_b:
      'Необходимо остановиться перед вторым знаком.',
    answer_c:
      'Необходимо остановиться на расстоянии не менее 5 метров от первой железнодорожной линии.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 455,
    alias: 'ticket455',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367010333-91.jpeg',
    image_original: '1367010334-06.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-61',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a: 'Легковой автомобиль, автобус, троллейбус.',
    answer_b: 'Троллейбус и автобус, легковой автомобиль.',
    answer_c: 'Троллейбус, легковой автомобиль, автобус.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 163,
    alias: 'ticket163',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_21',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'По дороге с двухсторонним движением, имеющей три полосы, Вам необходимо повернуть налево. Из какой полосы Вы осуществите данный маневр?',
    answer_a: 'С правой полосы.',
    answer_b: 'Со средней полосы.',
    answer_c: 'С правой или средней полосы.',
    answer_d:
      'Со средней полосы, но лишь когда занята правая полоса.',
    answer_e: '',
  },
  {
    id: 439,
    alias: 'ticket439',
    position: 6,
    correct_answer: 'answer_a',
    image: '1367008839-09.jpeg',
    image_original: '1367008839-24.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-45',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Красный автомобиль проедет перекресток:',
    answer_a: 'Вторым, одновременно с синим.',
    answer_b: 'Вторым, после желтого.',
    answer_c: 'Третьим, после зеленого и желтого.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 759,
    alias: 'ticket759',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-33',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При наезде автомобилем с низким кузовом на пешехода, имеющего рост 155 см. или более, наиболее возможно травмирование:',
    answer_a: 'Нижних конечностей и головы.',
    answer_b: 'Таза и грудной клетки.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 619,
    alias: 'ticket619',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-46',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли перевозка людей в буксируемом автобусе при жесткой или гибкой сцепке:',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 600,
    alias: 'ticket600',
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-27',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При буксировке путем частичной погрузки разрешается перевозка пассажиров:',
    answer_a: 'В кузове буксирующего автомобиля.',
    answer_b: 'В кабине буксируемого автомобиля.',
    answer_c: 'В кузове буксируемого автомобиля.',
    answer_d: 'В кабине буксирующего автомобиля.',
    answer_e: '',
  },
  {
    id: 388,
    alias: 'ticket388',
    position: 0,
    correct_answer: 'answer_c',
    image: '1366973265-55.jpeg',
    image_original: '1366973265-69.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-74',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Как должен поступить водитель, если намерен совершить правый поворот на перекрестке?',
    answer_a:
      'Может перестроиться на правую полосу движения и только после этого совершить поворот.',
    answer_b:
      'Может приблизиться к перекрестку, затем совершить правый поворот.',
    answer_c: 'Оба ответа правильны.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 393,
    alias: 'ticket393',
    position: 0,
    correct_answer: 'answer_c',
    image: '1366973571-76.jpeg',
    image_original: '1366973571-92.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-79',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком направлении разрешено движение легкового автомобиля?',
    answer_a: 'Налево и в обратную сторону.',
    answer_b: 'В любом направлении.',
    answer_c: 'Прямо, налево и в обратном направлении.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 478,
    alias: 'ticket478',
    position: 9,
    correct_answer: 'answer_b',
    image: '1367230518-81.jpeg',
    image_original: '1367230518-96.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-23',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Движение разрешено:',
    answer_a: 'Всем транспортным средствам.',
    answer_b: 'Мотоциклу.',
    answer_c: 'Автомобилю и мотоциклу.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 210,
    alias: 'ticket210',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_6',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Недостаточная видимость» это:',
    answer_a: 'Видимость в темное время суток.',
    answer_b:
      'Видимость дороги в населенных пунктах при отсутствии искусственного освещения проезжей части.',
    answer_c:
      'Видимость дороги во время тумана, дождя, снегопада и (или) при иных погодных условиях, недостаточных для обеспечения безопасности дорожного движения, а также видимость дороги в темное время суток, и (или) видимость менее 300м.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 687,
    alias: 'ticket687',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-52',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На транспортном средстве аварийная световая сигнализация должна быть включена:',
    answer_a: 'При дорожно-транспортном происшествии.',
    answer_b:
      'При буксировке (на буксируемом механическом транспортном средстве).',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 181,
    alias: 'ticket181',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_39',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли транспортным средствам, выполняющим регулярную перевозку пассажиров на всех дорогах, занимать крайнюю левую полосу дороги, имеющей 3 или более полосы в одном направлении?',
    answer_a: 'Разрешается при обгоне.',
    answer_b:
      'Разрешается, при левом повороте или развороте.',
    answer_c: 'Разрешается в любых случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 188,
    alias: 'ticket188',
    position: 0,
    correct_answer: 'answer_a',
    image: '1370603471-68.jpeg',
    image_original: '1366747830-69.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_46',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Кому Вы должны уступить дорогу, если намерены продолжать движение прямо?',
    answer_a: 'Двум транспортным средствам.',
    answer_b: 'Только автобусу.',
    answer_c: 'Только легковому автомобилю.',
    answer_d: 'Никому.',
    answer_e: '',
  },
  {
    id: 769,
    alias: null,
    position: 0,
    correct_answer: 'answer_d',
    image:
      '288cc0ff022877bd3df94bc9360b9c5d_1584560370.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 1,
    group: 4,
    label: '4-84',
    created_at: '2020-03-18 23:39:30',
    updated_at: '2020-03-18 23:39:37',
    hint_for_correct_answer: '',
    question: 'Что означает данная дорожная разметка?',
    answer_a: 'Место стоянки транспортных средств․',
    answer_b: 'Место пешеходного перехода․',
    answer_c: 'Островок безопасности․',
    answer_d:
      'Участок перекрестка, где запрещается въезд, если впереди по направлению движения образовалась пробка, которая принудит водителя остановиться.',
    answer_e: '',
  },
  {
    id: 763,
    alias: 'ticket763',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-37',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'При обработке опасных ран следует:',
    answer_a: 'Промыть рану чистой водой с мылом.',
    answer_b:
      'Обработать рану каким-нибудь веществом на спиртовой основе (йод, водка и т.д).',
    answer_c: 'Остановить кровотечение и перевязать рану.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 692,
    alias: 'ticket692',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-57',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Если значения сигналов светофора противоречат требованиям дорожных знаков приоритета, то водители должны руководствоваться.',
    answer_a: 'Требованиями знаков.',
    answer_b: 'Сигналами светофора.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 242,
    alias: 'ticket242',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_38',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» национальные водительские удостоверения выдаются сроком на:',
    answer_a: '5 лет.',
    answer_b: '10 лет.',
    answer_c: '20 лет.',
    answer_d: 'Бессрочно.',
    answer_e: '',
  },
  {
    id: 280,
    alias: 'ticket280',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_25',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Спереди установлены светоотражающие приспособления белого цвета.',
    answer_b:
      'Неисправно тягово-сцепное устройство тягача.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 420,
    alias: 'ticket420',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367007135-28.jpeg',
    image_original: '1367007135-44.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-26',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a: 'Красный, зеленый, синий, черный.',
    answer_b: 'Зеленый, красный, черный, синий.',
    answer_c: 'Зеленый, красный, синий, черный.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 274,
    alias: 'ticket274',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_19',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Не работают предусмотренные конструкцией транспортного средства ремни безопасности.',
    answer_b:
      'Установлены предметы, ограничивающие обзорность с места водителя.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 255,
    alias: 'ticket255',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_51',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» международное водительское удостоверение на право управления транспортными средствами категории «D» , » DE» , подкатегории «D1» и «D1Е» может быть выдано лицам достигшим:',
    answer_a: '19 - летнего возраста.',
    answer_b: '20 - летнего возраста.',
    answer_c: '21 - летнего возраста.',
    answer_d: '22 - летнего возраста.',
    answer_e: '',
  },
  {
    id: 460,
    alias: 'ticket460',
    position: 7,
    correct_answer: 'answer_c',
    image: '1367225289-94.jpeg',
    image_original: '1367225290-1.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-5',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a: 'Трамвай и автобус, легковой автомобиль.',
    answer_b: 'Трамвай , легковой автомобиль, автобус.',
    answer_c: 'Легковой автомобиль, трамвай и автобус.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 360,
    alias: null,
    position: 0,
    correct_answer: 'answer_d',
    image:
      'e7b24b112a44fdd9ee93bdf998c6ca0e_1583955463.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-46',
    created_at: null,
    updated_at: '2020-03-11 23:37:43',
    hint_for_correct_answer: '',
    question:
      'Какой из этих называется «Конец дороги с односторонним движением»?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 760,
    alias: 'ticket760',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-34',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При наезде автомобилем с низким кузовом на 3-5 летнего ребёнка наиболее возможно травмирование:',
    answer_a: 'Нижних конечностей и головы.',
    answer_b: 'Таза и грудной клетки.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 477,
    alias: 'ticket477',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367230461-23.jpeg',
    image_original: '1367230461-39.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-22',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Каким транспортным средствам разрешено движение при этом сигнале светофора?',
    answer_a: 'Трамваю, желтому и красному автомобилям.',
    answer_b: 'Желтому и красному автомобилям.',
    answer_c: 'Всем транспортным средствам.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 268,
    alias: 'ticket268',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_13',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Не работают предусмотренные конструкцией стеклоомыватели.',
    answer_b:
      'Допустимая норма внешнего шума двигателя превышает величину, предусмотренную стандартом.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 436,
    alias: 'ticket436',
    position: 9,
    correct_answer: 'answer_b',
    image: '1367008639-92.jpeg',
    image_original: '1367008640-09.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-42',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Вторым проедет перекресток:',
    answer_a: 'Зеленый автомобиль.',
    answer_b: 'Красный автомобиль одновременно с синим.',
    answer_c: 'Желтый автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 392,
    alias: 'ticket392',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366973509-04.jpeg',
    image_original: '1366973509-2.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-78',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Что указывает данная дорожная разметка на проезжей части?',
    answer_a:
      'Границы полос, выделенных для попутно двигающихся транспортных средств.',
    answer_b:
      'Границу полосы проезжей части с реверсивным движением.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 324,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image:
      'f2fc990265c712c49d51a18a32b39f0c_1583953360.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-10',
    created_at: null,
    updated_at: '2020-03-11 23:02:40',
    hint_for_correct_answer: '',
    question:
      'Какой знак устанавливается непосредственно перед пересечением проезжих частей?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 584,
    alias: null,
    position: 1,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-11',
    created_at: null,
    updated_at: '2020-03-20 10:36:15',
    hint_for_correct_answer: '',
    question:
      'Во время буксировки, при отсутствии или неисправности аварийной световой сигнализации, знак «Аварийная остановка» устанавливается:',
    answer_a:
      'На задней части буксируемого транспортного средства.',
    answer_b:
      'В передней части буксирующего транспортного средства.',
    answer_c:
      'По усмотрению водителя, на видном месте одного из транспортных средств.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 225,
    alias: 'ticket225',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_21',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Велосипед» , это:',
    answer_a:
      'Транспортные средства, имеющие два или более колеса, в том числе инвалидные коляски, приводимые в движение мускульной силой находящихся на нем людей с помощью педали или рычага.',
    answer_b:
      'Транспортные средства, имеющие два или более колеса, кроме инвалидной коляски, приводимые в движение мускульной силой находящихся на нем людей с помощью педали или рычага.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 517,
    alias: 'ticket517',
    position: 0,
    correct_answer: 'answer_d',
    image: '1367316994-07.jpeg',
    image_original: '1367236767-97.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-10',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какому транспортному средству разрешено движение по правой полосе проезжей части?',
    answer_a: 'Всем механическим транспортным средствам.',
    answer_b:
      'Транспортным средствам общего пользования и такси.',
    answer_c: 'Только велосипедам.',
    answer_d:
      'Только транспортным средствам общего пользования.',
    answer_e: '',
  },
  {
    id: 583,
    alias: null,
    position: 2,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-10',
    created_at: null,
    updated_at: '2020-03-20 10:31:47',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли вне населенных пунктов водителю междугороднего автобуса превышать скорость 70 км/ч?',
    answer_a:
      'Разрешается, только при движении по дороге, имеющей две и более полосы для движения в данном направлении.',
    answer_b: 'Разрешается.',
    answer_c: 'Запрещается.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 716,
    alias: 'ticket716',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-81',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При организованной перевозке группы детей в светлое время суток на автобусе должны быть включены:',
    answer_a: 'Дальний свет фар.',
    answer_b: 'Ближний свет фар.',
    answer_c: 'Аварийный световой сигнал.',
    answer_d: 'Приборы внутреннего освещения салона.',
    answer_e: '',
  },
  {
    id: 182,
    alias: 'ticket182',
    position: 0,
    correct_answer: 'answer_c',
    image: '1366747525-76.jpeg',
    image_original: '1366747546-83.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_40',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Как должен поступить водитель автобуса в данной ситуации?',
    answer_a: 'Уступить дорогу легковому автомобилю.',
    answer_b:
      'Включить указатель поворота, дать звуковой сигнал и начать движение.',
    answer_c:
      'Начать движение, убедившись, что водитель легкового автомобиля уступает дорогу.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 580,
    alias: 'ticket580',
    position: 5,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-7',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Движение междугородних автобусов вне населенных пунктов разрешается со скоростью:',
    answer_a: 'Не более 70 км/ч.',
    answer_b: 'Не более 90 км/ч.',
    answer_c: 'Не более 110 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 730,
    alias: 'ticket730',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-4',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Попав в аварию, пешеход сломал руку. На предплечье имеется рана (около 5 см), из которой непрерывно вытекает кровь темного цвета. Что надо предпринять для остановки кровотечения?',
    answer_a: 'Промыть рану водой.',
    answer_b:
      'Приподнять руку пострадавшего и наложить тугую повязку.',
    answer_c: 'Рану смазать спиртовым раствором йода.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 709,
    alias: 'ticket709',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-74',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Обгон запрещается:',
    answer_a:
      'На железнодорожных переездах и на расстоянии 100 м до него.',
    answer_b:
      'На железнодорожных переездах и на расстоянии 150 м до него.',
    answer_c:
      'На железнодорожных переездах и на расстоянии 250 м до него.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 743,
    alias: 'ticket743',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-17',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При дорожно-транспортном происшествии в первую очередь необходимо:',
    answer_a: 'Уложить пострадавшего в удобном положении.',
    answer_b:
      'Обследовать место происшествия, обеспечив безопасность.',
    answer_c:
      'Проверить наличие сильного кровотечения у пострадавшего.',
    answer_d: 'Вынести пострадавшего из автомобиля.',
    answer_e: '',
  },
  {
    id: 397,
    alias: 'ticket397',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367001680-58.jpeg',
    image_original: '1367001680-76.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-3',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Синий автомобиль проедет перекресток:',
    answer_a: 'Первым.',
    answer_b: 'Вторым.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 498,
    alias: 'ticket498',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367231171-19.jpeg',
    image_original: '1367231171-36.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-43',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'О чем информирует сигнал светофора?',
    answer_a: 'Светофор неисправен.',
    answer_b:
      'При проезде перекрестка водители должны руководствоваться требованиями дорожных знаков.',
    answer_c:
      'Водители должны дождаться разрешающего сигнала светофора.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 752,
    alias: 'ticket752',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-26',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Ваш приятель, больной сахарным диабетом, чувствует недомогание и к тому же не помнит когда ему в последний раз вводили инсулин. Что надо предпринять в первую очередь?',
    answer_a: 'Дать пострадавшему сахар или сладкое питье.',
    answer_b: 'Предложить ему отдохнуть несколько часов.',
    answer_c: 'Посоветовать сделать инъекцию инсулина.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 608,
    alias: 'ticket608',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-35',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Перевозка людей на грузовом прицепе:',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается.',
    answer_c:
      'Разрешается только лицам, сопровождающим груз.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 396,
    alias: 'ticket396',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367001639-51.jpeg',
    image_original: '1367001639-7.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-2',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Последним проедет перекресток:',
    answer_a: 'Синий автомобиль.',
    answer_b: 'Зеленый автомобиль.',
    answer_c: 'Красный автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 171,
    alias: 'ticket171',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_29',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Если встречный разъезд на уклонах, обозначенных соответствующим знаком, затруднен, необходимо уступить дорогу:',
    answer_a:
      'Водителю транспортного средства, движущегося на спуск.',
    answer_b:
      'Водителю транспортного средства общего пользования.',
    answer_c:
      'Водителю транспортного средства, движущегося на подъем.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 434,
    alias: 'ticket434',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367007627-08.jpeg',
    image_original: '1367007627-23.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-40',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Водитель зеленого автомобиля:',
    answer_a:
      'Имеет преимущество на первоочередное движение.',
    answer_b: 'Должен уступить дорогу.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 314,
    alias: 'ticket314',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_59',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация автобусов запрещается, если:',
    answer_a: 'Имеется один противооткатный упор.',
    answer_b: 'Имеется один огнетушитель.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 432,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '1367007557-25.jpeg',
    image_original: '1367007557-41.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-38',
    created_at: null,
    updated_at: '2020-03-19 10:42:43',
    hint_for_correct_answer: '',
    question:
      'Какое транспортное средство имеет право на первоочередное движение?',
    answer_a:
      'Красный автомобиль, т.к. он въезжает на перекресток с круговым движением справа от синего автомобиля.',
    answer_b:
      'Синий автомобиль, т.к. он едет по дороге с круговым движением.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 391,
    alias: 'ticket391',
    position: 0,
    correct_answer: 'answer_c',
    image: '1366973431-18.jpeg',
    image_original: '1366973431-33.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-77',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Как должен поступить водитель в данной ситуации?',
    answer_a:
      'Проехать железнодорожный переезд, соблюдая меры безопасности.',
    answer_b:
      'Проехать железнодорожный переезд не останавливаясь.',
    answer_c:
      'Остановиться перед знаком и, соблюдая меры безопасности, проехать многорельсовый железнодорожный переезд.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 707,
    alias: 'ticket707',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-72',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель автомобиля патрульной службы для приобретения преимущества перед другими участниками дорожного движения должен включить:',
    answer_a: 'Проблесковый маячок синего цвета.',
    answer_b:
      'Проблесковые маячки синего и красного цветов.',
    answer_c:
      'Проблесковый маячок синего цвета и специальный звуковой сигнал.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 430,
    alias: 'ticket430',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367007472-44.jpeg',
    image_original: '1367007472-6.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-36',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства должен уступить дорогу?',
    answer_a: 'Водитель автомобиля.',
    answer_b: 'Водитель мотоцикла.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 303,
    alias: 'ticket303',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_48',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещается, если:',
    answer_a:
      'Суммарный люфт в рулевом управлении автобуса, изготовленном на базе легкового автомобиля, составляет 15 градусов.',
    answer_b:
      'Суммарный люфт в рулевом управлении автобуса составляет 15 градусов.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 735,
    alias: 'ticket735',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-9',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Оказывая помощь пострадавшему при открытом переломе конечности, необходимо:',
    answer_a:
      'Немедленно приподнять травмированную конечность пострадавшего.',
    answer_b:
      'Накрыть рану стерильной салфеткой и обездвижить травмированную конечность.',
    answer_c: 'Надавив, остановить кровотечение.',
    answer_d: 'Наложить на рану холодную примочку.',
    answer_e: '',
  },
  {
    id: 389,
    alias: 'ticket389',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366973293-06.jpeg',
    image_original: '1366973293-22.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-75',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Имеет ли водитель право совершить разворот на расстоянии 200 м от знака в данной ситуации?',
    answer_a: 'Имеет право.',
    answer_b: 'Не имеет право.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 321,
    alias: 'ticket321',
    position: 3,
    correct_answer: 'answer_c',
    image: '1366978675-79.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-7',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Этот дорожный знак:',
    answer_a:
      'Запрещает движение всех механических транспортных средств, за исключением двухколесных мотоциклов без коляски.',
    answer_b:
      'Запрещает движение всех механических транспортных средств, за исключением колесных тракторов.',
    answer_c:
      'Запрещается движение тракторов и самоходных машин.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 497,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      '7380ad8a673226ae47fce7bff88e9c33_1585119273.jpeg',
    image_original: '1367231079-63.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-42',
    created_at: null,
    updated_at: '2020-03-25 10:54:33',
    hint_for_correct_answer: '',
    question:
      'Какие транспортные средства имеют право продолжить движение в данной ситуации?',
    answer_a:
      'Легковой автомобиль - прямо, патрульный автомобиль - по всем направлениям, автобус - только направо.',
    answer_b:
      'Только патрульный автомобиль - по всем направлениям.',
    answer_c:
      'Патрульный автомобиль - по всем направлениям, автобус - только направо.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 663,
    alias: 'ticket663',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367318878-51.jpeg',
    image_original: '1367318878-58.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-28',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли водителю зеленого автомобиля выполнять обгон?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c:
      'Разрешается, если красный автомобиль движется со скоростью менее 30 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 355,
    alias: 'ticket355',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366984252-39.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-41',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Этот дорожный знак обозначает:',
    answer_a: 'Дорогу, не имеющую сквозного проезда.',
    answer_b:
      'Направление движения к объекту в населенном пункте.',
    answer_c:
      'Конец дополнительной полосы на подъеме или полосы разгона.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 414,
    alias: 'ticket414',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367006874-33.jpeg',
    image_original: '1367006874-5.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-20',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Вторым проедет перекресток:',
    answer_a: 'Синий автомобиль.',
    answer_b: 'Зеленый автомобиль.',
    answer_c: 'Красный автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 285,
    alias: 'ticket285',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_30',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Сзади установлены светоотражающие приспособления красного цвета.',
    answer_b:
      'Не работает предусмотренный конструкцией спидометр.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 611,
    alias: 'ticket611',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-38',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли при буксировке на гибкой или жесткой сцепке перевозить людей в буксируемом механическом транспортном средстве?',
    answer_a: 'Разрешается в автобусе и троллейбусе.',
    answer_b:
      'Разрешается в кабине грузового автомобиля и в легковом автомобиле.',
    answer_c:
      'Разрешается в кузове грузового автомобиля и в легковом автомобиле.',
    answer_d: 'Запрещается.',
    answer_e: '',
  },
  {
    id: 401,
    alias: 'ticket401',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367005588-93.jpeg',
    image_original: '1367005589-46.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-7',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Вторым проедет перекресток:',
    answer_a: 'Зеленый автомобиль.',
    answer_b: 'Красный автомобиль.',
    answer_c: 'Синий автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 542,
    alias: 'ticket542',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367317268-24.jpeg',
    image_original: '1367237533-26.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-35',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешена ли остановка автомобиля в этом месте?',
    answer_a:
      'Запрещена, так как расстояние между прерывистой линией разметки и остановившимся автомобилем менее 3 м.',
    answer_b: 'Запрещена по четным числам месяца.',
    answer_c: 'Разрешена.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 585,
    alias: 'ticket585',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-12',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При буксировке на жесткой сцепке расстояние между транспортными средствами не должно превышать:',
    answer_a: '2 м.',
    answer_b: '3 м.',
    answer_c: '4 м.',
    answer_d: '5 м.',
    answer_e: '6 м.',
  },
  {
    id: 266,
    alias: 'ticket266',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_11',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Нарушена герметичность системы вентиляции картера двигателя.',
    answer_b:
      'Нарушена герметичность системы питания двигателя.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 499,
    alias: 'ticket499',
    position: 0,
    correct_answer: 'answer_d',
    image: '1367231201-85.jpeg',
    image_original: '1367231202-01.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-44',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли водителю легкового автомобиля объехать автобус, когда отключен реверсивный светофор?',
    answer_a: 'Разрешается.',
    answer_b:
      'Разрешается, если автобус движется со скоростью 30км/ч.',
    answer_c:
      'Разрешается, если нет транспортных средств, двигающихся навстречу.',
    answer_d: 'Запрещается.',
    answer_e: '',
  },
  {
    id: 230,
    alias: 'ticket230',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_26',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» велосипедистам запрещается ездить:',
    answer_a: 'Не держась за руль.',
    answer_b: 'Без мотошлема.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 400,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image:
      '18d8042386b79e2c279fd162df0205c8_1585126581.jpeg',
    image_original: '1367001798-05.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-6',
    created_at: null,
    updated_at: '2020-03-25 12:56:21',
    hint_for_correct_answer: '',
    question: 'В каком направлении запрещено движение?',
    answer_a: 'Направо в первый проезд.',
    answer_b: 'Направо во второй проезд.',
    answer_c: 'Направо в первый и второй проезды.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 757,
    alias: 'ticket757',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-31',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Пострадавшего с травмой брюшной полости следует:',
    answer_a: 'Уложить и приподнять голову.',
    answer_b: 'Уложить и приподнять ноги.',
    answer_c: 'Уложить и согнуть ноги в коленных суставах.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 309,
    alias: 'ticket309',
    position: 5,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_54',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация автобусов запрещается, если:',
    answer_a:
      'Шины автобуса имеют остаточную высоту рисунка протектора 2.5 мм.',
    answer_b:
      'Не работают приборы внутреннего освещения салона.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 184,
    alias: 'ticket184',
    position: 0,
    correct_answer: 'answer_a',
    image: '1370602866-28.jpeg',
    image_original: '1366747647-89.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_42',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства имеет право на первоочередное движение?',
    answer_a: 'Водитель легкового автомобиля.',
    answer_b: 'Водитель автобуса.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 406,
    alias: 'ticket406',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367006540-95.jpeg',
    image_original: '1367006541-17.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-12',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Первым проедет перекресток:',
    answer_a: 'Зеленый автомобиль.',
    answer_b: 'Синий автомобиль.',
    answer_c: 'Красный автомобиль.',
    answer_d: 'Желтый автомобиль.',
    answer_e: '',
  },
  {
    id: 312,
    alias: 'ticket312',
    position: 2,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_57',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация автобусов запрещается, если:',
    answer_a: 'Отсутствуют противооткатные упоры.',
    answer_b:
      'Сзади установлены красные фонари заднего хода.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 307,
    alias: 'ticket307',
    position: 7,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_52',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация автобусов запрещается, если:',
    answer_a: 'Не работает сигнал требования остановки.',
    answer_b:
      'Цифры и буквы регистрационных знаков повторяются на задней части кузова.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 568,
    alias: 'ticket568',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367318343-6.jpeg',
    image_original: '1367239033-46.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-61',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Каким транспортным средствам разрешена стоянка в зоне действия данного дорожного знака?',
    answer_a:
      'Только транспортным средствам общего пользования.',
    answer_b:
      'Транспортным средствам, управляемым инвалидами, и такси с включенным таксометром.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 679,
    alias: 'ticket679',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-44',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли провозить через железнодорожный переезд сельскохозяйственные, дорожные, строительные и другие машины и механизмы?',
    answer_a: 'Разрешается.',
    answer_b:
      'Разрешается, если они находятся в транспортном положении.',
    answer_c: 'Запрещается.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 298,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_43',
    created_at: null,
    updated_at: '2020-03-18 17:33:48',
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещается, если:',
    answer_a:
      'Не работают в установленном режиме внешние световые приборы.',
    answer_b:
      'Шины автобусов имеют остаточную высоту рисунка протектора 0.8 мм.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 645,
    alias: 'ticket645',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-10',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Приближаясь к стоящему транспортному средству с включенным проблесковым маячком красного цвета водители транспортных средств, движущихся в данном направлении, должны:',
    answer_a:
      'Остановиться и продолжить движение, лишь получив на это разрешение.',
    answer_b:
      'Снизить скорость, чтобы, при необходимости, иметь возможность незамедлительно остановиться.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 722,
    alias: 'ticket722',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367319990-68.jpeg',
    image_original: '1367319990-76.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-86',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Как надо поступить в данной ситуации?',
    answer_a:
      'При отсутствии поезда объехать шлагбаум и продолжить движение.',
    answer_b:
      'Остановиться и дождаться открытия шлагбаума.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 372,
    alias: 'ticket372',
    position: 0,
    correct_answer: 'answer_c',
    image: '1366966555-98.jpeg',
    image_original: '1366966556-14.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-58',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком направлении водителю разрешено движение:',
    answer_a: 'Только направо и налево.',
    answer_b: 'Только прямо.',
    answer_c: 'Прямо и в обратном направлении.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 512,
    alias: 'ticket512',
    position: 0,
    correct_answer: 'answer_d',
    image: '1367236529-38.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-5',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Сколько полос для движения имеет дорога, где транспортные потоки противоположных направлений разделяются двойными сплошными линиями?',
    answer_a: 'Две полосы.',
    answer_b: 'Две или три полосы.',
    answer_c: 'Три полосы.',
    answer_d: 'Четыре или более полос.',
    answer_e: '',
  },
  {
    id: 575,
    alias: 'ticket575',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-2',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При перевозке людей в оборудованном кузове грузового автомобиля движение разрешается со скоростью, не более:',
    answer_a: '60 км/ч.',
    answer_b: '70 км/ч.',
    answer_c: '80 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 398,
    alias: 'ticket398',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367001724-27.jpeg',
    image_original: '1367001724-5.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-4',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком ответе правильно указана очередность проезда перекрестка?',
    answer_a: 'Автобус, легковой автомобиль, велосипед.',
    answer_b: 'Легковой автомобиль, автобус, велосипед.',
    answer_c: 'Велосипед, автобус, легковой автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 156,
    alias: 'ticket156',
    position: 0,
    correct_answer: 'answer_b',
    image: '1370589530-67.jpeg',
    image_original: '1366746263-03.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_14',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком направлении разрешается движение грузового автомобиля?',
    answer_a: 'Только направо.',
    answer_b: 'Направо, налево и в обратном направлении.',
    answer_c: 'Только налево.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 426,
    alias: 'ticket426',
    position: 0,
    correct_answer: 'answer_d',
    image: '1367007361-47.jpeg',
    image_original: '1367007361-64.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-32',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a: 'Легковой автомобиль, автобус, велосипед.',
    answer_b: 'Автобус, велосипед, легковой автомобиль.',
    answer_c: 'Автобус, легковой автомобиль, велосипед.',
    answer_d: 'Велосипед, автобус, легковой автомобиль.',
    answer_e: '',
  },
  {
    id: 571,
    alias: 'ticket571',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-64',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли остановка и стоянка автобусов в населенных пунктах на левой стороне проезжей части дороги с односторонним движением?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: 'Разрешается только для остановки.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 514,
    alias: 'ticket514',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367236599-36.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-7',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какая из этих линий разметки используется для обозначения границ полос движения, на которых осуществляется реверсивное движение?',
    answer_a: 'Линия 1.',
    answer_b: 'Линия 2.',
    answer_c: 'Линия 3.',
    answer_d: 'Линия 2 и 3.',
    answer_e: 'Линия 3 и 4.',
  },
  {
    id: 166,
    alias: 'ticket166',
    position: 0,
    correct_answer: 'answer_b',
    image: '1370591287-67.jpeg',
    image_original: '1366746561-12.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_24',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'В каком направлении разрешается движение?',
    answer_a: 'Только налево.',
    answer_b: 'Прямо, налево и разворот.',
    answer_c: 'Только прямо.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 467,
    alias: 'ticket467',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367233127-77.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-12',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Данный светофор запрещает движение:',
    answer_a: 'Только налево.',
    answer_b: 'Прямо и налево.',
    answer_c: 'Прямо и направо.',
    answer_d: 'Только направо.',
    answer_e: '',
  },
  {
    id: 680,
    alias: 'ticket680',
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-45',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Чем должен руководствоваться водитель при приближении к железнодорожному переезду:',
    answer_a: 'Положением шлагбаума и сигналами светофора.',
    answer_b: 'Требованиями дорожных знаков и разметки.',
    answer_c: 'Указаниями дежурного по переезду.',
    answer_d: 'Всеми перечисленными требованиями.',
    answer_e: '',
  },
  {
    id: 496,
    alias: 'ticket496',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367231059-92.jpeg',
    image_original: '1367231060-08.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-41',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли движение по обозначенной траектории, когда реверсивные светофоры выключены?',
    answer_a: 'Разрешается.',
    answer_b: 'Разрешается, с целью обгона.',
    answer_c: 'Запрещается.',
    answer_d:
      'Разрешается, при отсутствии встречного транспортного средства.',
    answer_e: '',
  },
  {
    id: 319,
    alias: null,
    position: 5,
    correct_answer: 'answer_c',
    image:
      '8d3bba7425e7c98c50f52ca1b52d3735_1583952854.png',
    image_original:
      '8d3bba7425e7c98c50f52ca1b52d3735_original_1583952828.png',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-5',
    created_at: null,
    updated_at: '2020-03-11 22:54:14',
    hint_for_correct_answer: '',
    question:
      'Какой знак запрещает движение транспортных средств с дистанцией между ними, меньшей указанной на знаке?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 762,
    alias: 'ticket762',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-36',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'При обработке не очень опасных ран следует:',
    answer_a:
      'Промыть рану чистой водой с мылом, после чего перевязать.',
    answer_b:
      'Обработать рану каким-нибудь веществом на спиртовой основе (йод, водка и т.д).',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 221,
    alias: 'ticket221',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_17',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» водитель механического транспортного средства обязан при себе иметь:',
    answer_a:
      'Водительское удостоверение на право управления транспортными средствами данной категории и учетные документы транспортного средства.',
    answer_b:
      'Доверенность, при управление транспортным средством принадлежащим другому лицу.',
    answer_c: 'Все перечисленные документы.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 737,
    alias: 'ticket737',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-11',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Оказывая помощь пострадавшему при травме головы, необходимо:',
    answer_a: 'Уложить, приподняв ноги.',
    answer_b:
      'Уложить, приподнять голову и туловище, обеспечив полулежащее положение.',
    answer_c: 'Уложить в горизонтальном положении.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 241,
    alias: 'ticket241',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_37',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» международное водительское удостоверение на право управления транспортными средствами категории «С» может  быть выдано:',
    answer_a: 'Лицам, достигшим 18-летнего возраста.',
    answer_b: 'Лицам, достигшим 20-летнего возраста.',
    answer_c: 'Лицам, достигшим 21-летнего возраста.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 291,
    alias: 'ticket291',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_36',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Нарушена герметичность гидравлического тормозного привода.',
    answer_b:
      'Сзади установлены указатели поворота с огнями белого цвета.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 738,
    alias: 'ticket738',
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-12',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Кому из перечисленных пострадавших в дорожно-транспортном происшествии окажете первую помощь?',
    answer_a: 'Испуганной беременной женщине.',
    answer_b: 'Ребенку, имеющему царапины.',
    answer_c: 'Мужчине с переломом плеча.',
    answer_d:
      'Мужчине, находящемуся в бессознательном состоянии.',
    answer_e: '',
  },
  {
    id: 270,
    alias: 'ticket270',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_15',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Установлены предметы, влекущие опасность травмирования участников дорожного движения.',
    answer_b: 'Не работает звуковой сигнал.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 318,
    alias: 'ticket318',
    position: 6,
    correct_answer: 'answer_b',
    image: '1366978200-65.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-4',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Этот дорожный знак обозначает:',
    answer_a:
      'Участок дороги, на котором имеется тротуар или пешеходная дорожка.',
    answer_b:
      'Участок дороги, на котором имеется пешеходный переход.',
    answer_c:
      'Участок дороги, не имеющий тротуара или пешеходной дорожки.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 690,
    alias: 'ticket690',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-55',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Если на грунтовой дороге непосредственно перед перекрестком имеется участок с покрытием, то делает ли это ее равной по значению с пересекаемой?',
    answer_a: 'Нет.',
    answer_b: 'Да.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 173,
    alias: 'ticket173',
    position: 0,
    correct_answer: 'answer_b',
    image: '1370591908-06.jpeg',
    image_original: '1366747062-06.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_31',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Преимущество в движении имеет:',
    answer_a:
      'Синий автомобиль, т. к. красный изменяет направление движения влево.',
    answer_b:
      'Красный автомобиль, т. к. при одновременном перестроении он находится справа.',
    answer_c:
      'Синий автомобиль, т. к. при одновременном перестроении он находится слева.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 367,
    alias: 'ticket367',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366964387-08.jpeg',
    image_original: '1366964387-24.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-53',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что показывают данные дорожные знаки?',
    answer_a:
      'Главная дорога продолжается от перекрестка налево.',
    answer_b:
      'Главная дорога продолжается прямо через перекресток и налево.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 447,
    alias: 'ticket447',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367009255-88.jpeg',
    image_original: '1367009256-04.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-53',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком порядке проедут перекресток транспортные средства, если светофоры не работают?',
    answer_a:
      'Троллейбус и мотоцикл, автобус и легковой автомобиль.',
    answer_b:
      'Мотоцикл, автобус и легковой автомобиль, троллейбус.',
    answer_c:
      'Автобус и легковой автомобиль, троллейбус и мотоцикл.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 465,
    alias: 'ticket465',
    position: 2,
    correct_answer: 'answer_b',
    image: '1367225477-39.jpeg',
    image_original: '1367225477-54.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-10',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Движение разрешено:',
    answer_a: 'Прямо.',
    answer_b: 'Направо в первый проезд.',
    answer_c: 'Направо во второй проезд.',
    answer_d: 'Направо в первый и второй проезды.',
    answer_e: '',
  },
  {
    id: 206,
    alias: 'ticket206',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_2',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» водительское удостоверение на право управления транспортными средствами категории «A» может быть выдано лицам, достигшим:',
    answer_a: '16 - летнего возраста.',
    answer_b: '17 - летнего возраста.',
    answer_c: '18 - летнего возраста.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 330,
    alias: 'ticket330',
    position: 4,
    correct_answer: 'answer_b',
    image: '1367000119-5.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-16',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Этот знак называется?',
    answer_a:
      'Предварительный указатель объезда препятствий.',
    answer_b:
      'Предварительный указатель перестроения на другую проезжую часть.',
    answer_c:
      'Предварительный указатель выезда на полосу встречного движения.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 553,
    alias: 'ticket553',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367317995-01.jpeg',
    image_original: '1367237907-23.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-46',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли транспортному средству остановиться в указанном месте для высадки пассажира?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: 'Разрешается, но поднявшись на тротуар.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 605,
    alias: 'ticket605',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-32',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли перевозка людей на грузовом прицепе:',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается.',
    answer_c:
      'Разрешается только лицам, сопровождающим груз.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 275,
    alias: 'ticket275',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_20',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'В конструкцию транспортного средства внесены изменения (переоборудование) без разрешения органа, осуществляющего их учет.',
    answer_b:
      'Спереди установлены указатели поворота с огнями желтого цвета.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 529,
    alias: 'ticket529',
    position: 4,
    correct_answer: 'answer_a',
    image: '1367237204-13.png',
    image_original: '1367237204-79.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-22',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На каком рисунке водитель правильно остановил свой автомобиль для высадки пассажиров?',
    answer_a: 'На левом рисунке.',
    answer_b: 'На обоих рисунках.',
    answer_c: 'На правом рисунке.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 368,
    alias: 'ticket368',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366964419-27.jpeg',
    image_original: '1366964419-41.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-54',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что показывают данные дорожные знаки?',
    answer_a:
      'В зоне действия знака водители должны передвигаться с большей скоростью, чем указано на знаке.',
    answer_b:
      'В зоне действия знака водителям рекомендуется передвигаться со скоростью указанной знаком.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 410,
    alias: 'ticket410',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367006727-94.jpeg',
    image_original: '1367006728-09.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-16',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какой автомобиль последним проедет перекресток:',
    answer_a: 'Синий.',
    answer_b: 'Красный.',
    answer_c: 'Зеленый.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 411,
    alias: 'ticket411',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367006755-34.jpeg',
    image_original: '1367006755-51.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-17',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Первым проедет перекресток:',
    answer_a: 'Зеленый автомобиль.',
    answer_b: 'Красный автомобиль.',
    answer_c: 'Синий автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 251,
    alias: 'ticket251',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_47',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» местом остановки транспортных средств общего пользования называется:',
    answer_a:
      'Место, предназначенное для посадки-высадки пассажиров на определенном отрезке маршрута транспортных средств общего пользования и оборудованное соответствующими дорожными знаками.',
    answer_b:
      'Место, предназначенное для посадки-высадки пассажиров на определенном отрезке маршрута транспортных средств общего пользования.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 459,
    alias: 'ticket459',
    position: 8,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-4',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Если правая рука регулировщика вытянута вперед, то движение безрельсовым транспортным средствам разрешено:',
    answer_a:
      'Со стороны левого бока - налево и в обратном направлении.',
    answer_b: 'Со стороны правого бока - только направо.',
    answer_c:
      'Со стороны левого бока - во всех направлениях.',
    answer_d: 'Со спины - только направо.',
    answer_e: '',
  },
  {
    id: 491,
    alias: 'ticket491',
    position: 0,
    correct_answer: 'answer_d',
    image: '1367230906-89.jpeg',
    image_original: '1367230907-05.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-36',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Красный автомобиль проедет перекресток:',
    answer_a: 'Первым.',
    answer_b: 'Вторым.',
    answer_c: 'Третьим.',
    answer_d: 'Последним.',
    answer_e: '',
  },
  {
    id: 558,
    alias: 'ticket558',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367318121-65.jpeg',
    image_original: '1367238719-7.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-51',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком из перечисленных случаев водитель автобуса может занять среднюю полосу на трехполосной дороге двустороннего движения, которая используется для движения в обоих направлениях?',
    answer_a: 'С целью обгона или объезда.',
    answer_b: 'С целью поворота налево или разворота.',
    answer_c: 'В обоих перечисленных случаях.',
    answer_d: 'Нет правильных ответов.',
    answer_e: '',
  },
  {
    id: 250,
    alias: 'ticket250',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_46',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» лицам, имеющим водительское удостоверение на право управления транспортными средствами категории «B» , «C» , «D» и подкатегорий «C1» , «D1» разрешается также управлять ими с прицепами, если разрешенная макимальная масса прицепа не превышает:',
    answer_a: '950 килограммов.',
    answer_b: '850 килограммов.',
    answer_c: '750 килограммов.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 669,
    alias: 'ticket669',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-34',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Что должен предпринять водитель в первую очередь при ослеплении светом фар встречного автомобиля?',
    answer_a:
      'Дальний свет фар (если включен) переключить на ближний.',
    answer_b: 'Включить аварийную световую сигнализацию.',
    answer_c:
      'Подать звуковой сигнал: один длинный и три коротких.',
    answer_d:
      'Подать звуковой сигнал: один короткий и три длинных.',
    answer_e: '',
  },
  {
    id: 657,
    alias: 'ticket657',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-22',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Обгон перед железнодорожным переездом запрещен ближе, чем за:',
    answer_a: '50 м.',
    answer_b: '100 м.',
    answer_c: '150 м.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 536,
    alias: 'ticket536',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367317201-12.jpeg',
    image_original: '1367237390-95.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-29',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли в данной ситуации остановиться для высадки пассажира?',
    answer_a:
      'Разрешается, если это не создает помех транспортным средствам общего пользования.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 415,
    alias: 'ticket415',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367006932-11.jpeg',
    image_original: '1367006932-32.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-21',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Третьим проедет перекресток:',
    answer_a: 'Синий автомобиль.',
    answer_b: 'Желтый автомобиль.',
    answer_c: 'Зеленый автомобиль.',
    answer_d: 'Красный автомобиль.',
    answer_e: '',
  },
  {
    id: 506,
    alias: 'ticket506',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367231458-78.jpeg',
    image_original: '1367231458-96.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-51',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При повороте направо водитель должен уступить дорогу:',
    answer_a: 'Только велосипедисту.',
    answer_b: 'Только пешеходам.',
    answer_c: 'Пешеходам и велосипедисту.',
    answer_d: 'Может продолжать движение без остановки.',
    answer_e: '',
  },
  {
    id: 422,
    alias: 'ticket422',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367007186-97.jpeg',
    image_original: '1367007187-13.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-28',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Кто из водителей имеет преимущество на первоочередное движение?',
    answer_a: 'Водитель мотоцикла.',
    answer_b: 'Водитель автомобиля.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 505,
    alias: 'ticket505',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367231421-77.jpeg',
    image_original: '1367231422-01.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-50',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком направлении водитель может продолжить движение?',
    answer_a: 'Направо, в первый проезд.',
    answer_b: 'Направо, в первый и второй проезд.',
    answer_c: 'Налево, в первый проезд.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 594,
    alias: 'ticket594',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-21',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'В каких случаях запрещена буксировка?',
    answer_a: 'В гололедицу на жесткой сцепке.',
    answer_b: 'В гололедицу на гибкой сцепке.',
    answer_c: 'Мотоциклами с боковым прицепом.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 591,
    alias: null,
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-18',
    created_at: null,
    updated_at: '2020-03-20 10:44:47',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли перевозить людей при буксировке на гибкой или жесткой сцепке в буксируемом механическом транспортном средстве?',
    answer_a: 'Разрешается в автобусе и троллейбусе.',
    answer_b: 'Разрешается только в легковом автомобиле.',
    answer_c:
      'Разрешается в кузове грузового автомобиля и в легковом автомобиле.',
    answer_d:
      'Разрешается в кабине грузового автомобиля и в легковом автомобиле.',
    answer_e: 'Запрещается.',
  },
  {
    id: 715,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image: '1367319530-33.jpeg',
    image_original: '1367319530-4.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-80',
    created_at: null,
    updated_at: '2020-03-20 17:28:58',
    hint_for_correct_answer: '',
    question:
      'Обязан ли водитель включить указатель поворота в данной ситуации?',
    answer_a: 'Обязан.',
    answer_b: 'Не обязан.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 749,
    alias: 'ticket749',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-23',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Из соседнего автогаража доносится звук работающего двигателя . Открыв дверь, вы видите лежащего на полу соседа. Что следует предпринять в первую очередь?',
    answer_a:
      'Распахнуть двери автогаража, выключить двигатель и, если возможно, вынести пострадавшего с места происшествия.',
    answer_b:
      'С целью обнаружения травм тщательно обследовать пострадавшего.',
    answer_c:
      'Уложить пострадавшего на бок, в удобном положении.',
    answer_d:
      'Помочь пострадавшему принять положение полусидя.',
    answer_e: '',
  },
  {
    id: 676,
    alias: 'ticket676',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-41',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли провозить через железнодорожный переезд сельскохозяйственные, дорожные, строительные и другие машины и механизмы?',
    answer_a:
      'Разрешается, если переезд не оборудован шлагбаумом.',
    answer_b:
      'Разрешается, если они находятся в нетранспортном положении.',
    answer_c:
      'Разрешается, если они находятся в транспортном положении.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 613,
    alias: 'ticket613',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-40',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При перевозке организованной группы детей в салоне автобуса должен находиться минимум:',
    answer_a: 'Один совершеннолетний сопровождающий.',
    answer_b: 'Два совершеннолетних сопровождающих.',
    answer_c: 'Три совершеннолетних сопровождающих.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 590,
    alias: 'ticket590',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367316658-89.jpeg',
    image_original: '1367261499-83.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-17',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой максимальной скоростью может осуществляться буксировка в данных условиях?',
    answer_a: '30 км/ч.',
    answer_b: '50 км/ч.',
    answer_c: '70 км/ч.',
    answer_d: '80 км/ч.',
    answer_e: '',
  },
  {
    id: 483,
    alias: 'ticket483',
    position: 4,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-28',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Что означает круглый зеленый мигающий сигнал светофора?',
    answer_a:
      'Информирует, что въезд на перекресток запрещен.',
    answer_b:
      'Разрешает движение и информирует, что время его действия истекает и вскоре будет включен запрещающий сигнал.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 573,
    alias: 'ticket573',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-66',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли стоянка автобусов в жилых зонах и дворовых территориях?',
    answer_a: 'Запрещается.',
    answer_b:
      'Разрешается, только в местах предназначенных для этого.',
    answer_c: 'Разрешается.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 366,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image:
      '5ef698cd9fe650923ea331c15af3b160_1583955820.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-52',
    created_at: null,
    updated_at: '2020-03-11 23:43:40',
    hint_for_correct_answer: '',
    question:
      'Какой из знаков устанавливается спереди и сзади транспортного средства, перевозящего группу детей?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: '',
  },
  {
    id: 618,
    alias: 'ticket618',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-45',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой максимальной скоростью разрешается движение автобусов в зоне действия знаков » Жилая зона» и » Конец жилой зоны» ?',
    answer_a: '20 км/ч.',
    answer_b: '30 км/ч.',
    answer_c: '40 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 672,
    alias: 'ticket672',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-37',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Задние противотуманные фонари могут применяться:',
    answer_a:
      'При движении в колонне в темное время суток.',
    answer_b: 'При движении в тоннелях.',
    answer_c: 'Только в условиях недостаточной видимости.',
    answer_d: 'При разгрузке груза в темное время суток.',
    answer_e: 'Во всех перечисленных случаях.',
  },
  {
    id: 223,
    alias: 'ticket223',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_19',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Разрешенная максимальная масса» транспортного средства, это:',
    answer_a:
      'Масса укомплектованного и заправленного транспортного средства.',
    answer_b:
      'Масса укомплектованного и заправленного транспортного средства с водителем, пассажирами и грузом.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 541,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '1367317241-7.jpeg',
    image_original: '1367237492-85.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-34',
    created_at: null,
    updated_at: '2020-03-19 23:04:48',
    hint_for_correct_answer: '',
    question: 'Разрешена ли остановка в этом месте?',
    answer_a: 'Разрешена.',
    answer_b: 'Запрещена.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 494,
    alias: 'ticket494',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367231002-64.jpeg',
    image_original: '1367231002-8.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-39',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Движение разрешено:',
    answer_a:
      'Сине-желтому автомобилю-прямо, красному-направо.',
    answer_b:
      'Красному автомобилю-прямо и направо, сине-желтому-прямо.',
    answer_c: 'Обоим автомобилям только прямо.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 154,
    alias: 'ticket154',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_12',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разворот запрещается, если видимость дороги хотя бы в одном направлении менее:',
    answer_a: '100 м.',
    answer_b: '150 м.',
    answer_c: '300 м.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 648,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      '443cb001c138b2561a0d90720d6ce111_1585128685.jpeg',
    image_original: '1367318689-74.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-13',
    created_at: null,
    updated_at: '2020-03-25 13:31:25',
    hint_for_correct_answer: '',
    question: 'Синий автомобиль проедет перекресток:',
    answer_a: 'Первым одновременно с красным.',
    answer_b: 'Вторым одновременно с красным.',
    answer_c: 'Третьим одновременно с красным.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 659,
    alias: 'ticket659',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367318829-84.jpeg',
    image_original: '1367318829-9.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-24',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешен ли водителю легкового автомобиля обгон в данной ситуации?',
    answer_a: 'Разрешен.',
    answer_b:
      'Разрешен, если скорость мотоциклиста менее 30 км/ч.',
    answer_c: 'Запрещен.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 402,
    alias: 'ticket402',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367005641-48.jpeg',
    image_original: '1367005641-65.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-8',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Вторым проедет перекресток:',
    answer_a: 'Синий автомобиль.',
    answer_b: 'Зеленый автомобиль.',
    answer_c: 'Красный автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 649,
    alias: 'ticket649',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-14',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При приближении транспортного средства с включенными проблесковыми маячками синего и красного цветов и специальным звуковым сигналом водители обязаны:',
    answer_a:
      'Уступить дорогу для обеспечения беспрепятственного проезда указанного транспортного средства.',
    answer_b:
      'Снизить скорость и уступить дорогу, для обеспечения беспрепятственного проезда указанного транспортного средства, а также сопровождаемых им транспортных средств.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 750,
    alias: 'ticket750',
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-24',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При обнаружении пострадавшего в бессознательном состоянии в первую очередь необходимо:',
    answer_a: 'Напоить его холодной водой.',
    answer_b:
      'Уложить пострадавшего на бок, в удобном положении.',
    answer_c: 'Обеспечить нормальную температуру тела.',
    answer_d:
      'Освободить дыхательные пути и проверить дыхание.',
    answer_e: '',
  },
  {
    id: 609,
    alias: 'ticket609',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-36',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли перевозить людей в буксируемом автобусе?',
    answer_a: 'Разрешается.',
    answer_b: 'Разрешается до 8-и пассажиров.',
    answer_c: 'Запрещается.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 299,
    alias: 'ticket299',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_44',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация автобусов запрещается, если:',
    answer_a: 'Двигатель работает с перебоями.',
    answer_b:
      'Шины имеют внешние повреждения, обнажающие корд.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 653,
    alias: null,
    position: 0,
    correct_answer: 'answer_d',
    image:
      'eaae339c4d89fc102edd9dbdb6a28915_1585129417.jpeg',
    image_original: '1367318807-31.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-18',
    created_at: null,
    updated_at: '2020-03-25 13:43:37',
    hint_for_correct_answer: '',
    question: 'Синий автомобиль проедет перекресток:',
    answer_a: 'Первым.',
    answer_b: 'Вторым.',
    answer_c: 'Третьим.',
    answer_d: 'Последним.',
    answer_e: '',
  },
  {
    id: 486,
    alias: 'ticket486',
    position: 1,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-31',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Если правая рука регулировщика вытянута вперед, то движение безрельсовым транспортным средствам со стороны левого бока разрешено:',
    answer_a: 'Прямо и налево.',
    answer_b: 'Во всех направлениях.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 340,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      '40008b9a5380fcacce3976bf7c08af5b_1583954593.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-26',
    created_at: null,
    updated_at: '2020-03-11 23:23:13',
    hint_for_correct_answer: '',
    question:
      'Какой знак обозначает «Гостиницу» или «Мотель» ?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 233,
    alias: 'ticket233',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_29',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» лицо, обучающее вождению транспортных средств:',
    answer_a: 'Приравнивается к водителю.',
    answer_b: 'Не приравнивается к водителю.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 530,
    alias: 'ticket530',
    position: 3,
    correct_answer: 'answer_d',
    image: '1367317137-79.jpeg',
    image_original: '1367237238-32.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-23',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Каким транспортным средствам разрешена стоянка?',
    answer_a: 'Только мотоциклу.',
    answer_b: 'Только грузовому автомобилю.',
    answer_c: 'Только легковому автомобилю.',
    answer_d: 'Легковому автомобилю и мотоциклу.',
    answer_e: 'Всем транспортным средствам.',
  },
  {
    id: 475,
    alias: 'ticket475',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367233661-83.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-20',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Данный светофор применяется для регулирования движения:',
    answer_a: 'По всей ширине проезжей части.',
    answer_b:
      'По полосам проезжей части, направление движения по которым может изменяться на противоположное.',
    answer_c:
      'Только по полосам предназначенным для движения транспортных средств общего пользования.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 151,
    alias: 'ticket151',
    position: 2,
    correct_answer: 'answer_e',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_9',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Разворот запрещается:',
    answer_a: 'На пешеходных переходах.',
    answer_b: 'В тоннелях.',
    answer_c:
      'На мостах, путепроводах, эстакадах и под ними.',
    answer_d: 'На железнодорожных переездах.',
    answer_e: 'Во всех перечисленных случаях.',
  },
  {
    id: 371,
    alias: 'ticket371',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366966517-41.jpeg',
    image_original: '1366966517-59.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-57',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что показывают данные дорожные знаки?',
    answer_a:
      'Через 150-300м после знака начинается сужение дороги с правой стороны протяженностью 100м.',
    answer_b:
      'Через 100м после знака начинается сужение дороги с правой стороны.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 306,
    alias: 'ticket306',
    position: 8,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_51',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация автобусов запрещается, если:',
    answer_a: 'Не работают аварийные открыватели дверей.',
    answer_b:
      'Цифры и буквы регистрационных знаков не повторяются на задней части кузова.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 761,
    alias: 'ticket761',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-35',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Если электрический провод лежит на автомобиле, необходимо:',
    answer_a:
      'Помочь находящимся в нём людям срочно покинуть автомобиль.',
    answer_b:
      'Попросить находящихся в нем людей не выходить из автомобиля, пока не будет выключен электрический ток.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 409,
    alias: 'ticket409',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367006695-72.jpeg',
    image_original: '1367006695-88.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-15',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Последним проедет перекресток:',
    answer_a: 'Зеленый автомобиль.',
    answer_b: 'Синий автомобиль.',
    answer_c: 'Красный автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 332,
    alias: 'ticket332',
    position: 2,
    correct_answer: 'answer_a',
    image: '1366982316-41.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-18',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Можно ли водителю автобуса обгонять в зоне действия этого знака?',
    answer_a:
      'Можно во всех случаях с соблюдением правил обгона.',
    answer_b: 'Нельзя.',
    answer_c:
      'Можно при условии, если обгоняемое транспортное средство движется со скоростью менее 30 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 351,
    alias: 'ticket351',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366962719-68.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-37',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'При наличии этого дорожного знака: ',
    answer_a:
      'Запрещается обгон всеми видами транспортных средств, за исключением тихоходных транспортных средств, гужевых повозок, мотоциклов без бокового прицепа, мопедов и велосипедов.',
    answer_b:
      'Разрешается обгон грузовыми автомобилями с разрешенной максимальной массой не более 3,5 т.',
    answer_c:
      'Обгон разрешен, если скорость обгоняемого транспортного средства не превышает 30 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 183,
    alias: 'ticket183',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366747597-74.jpeg',
    image_original: '1366747575-59.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_41',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель белого легкового автомобиля в данной ситуации:',
    answer_a:
      'Должен уступить дорогу автобусу, который начинает движение с обозначенного места остановки.',
    answer_b:
      'Имеет преимущество в движении, поскольку автобус перестраивается на вторую полосу движения.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 333,
    alias: null,
    position: 1,
    correct_answer: 'answer_c',
    image:
      '310dcbbf4cce62f762a2aaa148d556bd_1583953685.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-19',
    created_at: null,
    updated_at: '2020-03-11 23:08:05',
    hint_for_correct_answer: '',
    question:
      'Какой из знаков разрешает движение только с указанной (км/ч) или большей скоростью?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 264,
    alias: 'ticket264',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_9',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Отсутствуют предусмотренные конструкцией подголовники сидений.',
    answer_b:
      'На одну ось установлены новые и восстановленные шины.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 152,
    alias: 'ticket152',
    position: 1,
    correct_answer: 'answer_b',
    image: '1370587975-29.jpeg',
    image_original: '1366746146-95.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_10',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли водителю желтого автобуса выезжать на перекресток?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c:
      'Разрешается, если автобус движется по установленному маршруту.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 623,
    alias: 'ticket623',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367316709-36.jpeg',
    image_original: '1367261596-52.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-50',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой максимальной скоростью может двигаться водитель буксирующего автобуса в данной ситуации?',
    answer_a: '50 км/ч.',
    answer_b: '60 км/ч.',
    answer_c: '90 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 520,
    alias: 'ticket520',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367236836-94.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-13',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли заезжать на направляющий островок, размеченный широкими белыми линиями?',
    answer_a: 'Разрешается только для остановки.',
    answer_b: 'Разрешается при движении задним ходом.',
    answer_c: 'Запрещается.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 654,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-19',
    created_at: null,
    updated_at: '2020-03-20 13:24:48',
    hint_for_correct_answer: '',
    question:
      'Дает ли преимущество в движении включенный на транспортном средстве проблесковый маячок желтого(оранжевого) цвета?',
    answer_a: 'Дает.',
    answer_b: 'Не дает.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 567,
    alias: 'ticket567',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367318314-71.jpeg',
    image_original: '1367239005-17.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-60',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Данная дорожная разметка разрешает движение:',
    answer_a: 'Только налево.',
    answer_b: 'Налево и в обратном направлении.',
    answer_c: 'Только в обратном направлении.',
    answer_d: 'Прямо, налево и в обратном направлении.',
    answer_e: '',
  },
  {
    id: 702,
    alias: 'ticket702',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-67',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При движении по установленному маршруту в темное время суток на неосвещенных участках дорог на автобусе должен быть включен:',
    answer_a: 'Только ближний свет фар.',
    answer_b: 'Только дальний свет фар.',
    answer_c: 'Ближний или дальний свет фар.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 554,
    alias: 'ticket554',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367318020-57.jpeg',
    image_original: '1367238467-99.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-47',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли продолжить движение по направлению, указанному стрелкой?',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается во всех случаях.',
    answer_c:
      'Разрешается, для остановки с целью высадки пассажиров.',
    answer_d:
      'Разрешается, с целью обгона грузового автомобиля.',
    answer_e: '',
  },
  {
    id: 348,
    alias: null,
    position: 0,
    correct_answer: 'answer_d',
    image:
      '01386bd6d8e091c2ab4c7c7de644d37b_1583954816.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-34',
    created_at: null,
    updated_at: '2020-03-11 23:26:56',
    hint_for_correct_answer: '',
    question:
      'Какой знак обязывает уступить дорогу транспортным средствам, движущимся по пересекаемой дороге?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 362,
    alias: 'ticket362',
    position: 0,
    correct_answer: 'answer_c',
    image: '1366984819-73.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-48',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эти знаки обозначают:',
    answer_a:
      'Место стоянки через 30 м для автомобилей с опознавательным знаком «Инвалид».',
    answer_b:
      'Место стоянки в зоне 30 м для транспортных средств, кроме мотоколясок.',
    answer_c:
      'Место стоянки в зоне 30 м для мотоколясок и автомобилей с опознавательным знаком «Инвалид».',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 202,
    alias: 'ticket202',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366749074-59.jpeg',
    image_original: '1366749053-58.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_60',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Обязаны ли Вы уступить дорогу легковому автомобилю, если намерены совершить правый поворот на перекрестке?',
    answer_a: 'Обязаны.',
    answer_b: 'Не обязаны.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 700,
    alias: 'ticket700',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-65',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При приближении транспортного средства с включенным проблесковым маячком синего цвета и специальным звуковым сигналом водители транспортных средств общего пользования обязаны:',
    answer_a:
      'Продолжить движение, поскольку двигаются по установленному маршруту.',
    answer_b:
      'Уступить дорогу для обеспечения беспрепятственного проезда указанного транспортного средства.',
    answer_c:
      'Снизить скорость и уступить дорогу для обеспечения беспрепятственного проезда указанного транспортного средства.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 267,
    alias: 'ticket267',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_12',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Нарушена герметичность системы вентиляции картера двигателя.',
    answer_b:
      'На одну ось установлены морозостойкие и неморозостойкие шины.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 339,
    alias: 'ticket339',
    position: 0,
    correct_answer: 'answer_c',
    image: '1381143860-92.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-25',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Этот дорожный знак обозначает:',
    answer_a:
      'Дорога с односторонним движением, на которой разрешено движение только грузовых автомобилей.',
    answer_b:
      'Полосу, предназначенную для движения только грузовых автомобилей.',
    answer_c:
      'Рекомендуемое направление движения для грузовых автомобилей.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 361,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image:
      '52720e003547c70561bf5e03b95aa99f_1583955593.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-47',
    created_at: null,
    updated_at: '2020-03-11 23:39:53',
    hint_for_correct_answer: '',
    question:
      'Какой знак обязывает уступить дорогу транспортным средствам, движущимся по пересекаемой дороге?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 377,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      'd34ab169b70c9dcd35e62896010cd9ff_1583956071.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-63',
    created_at: null,
    updated_at: '2020-03-11 23:47:51',
    hint_for_correct_answer: '',
    question:
      'Действие каких знаков не распространяется на транспортные средства общего пользования?',
    answer_a: 'Не один из знаков.',
    answer_b: 'Только первого.',
    answer_c: 'Только четвертого.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 148,
    alias: 'ticket148',
    position: 5,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_6',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На дорогах с двусторонним движением, имеющих три полосы, обозначенные разметкой, из которых средняя пользуется для движения в обоих направлениях (за исключением дорог с реверсивным регулированием движения) выезжать на крайнюю левую полосу:',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c:
      'Разрешается, только для обгона, объезда, поворота налево или разворота.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 745,
    alias: 'ticket745',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-19',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Пульс у взрослого человека в состоянии покоя составляет:',
    answer_a: '40-60 ударов в минуту.',
    answer_b: '60-80 ударов в минуту.',
    answer_c: '80-100 ударов в минуту.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 504,
    alias: 'ticket504',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367231389-56.jpeg',
    image_original: '1367231389-72.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-49',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Имеет ли право водитель автобуса двигаться прямо в данной ситуации?',
    answer_a: 'Имеет право.',
    answer_b: 'Не имеет право.',
    answer_c:
      'Имеет право, если он движется по обозначенному маршруту.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 228,
    alias: 'ticket228',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_24',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» считается ли перекрестком выезд на дорогу с прилегающей территории?',
    answer_a: 'Не считается.',
    answer_b: 'Считается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 380,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '1366971795-8.jpeg',
    image_original: '1366971795-96.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-66',
    created_at: null,
    updated_at: '2020-03-18 22:24:35',
    hint_for_correct_answer: '',
    question: 'Что показывают данные дорожные знаки?',
    answer_a:
      'Водители должны передвигаться со скоростью 40км/ч при гололедице.',
    answer_b:
      'Водители должны передвигаться со скоростью не более 40км/ч при мокром покрытии дороги.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 352,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image:
      '371bce7dc83817b7893bcdeed13799b5_1583954956.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-38',
    created_at: null,
    updated_at: '2020-03-11 23:29:16',
    hint_for_correct_answer: '',
    question:
      'Какой знак называется «Пересечение с велосипедной дорожкой» ?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 191,
    alias: 'ticket191',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366748131-4.jpeg',
    image_original: '1366748151-5.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_49',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Имеете ли Вы право совершить маневр по обозначенной траектории в данной ситуации?',
    answer_a: 'Да.',
    answer_b: 'Нет.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 547,
    alias: 'ticket547',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-40',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На каком расстоянии от железнодорожного переезда запрещается стоянка транспортных средств?',
    answer_a: '15 м.',
    answer_b: '50 м.',
    answer_c: '100 м.',
    answer_d: '150 м.',
    answer_e: '',
  },
  {
    id: 635,
    alias: 'ticket635',
    position: 0,
    correct_answer: 'answer_e',
    image: '1367316889-9.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-62',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой максимальной скоростью допускается движение легковых автомобилей на участках дорог, обозначенных таким дорожным знаком?',
    answer_a: '70 км/ч.',
    answer_b: '80 км/ч.',
    answer_c: '90 км/ч.',
    answer_d: '100 км/ч.',
    answer_e: '110 км/ч.',
  },
  {
    id: 294,
    alias: 'ticket294',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_39',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Резьбовые соединения рулевого управления не затянуты или не зафиксированы установленным способом.',
    answer_b: 'В автобусе отсутствуют огнетушители.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 342,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image:
      '58238e9ae2dd305d79c2ebc8c1883422_1583954655.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-28',
    created_at: null,
    updated_at: '2020-03-11 23:24:15',
    hint_for_correct_answer: '',
    question:
      'Какой знак обозначает конец зоны ограничения максимальной скорости 50 км/ч?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 740,
    alias: 'ticket740',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-14',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При выпадении внутренних органов вследствие травмы брюшной полости необходимо:',
    answer_a:
      'Промыть и попытаться осторожно вложить их обратно.',
    answer_b:
      'Накрыть выпавшие органы чистой влажной тканью и полиэтиленовой пленкой.',
    answer_c:
      'Перерезать выпавшие органы и перевязать рану.',
    answer_d:
      'Не дотрагиваться, и в этом состоянии перевезти пострадавшего в больницу.',
    answer_e: '',
  },
  {
    id: 544,
    alias: 'ticket544',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-37',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Где разрешается длительная стоянка транспортных средств вне населенных пунктов для отдыха, ночлега и т.д.?',
    answer_a: 'На обочине дороги.',
    answer_b:
      'На площадках для стоянки или за пределами дороги.',
    answer_c:
      'На правой стороне проезжей части дороги, но так, чтобы не препятствовать движению других транспортных средств.',
    answer_d:
      'На левой стороне дороги, но с соблюдением мер по безопасности движения.',
    answer_e: '',
  },
  {
    id: 458,
    alias: 'ticket458',
    position: 9,
    correct_answer: 'answer_b',
    image: '1367225245-05.jpeg',
    image_original: '1367225245-21.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-3',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства должен уступить дорогу?',
    answer_a: 'Водитель автомобиля.',
    answer_b: 'Водитель трамвая.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 320,
    alias: null,
    position: 4,
    correct_answer: 'answer_c',
    image:
      '320722549d1751cf3f247855f937b982_1583953036.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-6',
    created_at: null,
    updated_at: '2020-03-11 22:57:17',
    hint_for_correct_answer: '',
    question:
      'На каком расстоянии до начала опасного участка устанавливаются эти знаки в населенных пунктах?',
    answer_a: '15 - 25 м.',
    answer_b: '25 - 50 м.',
    answer_c: '50 - 100 м.',
    answer_d: '100 -150 м.',
    answer_e: '150 - 300 м.',
  },
  {
    id: 602,
    alias: 'ticket602',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-29',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'C какой максимальной скоростью разрешено движение при буксировке на гибкой сцепке?',
    answer_a: '70 км/ч.',
    answer_b: '60 км/ч.',
    answer_c: '50 км/ч.',
    answer_d: '40 км/ч.',
    answer_e: '30 км/ч.',
  },
  {
    id: 374,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      'ad972f10e0800b49d76fed33a21f6698_1583956005.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-60',
    created_at: null,
    updated_at: '2020-03-11 23:46:45',
    hint_for_correct_answer: '',
    question: 'Какой из знаков запрещает разворот?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 689,
    alias: 'ticket689',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-54',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Перекресток считается регулируемым, если очередность движения на нем определяется:',
    answer_a: 'Только сигналами светофора.',
    answer_b: 'Только сигналами регулировщика.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 284,
    alias: 'ticket284',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_29',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Не работают приборы внутреннего освещения салона легкового автомобиля.',
    answer_b:
      'Отсутствуют предусмотренные конструкцией подголовники сидений.',
    answer_c: 'Во всех перечисленных случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 160,
    alias: 'ticket160',
    position: 0,
    correct_answer: 'answer_b',
    image: '1370589897-68.jpeg',
    image_original: '1366746325-47.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_18',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'В каком направлении запрещено движение?',
    answer_a: 'Только налево.',
    answer_b: 'Только направо.',
    answer_c: 'Прямо и налево.',
    answer_d: 'Во всех направлениях.',
    answer_e: '',
  },
  {
    id: 597,
    alias: 'ticket597',
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-24',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При буксировке какое расстояние между транспортными средствами должна обеспечить гибкая сцепка?',
    answer_a: '1 - 3 м.',
    answer_b: '2 - 4 м.',
    answer_c: '3 - 6 м.',
    answer_d: '4 - 6 м.',
    answer_e: '4 - 8 м.',
  },
  {
    id: 756,
    alias: 'ticket756',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-30',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В случае приступа бронхиальной астмы у пострадавшего следует:',
    answer_a: 'Помочь ему принять положение полусидя.',
    answer_b: 'Уложить и приподнять ноги.',
    answer_c: 'Уложить и согнуть ноги в коленных суставах.',
    answer_d: 'Уложить и приподнять голову.',
    answer_e: '',
  },
  {
    id: 673,
    alias: 'ticket673',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-38',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На каком расстоянии до встречного транспортного средства дальний свет фар должен быть переключен на ближний?',
    answer_a: 'За 100 м.',
    answer_b: 'За 150 м.',
    answer_c: 'За 300 м.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 170,
    alias: 'ticket170',
    position: 0,
    correct_answer: 'answer_a',
    image: '1370591617-29.jpeg',
    image_original: '1366746804-75.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_28',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Должен ли водитель автобуса, движущегося по установленному маршруту, уступать дорогу в данной ситуации?',
    answer_a: 'Должен.',
    answer_b: 'Не должен.',
    answer_c: 'Не должен, так как он движется прямо.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 462,
    alias: 'ticket462',
    position: 5,
    correct_answer: 'answer_b',
    image: '1367225359-27.jpeg',
    image_original: '1367225359-43.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-7',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства должен уступить дорогу?',
    answer_a: 'Водитель мотоцикла.',
    answer_b: 'Водитель автомобиля.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 343,
    alias: 'ticket343',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366983832-37.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-29',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'О чем предупреждает знак и табличка под ним:',
    answer_a:
      'Остановка на обочине запрещена в связи с работами.',
    answer_b:
      'Съезд на обочину опасен в связи с проведением на ней ремонтных работ.',
    answer_c:
      'Стоянка на обочине запрещена в связи с ремонтными работами на дороге.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 511,
    alias: 'ticket511',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367236514-02.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-4',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что обозначает данная разметка?',
    answer_a:
      'Пешеходный переход, где движение регулируется светофором.',
    answer_b:
      'Место, где велосипедная дорожка пересекает проезжую часть.',
    answer_c:
      'Место, где пешеходная дорожка пересекает проезжую часть.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 538,
    alias: 'ticket538',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-31',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Сигналом остановки поезда служит?',
    answer_a:
      'Круговое движение руки (днем с лоскутом яркой материи или каким-либо хорошо видимым предметом, ночью с факелом или фонарем).',
    answer_b:
      'Поднятая над головой рука с жезлом или красным флагом.',
    answer_c: 'Вытянутая вперед рука.',
    answer_d:
      'Покачивание вверх и вниз вытянутой вперед рукой.',
    answer_e: '',
  },
  {
    id: 445,
    alias: 'ticket445',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367009195-9.jpeg',
    image_original: '1367009196-05.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-51',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a:
      'Желтый автобус, грузовой автомобиль, зеленый автобус.',
    answer_b:
      'Грузовой автомобиль, желтый автобус, зеленый автобус.',
    answer_c:
      'Желтый автобус, зеленый автобус, грузовой автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 714,
    alias: 'ticket714',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367319480-84.jpeg',
    image_original: '1367319480-9.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-79',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'О чем информирует сигнал, поданный рукой водителя легкового автомобиля?',
    answer_a:
      'Намерен совершить левый поворот или разворот.',
    answer_b:
      'Тормозит, чтобы уступить дорогу грузовому автомобилю.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 442,
    alias: 'ticket442',
    position: 3,
    correct_answer: 'answer_c',
    image: '1367009002-08.jpeg',
    image_original: '1367009002-25.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-48',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a: 'Легковой автомобиль, автобус, трамвай.',
    answer_b: 'Трамвай, автобус, легковой автомобиль.',
    answer_c: 'Трамвай, легковой автомобиль, автобус.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 641,
    alias: 'ticket641',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-6',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какие сигналы общей тревоги обязан подавать водитель звуковыми сигналами при вынужденной остановке транспортного средства на железнодорожном переезде?',
    answer_a: 'Три длинных и один короткий.',
    answer_b: 'Один длинный и три коротких.',
    answer_c: 'Один длинный и два коротких.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 386,
    alias: 'ticket386',
    position: 0,
    correct_answer: 'answer_c',
    image: '1366973174-44.jpeg',
    image_original: '1366973174-6.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-72',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'По какой траектории разрешается объезд препятствия в данной ситуации?',
    answer_a: 'Только » a» .',
    answer_b: 'Только » b» .',
    answer_c: '» a» и » b» .',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 350,
    alias: 'ticket350',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366960296-28.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-36',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли останавливаться на полосе, обозначенной этим знаком для посадки пассажиров?',
    answer_a:
      'Разрешается, если полоса расположена у правого края проезжей части, и если она не отделена от остальной проезжей части сплошной линией разметки.',
    answer_b: 'Запрещается.',
    answer_c: 'Разрешается.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 253,
    alias: 'ticket253',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_49',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» водительское удостоверение на право управления транспортными средствами категории «D» и подкатегории «D1» может быть выдано лицам, призванными в вооруженные силы и другие войска РА.',
    answer_a: '18 - летнего возраста.',
    answer_b: '19 - летнего возраста.',
    answer_c: '20 - летнего возраста.',
    answer_d: '21 - летнего возраста.',
    answer_e: '',
  },
  {
    id: 535,
    alias: 'ticket535',
    position: 0,
    correct_answer: 'answer_e',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-28',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Ближе какого расстояния от железнодорожных переездов запрещается стоянка транспортных средств?',
    answer_a: '300 м.',
    answer_b: '150 м.',
    answer_c: '100 м.',
    answer_d: '50 м.',
    answer_e: '25 м.',
  },
  {
    id: 598,
    alias: 'ticket598',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-25',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'C какой максимальной скоростью допускается движение легковых автомобилей с прицепом по автомагистралям?',
    answer_a: '110 км/ч.',
    answer_b: '100 км/ч.',
    answer_c: '90 км/ч.',
    answer_d: '80 км/ч.',
    answer_e: '70 км/ч.',
  },
  {
    id: 331,
    alias: null,
    position: 3,
    correct_answer: 'answer_c',
    image:
      '6da37dd3139aa4d9aa55b8d237ec5d4a_1583953617.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-17',
    created_at: null,
    updated_at: '2020-03-11 23:06:57',
    hint_for_correct_answer: '',
    question:
      'Какой знак обязывает уступить дорогу транспортным средствам, движущимся по пересекаемой дороге?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 698,
    alias: 'ticket698',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-63',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какие повторяющиеся звуковые сигналы общей тревоги обязан подавать водитель автобуса при вынужденной остановке транспортного средства на железнодорожном переезде?',
    answer_a: 'Три длинных и один короткий.',
    answer_b: 'Один длинный и три коротких.',
    answer_c: 'Один длинный и два коротких.',
    answer_d: 'Два длинных и два коротких.',
    answer_e: '',
  },
  {
    id: 739,
    alias: 'ticket739',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-13',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Оказывая помощь пострадавшему при кровотечении из носа, необходимо:',
    answer_a: 'Приподнять голову пострадавшего.',
    answer_b:
      'Голову опустить и прижать верхнюю часть носа.',
    answer_c: 'Вложить ватный тампон в нос пострадавшего.',
    answer_d: 'Дождаться прекращения кровотечения.',
    answer_e: '',
  },
  {
    id: 227,
    alias: 'ticket227',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_23',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» первоначальное обучение вождению транспортных средств должно проводиться:',
    answer_a:
      'На дорогах вне населенных пунктов, с учетом интенсивности движения транспортных средств.',
    answer_b: 'На закрытых площадках или автодромах.',
    answer_c:
      'На любой дороге (кроме автомагистралей) с учетом интенсивности движения транспортных средств.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 574,
    alias: 'ticket574',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-1',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'C какой максимальной скоростью разрешается движение легковых автомобилей на участках дорог вне населенных пунктов?',
    answer_a: '110 км/ч.',
    answer_b: '100 км/ч.',
    answer_c: '90 км/ч.',
    answer_d: '80 км/ч.',
    answer_e: '70 км/ч.',
  },
  {
    id: 155,
    alias: 'ticket155',
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_13',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Вы движетесь по дороге с двухсторонним движением, имеющей три полосы. В каком случае разрешается выезжать на среднюю полосу?',
    answer_a: 'Только для обгона.',
    answer_b: 'Только для объезда.',
    answer_c: 'Только для поворота налево или разворота.',
    answer_d: 'Во всех перечисленных случаях.',
    answer_e: '',
  },
  {
    id: 236,
    alias: 'ticket236',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_32',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Автобус» , это:',
    answer_a:
      'Автомобиль, имеющий более 8-и пассажирских мест для сидения и своей конструкцией и оборудованием предназначенный для безопасной перевозки пассажиров и багажа.',
    answer_b:
      'Автомобиль, имеющий 8 и более пассажирских мест для сидения и своей конструкцией и оборудованием предназначенный для безопасной перевозки пассажиров и багажа.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 563,
    alias: 'ticket563',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367318219-1.jpeg',
    image_original: '1367238867-09.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-56',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При продолжении движения налево где должен остановиться водитель автобуса, чтобы уступить дорогу легковому автомобилю?',
    answer_a: 'Перед дорожным знаком.',
    answer_b: 'Перед дорожной разметкой.',
    answer_c: 'В безопасном месте, по усмотрению водителя.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 405,
    alias: 'ticket405',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367005974-09.jpeg',
    image_original: '1367005974-23.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-11',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства должен уступить дорогу?',
    answer_a: 'Водитель велосипеда.',
    answer_b: 'Водитель автомобиля.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 180,
    alias: 'ticket180',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_38',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли транспортным средствам общего пользования в населенных пунктах занимать крайнюю левую полосу дороги, имеющей 3 или более полосы в одном направлении?',
    answer_a: 'Разрешается при обгоне.',
    answer_b:
      'Разрешается при левом повороте или развороте.',
    answer_c: 'Разрешается во всех случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 295,
    alias: 'ticket295',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_40',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'В рулевом управлении имеются не предусмотренные конструкцией перемещения деталей и узлов.',
    answer_b:
      'Спереди установлены указатели поворота с огнями белого цвета.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 408,
    alias: 'ticket408',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367006638-32.jpeg',
    image_original: '1371134007-97.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-14',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Вторым проедет перекресток:',
    answer_a: 'Красный автомобиль.',
    answer_b: 'Синий автомобиль.',
    answer_c: 'Зеленый автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 198,
    alias: 'ticket198',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366748824-16.jpeg',
    image_original: '1366748792-64.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_56',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какому транспортному средству Вы должны уступить дорогу, если намерены совершить левый поворот на перекрестке?',
    answer_a: 'Грузовому автомобилю.',
    answer_b: 'Всем транспортным средствам.',
    answer_c: 'Никому.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 500,
    alias: 'ticket500',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367231236-13.jpeg',
    image_original: '1367231236-28.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-45',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какое транспортное средство должно уступить дорогу?',
    answer_a: 'Автобус.',
    answer_b: 'Мотоцикл и легковой автомобиль.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 159,
    alias: 'ticket159',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_17',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На дорогах с двусторонним движением, при отсутствии дорожных знаков, разметки и разделительной полосы, находящиеся на проезжей части дороги элементы дорожных сооружений водители должны объезжать:',
    answer_a: 'Справа.',
    answer_b: 'Слева.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 336,
    alias: 'ticket336',
    position: 0,
    correct_answer: 'answer_c',
    image: '1366983706-57.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-22',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Этот дорожный знак предупреждает, что впереди:',
    answer_a:
      'Участок дороги с водной преградой, не имеющий моста или паромной переправы.',
    answer_b:
      'Участок дороги с водной преградой, на котором имеется разводной мост.',
    answer_c:
      'Место, где дорога выходит на набережную или берег.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 615,
    alias: 'ticket615',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-42',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли движение автобусов вне населенных пунктов со скоростью 70км/ч?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 252,
    alias: 'ticket252',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_48',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» стоянкой называется:',
    answer_a:
      'Приведение транспортного средства в недвижимое состояние на время более 5 минут, по причинам, не связанным с посадкой или высадкой пассажиров либо загрузкой или разгрузкой транспортного средства.',
    answer_b:
      'Приведение транспортного средства в недвижимое состояние на время более 5 минут, кроме случаев предотвращения столкновения с другим участником дорожного движения или препятствием, посадкой, высадкой пассажиров и (или) загрузкой, разгрузкой транспортного средства, а также в других случаях определенных законодательством.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 718,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image: '1367319697-85.jpeg',
    image_original: '1367319697-96.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-83',
    created_at: null,
    updated_at: '2020-03-20 17:31:47',
    hint_for_correct_answer: '',
    question: 'Разрешается ли обгон в данной ситуации?',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается.',
    answer_c:
      'Разрешается, если автобус движется со скоростью менее 30 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 617,
    alias: 'ticket617',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-44',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой максимальной скоростью разрешается движение междугородних автобусов вне населенных пунктов:',
    answer_a: '60 км/ч.',
    answer_b: '70 км/ч.',
    answer_c: '90 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 448,
    alias: 'ticket448',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367009963-92.jpeg',
    image_original: '1367009303-85.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-54',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a:
      'Грузовой автомобиль, трамвай и автобус, мотоцикл и легковой автомобиль.',
    answer_b:
      'Трамвай и автобус, мотоцикл и легковой автомобиль, грузовой автомобиль.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 199,
    alias: 'ticket199',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366748848-22.jpeg',
    image_original: '1366748868-36.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_57',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какому транспортному средству Вы должны уступить дорогу, если намерены совершить левый поворот на перекрестке?',
    answer_a: 'Никому.',
    answer_b: 'Только автобусу.',
    answer_c:
      'Только грузовому автомобилю с включенным проблесковым маячком.',
    answer_d: 'Обоим транспортным средствам.',
    answer_e: '',
  },
  {
    id: 731,
    alias: 'ticket731',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-5',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Оказывая помощь при закрытых травмах мягких тканей конечностей, в первую очередь следует:',
    answer_a: 'Наложить на рану тёплую примочку.',
    answer_b:
      'Наложить на рану холодную примочку и приподнять.',
    answer_c:
      'Наложить на рану холодную примочку и удерживать конечность ниже уровня сердца.',
    answer_d: 'Наложить на рану спиртовую примочку.',
    answer_e: '',
  },
  {
    id: 490,
    alias: 'ticket490',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367230868-47.png',
    image_original: '1367230869-21.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-35',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На каком рисунке водитель поворачивает правильно?',
    answer_a: 'На левом рисунке.',
    answer_b: 'На правом рисунке.',
    answer_c: 'На обоих рисунках.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 311,
    alias: 'ticket311',
    position: 3,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_56',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация автобусов запрещается, если:',
    answer_a: 'Не работает привод управления дверьми.',
    answer_b: 'Отсутствует медицинская аптечка.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 338,
    alias: null,
    position: 0,
    correct_answer: 'answer_d',
    image:
      '819f46e52c25763a55cc642422644317_1583954486.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-24',
    created_at: null,
    updated_at: '2020-03-11 23:21:26',
    hint_for_correct_answer: '',
    question:
      'Какой из знаков указывает протяженность опасного участка дороги, обозначенного предупреждающими знаками?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 453,
    alias: 'ticket453',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367010219-55.jpeg',
    image_original: '1367010219-7.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-59',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a:
      'Легковой автомобиль, автобус, грузовой автомобиль.',
    answer_b:
      'Автобус, грузовой автомобиль, легковой автомобиль.',
    answer_c:
      'Автобус, легковой автомобиль, грузовой автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 620,
    alias: 'ticket620',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-47',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При перевозке пассажиров в кузове грузового автомобиля, оборудованного для перевозки людей, водитель обязан двигаться со скоростью не более:',
    answer_a: '50 км/ч.',
    answer_b: '60 км/ч.',
    answer_c: '70 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 229,
    alias: 'ticket229',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_25',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» лицам, имеющим водительское удостоверение на право управления транспортными средствами категории «B» , «C» и » D» разрешается управлять ими также при наличии прицепа, если разрешенная максимальная масса которого не превышает:',
    answer_a: '750 килограммов.',
    answer_b: '800 килограммов.',
    answer_c: '1 000 килограммов.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 282,
    alias: 'ticket282',
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_27',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация мотоциклов с боковыми прицепами запрещена, если:',
    answer_a:
      'Отсутствует предусмотренная конструкцией поперечная рукоятка для пассажира на седле.',
    answer_b:
      'Шины имеют остаточную высоту рисунка протектора 0.6 мм.',
    answer_c: 'Отсутствует медицинская аптечка.',
    answer_d: 'Во всех перечисленных случаях.',
    answer_e: '',
  },
  {
    id: 666,
    alias: 'ticket666',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-31',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Обгон транспортных средств, это:',
    answer_a:
      'Опережение находящегося в движении одного или нескольких транспортных средств, связанное с выездом на полосу встречного движения.',
    answer_b:
      'Опережение находящегося в движении одного или нескольких транспортных средств, связанное с выездом с занимаемой полосы.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 681,
    alias: 'ticket681',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-46',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли перемещение пешеходов по дороге, обозначенной знаком «Автомагистраль»?',
    answer_a: 'Запрещается.',
    answer_b:
      'Разрешается идти только вне населенных пунктов навстречу движения транспортных средств.',
    answer_c:
      'Разрешается идти вне населенных пунктов по ходу движения транспортных средств.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 412,
    alias: 'ticket412',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367006794-14.jpeg',
    image_original: '1367006794-29.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-18',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства должен уступить дорогу?',
    answer_a: 'Водитель автобуса.',
    answer_b: 'Водитель мотоцикла.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 187,
    alias: 'ticket187',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366747786-44.jpeg',
    image_original: '1366747804-48.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_45',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Обязан ли водитель автобуса, продолжающего движение прямо, уступить дорогу грузовому автомобилю?',
    answer_a: 'Обязан.',
    answer_b: 'Не обязан.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 694,
    alias: 'ticket694',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-59',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Регулировщик подает сигнал свистком:',
    answer_a:
      'Только в том случае, когда требует остановить транспортное средство.',
    answer_b:
      'Для привлечения к себе внимания участников дорожного движения.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 341,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image: '1366959100-35.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-27',
    created_at: null,
    updated_at: '2020-03-18 21:29:44',
    hint_for_correct_answer: '',
    question:
      'Таким опознавательным знаком обозначаются автомобили:',
    answer_a: 'Перевозящие опасные грузы.',
    answer_b: 'Управляемые инвалидами.',
    answer_c:
      'Управляемые глухонемыми или глухими водителями.',
    answer_d:
      'Управляемые водителями, имеющими водительский стаж до 3-х лет.',
    answer_e: '',
  },
  {
    id: 607,
    alias: 'ticket607',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-34',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли проезд в кузове грузового автомобиля, не оборудованного для перевозки людей?',
    answer_a: 'Запрещается.',
    answer_b:
      'Разрешается на дорогах, не относящихся к автомагистралям.',
    answer_c:
      'Разрешается только лицам, сопровождающим груз или следующим за его получением, при условии обеспечения их местом для сидения, расположенным ниже уровня бортов.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 215,
    alias: 'ticket215',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_11',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» на дорогах Республики Армения установлено:',
    answer_a: 'Правостороннее движение.',
    answer_b: 'Левостороннее движение.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 174,
    alias: 'ticket174',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_32',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Обязаны ли водители транспортных средств в населенных пунктах уступать дорогу водителям транспортных средств общего пользования, начинающим движение от обозначенного и оборудованного места остановки?',
    answer_a: 'Да.',
    answer_b: 'Нет.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 382,
    alias: 'ticket382',
    position: 0,
    correct_answer: 'answer_b',
    image: '1380107635-97.jpeg',
    image_original: '1379628159-45.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-68',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что показывает данный дорожный знак?',
    answer_a:
      'Движение на данном участке дороги разрешается со скоростью не более 50 км/ч.',
    answer_b:
      'На данном участке дороги рекомендуется передвигаться со скоростью 50 км/ч.',
    answer_c:
      'Движение разрешено только при указанной на данном знаке скорости или более.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 384,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image: '1366972953-59.jpeg',
    image_original: '1366972953-76.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-70',
    created_at: null,
    updated_at: '2020-03-18 22:21:41',
    hint_for_correct_answer: '',
    question: 'Что показывают данные дорожные знаки?',
    answer_a:
      'При мокром покрытии дороги рекомендуется движение со скоростью 40 км/ч.',
    answer_b:
      'При мокром покрытии дороги разрешается движение со скоростью не более 40 км/ч.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 503,
    alias: 'ticket503',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367231337-05.jpeg',
    image_original: '1367231337-2.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-48',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В данной ситуации по обозначенным траекториям имеют право на движение:',
    answer_a: 'Водитель желтого автобуса.',
    answer_b: 'Водитель легкового автомобиля.',
    answer_c:
      'Водители желтого автобуса и легкового автомобиля.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 482,
    alias: null,
    position: 5,
    correct_answer: 'answer_c',
    image:
      'f770b62bc8f42a0b66751fe636fc6eb0_1584616732.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-27',
    created_at: null,
    updated_at: '2020-03-19 15:18:52',
    hint_for_correct_answer: '',
    question:
      'При красном сигнале данного светофора движение запрещается:',
    answer_a: 'По всей ширине проезжей части.',
    answer_b: 'Со скоростью менее 50 км/ч.',
    answer_c: 'По полосе, над которой он расположен.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 509,
    alias: 'ticket509',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367236458-64.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-2',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли водителю пересекать сплошную линию разметки, обозначающую границы стояночных мест транспортных средств?',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 656,
    alias: 'ticket656',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-21',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель транспортного средства, оборудованного проблесковым маячком синего цвета, имеет преимущество перед другими участниками движения, если:',
    answer_a: 'Включил проблесковый маячок.',
    answer_b: 'Подает специальный звуковой сигнал.',
    answer_c:
      'Включил проблесковый маячок и подает специальный звуковой сигнал.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 201,
    alias: 'ticket201',
    position: 0,
    correct_answer: 'answer_d',
    image: '1370669841-13.jpeg',
    image_original: '1366749014-88.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_59',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какому транспортному средству Вы должны уступить дорогу, если намерены совершить левый поворот на перекрестке?',
    answer_a: 'Только автобусу.',
    answer_b: 'Автобусу и легковому автомобилю.',
    answer_c: 'Только легковому автомобилю.',
    answer_d: 'Никому.',
    answer_e: '',
  },
  {
    id: 525,
    alias: null,
    position: 8,
    correct_answer: 'answer_a',
    image: '1367317036.jpeg',
    image_original: '1367236983-48.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-18',
    created_at: null,
    updated_at: '2020-03-19 22:06:37',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли в этом месте произвести разворот?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 592,
    alias: 'ticket592',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-19',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Буксировка в условиях гололедицы:',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается.',
    answer_c:
      'Разрешается при буксировке на жесткой сцепке или путем частичной погрузки.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 256,
    alias: 'ticket256',
    position: 8,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_1',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Шины легкового автомобиля имеют остаточную высоту рисунка протектора 1.8 мм.',
    answer_b:
      'Нарушена герметичность гидравлического тормозного привода.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 596,
    alias: 'ticket596',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-23',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Разрешается ли буксировка мотоциклов?',
    answer_a: 'Разрешается-мотоциклов с боковым прицепом.',
    answer_b:
      'Разрешается-мотоциклов без бокового прицепа.',
    answer_c: 'Разрешается в обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 449,
    alias: 'ticket449',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367009995-92.jpeg',
    image_original: '1367009996-07.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-55',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a:
      'Автомобиль » Скорой помощи» , трамвай, мотоцикл, автобус, легковой автомобиль.',
    answer_b:
      'Мотоцикл, автобус, трамвай и автомобиль » Скорой помощи» , легковой автомобиль.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 473,
    alias: 'ticket473',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367230356-55.png',
    image_original: '1367230357-17.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-18',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На каком рисунке водитель поворачивает правильно?',
    answer_a: 'На левом рисунке.',
    answer_b: 'На правом рисунке.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 438,
    alias: 'ticket438',
    position: 7,
    correct_answer: 'answer_a',
    image: '1367008779-64.jpeg',
    image_original: '1367008756-71.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-44',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Вторым проедет перекресток:',
    answer_a: 'Зеленый автомобиль.',
    answer_b: 'Синий автомобиль.',
    answer_c: 'Красный автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 507,
    alias: 'ticket507',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367231483-63.jpeg',
    image_original: '1367231483-79.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-52',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a:
      'Трамвай, автобус, грузовой автомобиль, мотоцикл.',
    answer_b:
      'Автобус, грузовой автомобиль, трамвай, мотоцикл.',
    answer_c:
      'Автобус, трамвай и мотоцикл, грузовой автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 428,
    alias: 'ticket428',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367007426-02.jpeg',
    image_original: '1367007426-19.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-34',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a: 'Трамвай, автомобиль и автобус одновременно.',
    answer_b: 'Трамвай, автобус, автомобиль.',
    answer_c: 'Автобус, трамвай, автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 586,
    alias: 'ticket586',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-13',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли перевозка людей в кузове грузового автомобиля при буксировке на жесткой или гибкой сцепке?',
    answer_a:
      'Разрешается в кузовах буксирующего и буксируемого автомобилей.',
    answer_b:
      'Разрешается только в кузове буксируемого автомобиля.',
    answer_c:
      'Разрешается только в кузове буксирующего автомобиля.',
    answer_d: 'Запрещается в кузовах обоих автомобилей.',
    answer_e: '',
  },
  {
    id: 705,
    alias: 'ticket705',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367319197-37.jpeg',
    image_original: '1367319197-43.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-70',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Можно ли подать предупреждающий сигнал рукой при движении по данной траектории?',
    answer_a: 'Можно, если неисправен указатель поворота.',
    answer_b:
      'Можно, если неисправен указатель поворота, в светлое время суток.',
    answer_c: 'Можно во всех случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 292,
    alias: 'ticket292',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_37',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'На одну ось установлены шины различных конструкций.',
    answer_b:
      'Нарушена герметичность системы питания двигателя.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 288,
    alias: 'ticket288',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_33',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'В легком автомобиле отсутствует медицинская аптечка.',
    answer_b:
      'Установлены фонари заднего хода с огнями красного цвета.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 277,
    alias: 'ticket277',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_22',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация мотоциклов запрещена, если:',
    answer_a:
      'Отсутствуют предусмотренные конструкцией дуги безопасности.',
    answer_b:
      'Шины имеют остаточную высоту рисунка протектора 1.6 мм.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 219,
    alias: 'ticket219',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_15',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» водитель, в порядке оказания помощи, обязан предоставить транспортное средство:',
    answer_a:
      'Служащим полиции для перевозки в медицинское учреждение лиц, нуждающихся в срочной медицинской помощи.',
    answer_b:
      'Медицинским работникам (с согласия водителя), которые следуют в попутном направлении для оказания медицинской помощи.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 556,
    alias: 'ticket556',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367318080-3.jpeg',
    image_original: '1367238658-56.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-49',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Как должен поступить водитель легкового автомобиля, если водитель автобуса начинает тормозить?',
    answer_a: 'Продолжить движение.',
    answer_b:
      'Замедлить движение, а в случае необходимости остановиться и продолжить движение, убедившись, что на переходе нет пешеходов.',
    answer_c:
      'Остановиться и продолжить движение только в том случае, когда возобновит движение автобус.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 369,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      '0c74b7f78409a4022a2c4c5a5ca3ee19_1583955913.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-55',
    created_at: null,
    updated_at: '2020-03-11 23:45:13',
    hint_for_correct_answer: '',
    question:
      'Какие знаки распространяют свое действие только на период времени, когда покрытие проезжей части влажное?',
    answer_a: 'Только A и C.',
    answer_b: 'Только B.',
    answer_c: 'Только C.',
    answer_d: 'Все.',
    answer_e: '',
  },
  {
    id: 231,
    alias: 'ticket231',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_27',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» водительское удостоверение на право управления транспортными средствами категории «B» и «C» может быть выдано:',
    answer_a: 'Лицам, достигшим 16 - летнего возраста.',
    answer_b: 'Лицам, достигшим 17 - летнего возраста.',
    answer_c: 'Лицам, достигшим 18 - летнего возраста.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 381,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image: '1366971844-91.jpeg',
    image_original: '1366971845-06.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-67',
    created_at: null,
    updated_at: '2020-03-18 22:24:07',
    hint_for_correct_answer: '',
    question: 'Что показывают данные дорожные знаки?',
    answer_a: 'Остановка запрещается по субботам.',
    answer_b: 'Остановка запрещается по воскресеньям.',
    answer_c: 'Остановка запрещается по рабочим дням.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 271,
    alias: 'ticket271',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_16',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Имеются люфты в соединениях рамы мотоцикла с рамой бокового прицепа.',
    answer_b:
      'Спереди установлены противотуманные фары с огнями желтого цвета.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 413,
    alias: 'ticket413',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367006850-77.jpeg',
    image_original: '1367006850-93.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-19',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Первым проедет перекресток:',
    answer_a: 'Красный автомобиль.',
    answer_b: 'Зеленый автомобиль.',
    answer_c: 'Синий автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 724,
    alias: 'ticket724',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367320074-54.jpeg',
    image_original: '1367320074-61.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-88',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли проехать железнодорожный переезд в данной ситуации?',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается, если не приближается поезд.',
    answer_c:
      'Разрешается, поскольку дежурный переезда запрещает движение встречного транспортного средства.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 269,
    alias: 'ticket269',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_14',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a: 'Двигатель работает с перебоями.',
    answer_b:
      'Задние противотуманные фонари не подключены к стоп-сигналам.',
    answer_c:
      'Не работают предусмотренные конструкцией стеклоомыватели.',
    answer_d: 'Во всех перечисленных случаях.',
    answer_e: '',
  },
  {
    id: 421,
    alias: 'ticket421',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367007165-27.jpeg',
    image_original: '1367007165-44.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-27',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a:
      'Трамвай, желтый автомобиль, зеленый автомобиль.',
    answer_b:
      'Трамвай и зеленый автомобиль, желтый автомобиль.',
    answer_c:
      'Зеленый автомобиль, желтый автомобиль, трамвай.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 178,
    alias: 'ticket178',
    position: 0,
    correct_answer: 'answer_b',
    image: '1370592127-59.jpeg',
    image_original: '1366747416-92.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_36',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Укажите очередность проезда перекрестка:',
    answer_a:
      'Автобус, грузовой автомобиль, гужевая повозка.',
    answer_b:
      'Автобус и гужевая повозка, грузовой автомобиль.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 177,
    alias: 'ticket177',
    position: 0,
    correct_answer: 'answer_a',
    image: '1370592085.jpeg',
    image_original: '1366747294-86.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_35',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства должен уступить дорогу?',
    answer_a: 'Водитель автомобиля.',
    answer_b: 'Водитель трамвая.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 708,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '1367319253-28.jpeg',
    image_original: '1367319253-34.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-73',
    created_at: null,
    updated_at: '2020-03-20 16:59:39',
    hint_for_correct_answer: '',
    question:
      'Обязан ли водитель автобуса уступить дорогу автомобилю » Скорой помощи» , если на нем не включен проблесковый маячок синего цвета и специальный звуковой сигнал?',
    answer_a: 'Обязан.',
    answer_b: 'Не обязан.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 214,
    alias: 'ticket214',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_10',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении без опасности дорожного движения» «Прицеп (полуприцеп)» , это:',
    answer_a:
      'Любое механическое транспортное средство, буксируемое на жесткой сцепке.',
    answer_b:
      'Не оборудованное двигателем транспортное средство, которое предназначено для движения как одно целое в составе с механическим транспортным средством.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 328,
    alias: 'ticket328',
    position: 6,
    correct_answer: 'answer_a',
    image: '1366982232-07.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-14',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Этот дорожный знак:',
    answer_a:
      'Разрешает движение только с указанной или большей скоростью.',
    answer_b:
      'Запрещает движение с большей скоростью, чем указано на знаке.',
    answer_c:
      'Указывает скорость, с которой рекомендуется движение на данном участке дороги.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 390,
    alias: 'ticket390',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366973371-05.jpeg',
    image_original: '1366973371-2.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-76',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Обязан ли водитель остановиться на указанном регулировщиком месте в данной ситуации?',
    answer_a:
      'Не обязан, поскольку знак запрещает остановку.',
    answer_b: 'Обязан.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 688,
    alias: 'ticket688',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-53',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На застроенных территориях, въезды на которую и выезды с которой обозначены дорожными знаками «Жилая зона» и «Конец жилой зоны» , не запрещается:',
    answer_a:
      'Перемещение пешеходов по проезжей части дороги.',
    answer_b: 'Сквозное движение транспортных средств.',
    answer_c: 'Учебная езда.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 741,
    alias: 'ticket741',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-15',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При наличии дыхания у находящегося в бессознательном состоянии пострадавшего необходимо:',
    answer_a: 'Уложить его на спину.',
    answer_b: 'Открыть рот и вытянуть язык.',
    answer_c: 'Повернуть на бок и приподнять голову.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 301,
    alias: 'ticket301',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_46',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещается, если:',
    answer_a:
      'Не работают приборы внутреннего освещения салона легкового автомобиля.',
    answer_b:
      'Не работают приборы внутреннего освещения салона автобуса.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 624,
    alias: 'ticket624',
    position: 0,
    correct_answer: 'answer_d',
    image: '1367316733-56.jpeg',
    image_original: '1367261649-67.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-51',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой максимальной скоростью может двигаться водитель междугороднего автобуса в данной ситуации?',
    answer_a: '60 км/ч.',
    answer_b: '70 км/ч.',
    answer_c: '80 км/ч.',
    answer_d: '90 км/ч.',
    answer_e: '',
  },
  {
    id: 261,
    alias: 'ticket261',
    position: 3,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_6',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a: 'Двигатель работает с перебоями.',
    answer_b:
      'Шины имеют обнажающие корд местные повреждения.',
    answer_c:
      'Не работают приборы внутреннего освещения салона легкового автомобиля.',
    answer_d: 'Во всех перечисленных случаях.',
    answer_e: '',
  },
  {
    id: 521,
    alias: 'ticket521',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-14',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Что обязан выполнить водитель транспортного средства, приблизившись к перекрестку, перед которым нанесена «Cтоп-линия» и включен зеленый сигнал светофора?',
    answer_a:
      'Остановиться у «Cтоп-линии», а затем возобновить движение.',
    answer_b:
      'Продолжить движение через перекресток без остановки.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 172,
    alias: 'ticket172',
    position: 0,
    correct_answer: 'answer_b',
    image: '1370591845-65.jpeg',
    image_original: '1366746907-34.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_30',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства должен уступить дорогу?',
    answer_a: 'Водитель трактора.',
    answer_b: 'Водитель автобуса.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 161,
    alias: 'ticket161',
    position: 0,
    correct_answer: 'answer_b',
    image: '1370589932-66.jpeg',
    image_original: '1366746408-73.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_19',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства нарушает правила поворота с дороги, на которой есть полоса торможения?',
    answer_a: 'Оба водителя.',
    answer_b: 'Водитель желтого автомобиля.',
    answer_c: 'Оба водителя поворачивают правильно.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 162,
    alias: 'ticket162',
    position: 0,
    correct_answer: 'answer_b',
    image: '1370590111-9.jpeg',
    image_original: '1366746460-7.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_20',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли в этой обстановке водителю красного автомобиля продолжать движение?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 313,
    alias: 'ticket313',
    position: 1,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_58',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация автобусов запрещается, если:',
    answer_a: 'Имеется один огнетушитель.',
    answer_b: 'Отсутствует знак аварийной остановки.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 767,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      'f2201f5191c4e92cc5af043eebfd0946_1584559341.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 1,
    group: 4,
    label: '4-82',
    created_at: '2020-03-18 23:20:24',
    updated_at: '2020-03-18 23:22:21',
    hint_for_correct_answer: '',
    question:
      'На каком наибольшем расстоянии устанавливается дорожный знак «Территория перекрестка», если невозможно установить его на границе перекрестка.',
    answer_a: '10 метров.',
    answer_b: '20 метров.',
    answer_c: '30 метров.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 593,
    alias: 'ticket593',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-20',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой максимальной скоростью разрешается буксировка транспортных средств на гибкой сцепке?',
    answer_a: '70 км/ч.',
    answer_b: '60 км/ч.',
    answer_c: '50 км/ч.',
    answer_d: '40 км/ч.',
    answer_e: '30 км/ч.',
  },
  {
    id: 283,
    alias: 'ticket283',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_28',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Не работает предусмотренный конструкцией механизм регулировки положения сидения водителя.',
    answer_b:
      'Не работают приборы внутреннего освещения салона автобуса.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 565,
    alias: 'ticket565',
    position: 0,
    correct_answer: 'answer_d',
    image: '1367318260-4.jpeg',
    image_original: '1367238942-17.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-58',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Каким транспортным средствам разрешена остановка в зоне действия данного дорожного знака?',
    answer_a:
      'Только транспортным средствам общего пользования.',
    answer_b:
      'Только транспортным средствам, управляемым инвалидами.',
    answer_c: 'Только такси с включенным таксометром.',
    answer_d: 'Всем запрещается.',
    answer_e: '',
  },
  {
    id: 234,
    alias: 'ticket234',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_30',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Аварийная обстановка» , это:',
    answer_a:
      'Ситуация, при которой из-за действия или бездействия участника дорожного движения возникла реальная угроза дорожно-транспортного происшествия.',
    answer_b:
      'Ситуация, при которой из-за действия или бездействия участника дорожного движения и (или) регулировщика возникла реальная угроза дорожно - транспортного происшествия.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 684,
    alias: 'ticket684',
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-49',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На транспортном средстве аварийная световая сигнализация должна быть включена:',
    answer_a: 'При дорожно-транспортном происшествии.',
    answer_b:
      'При буксировке (на буксируемом механическом транспортном средстве).',
    answer_c:
      'При вынужденной остановке в местах, где остановка запрещается.',
    answer_d: 'Во всех указанных случаях.',
    answer_e: '',
  },
  {
    id: 742,
    alias: 'ticket742',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-16',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'При сильном кровотечении необходимо:',
    answer_a: 'Перевязать рану.',
    answer_b:
      'Наложить тугую повязку, надавив на точку сдавливания артерии.',
    answer_c: 'Посыпать рану пеплом.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 693,
    alias: 'ticket693',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-58',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли водителю автомобиля продолжать движение при включении желтого сигнала светофора или поднятии регулировщиком руки вверх?',
    answer_a: 'Запрещается.',
    answer_b:
      'Разрешается, только в случае, если водитель не может остановиться, не прибегая к экстренному торможению.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 281,
    alias: 'ticket281',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_26',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Отсутствуют предусмотренные конструкцией ремни безопасности.',
    answer_b:
      'Сзади установлены фонари заднего хода с огнями белого цвета.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 770,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      '4ea06fbc83cdd0a06020c35d50e1e89a_1584561107.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 1,
    group: 4,
    label: '4-85',
    created_at: '2020-03-18 23:51:47',
    updated_at: '2020-03-18 23:51:55',
    hint_for_correct_answer: '',
    question:
      'Какая из нижепредставленных дорожных разметок указывает участок перекрестка, где запрещается въезд, если впереди по направлению движения образовалась пробка, которая принудит водителя остановиться.',
    answer_a: 'Первый․',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 474,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image:
      '25ddc0f8c9d3e22e03d3076f98d83cb2_1584615313.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-19',
    created_at: null,
    updated_at: '2020-03-19 14:55:13',
    hint_for_correct_answer: '',
    question:
      'Должен ли водитель трамвая при движении на зеленый сигнал светофора уступить дорогу транспортным средствам, движущимся с других направлений?',
    answer_a: 'Должен.',
    answer_b: 'Не должен.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 212,
    alias: 'ticket212',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_8',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Транспортное средство общего пользования» , это:',
    answer_a:
      'Транспортное средство (трамвай, троллейбус, автобус), перевозящее пассажиров и (или) багаж и движущееся по маршрутам, имеющим остановочные места (остановки).',
    answer_b:
      'Транспортное средство (трамвай, троллейбус, автобус, легковой автомобиль «такси» ), перевозящее пассажиров и (или) багаж и движущееся по маршрутам, имеющим остановочные места (остановки).',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 670,
    alias: 'ticket670',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-35',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Звуковые сигналы могут применяться только:',
    answer_a:
      'В населенных пунктах, для предупреждения других водителей о намерении произвести обгон.',
    answer_b:
      'Когда это необходимо для предотвращения дорожно- транспортного происшествия.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 226,
    alias: 'ticket226',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_22',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Пешеход» , это:',
    answer_a:
      'Лица, находящиеся на дороге, вне транспортного средства, за исключением лиц, уполномоченных производить работы на дороге и производящие эти работы в установленном законодательством порядке.',
    answer_b:
      'Лица, находящиеся на дороге, вне транспортного средства, в том числе лица, уполномоченные производить работы на дороге и производящие эти работы в установленном законодательством порядке.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 399,
    alias: 'ticket399',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367001758-89.jpeg',
    image_original: '1367001759-04.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-5',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Вторым проедет перекресток:',
    answer_a: 'Трамвай.',
    answer_b: 'Красный автомобиль.',
    answer_c: 'Синий автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 713,
    alias: 'ticket713',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367319416-33.jpeg',
    image_original: '1367319416-39.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-78',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'О чем информирует сигнал, поданный рукой водителя легкового автомобиля?',
    answer_a: 'Делает поворот направо.',
    answer_b: 'Продолжает движение прямо.',
    answer_c: 'Тормозит, чтобы уступить дорогу мотоциклу.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 203,
    alias: 'ticket203',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366749132-93.jpeg',
    image_original: '1366749153-59.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_61',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какому транспортному средству Вы должны уступить дорогу, если намерены совершить правый поворот на перекрестке?',
    answer_a: 'Никому.',
    answer_b: 'Только легковому автомобилю.',
    answer_c: 'Мотоциклу и легковому автомобилю.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 211,
    alias: 'ticket211',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_7',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Остановка» это:',
    answer_a:
      'Приведение транспортного средства в состояние покоя на время до 5 минут и (или) на время, необходимое для посадки, высадки и (или) загрузки, разгрузки транспортного средства.',
    answer_b:
      'Приведение транспортного средства в состояние покоя на время более 5 минут, если это не связано с посадкой, высадкой пассажиров или загрузкой, разгрузкой транспортного средства.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 510,
    alias: 'ticket510',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367316950-1.jpeg',
    image_original: '1367236492-36.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-3',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'По какому пути из числа обозначенных стрелками разрешено движение?',
    answer_a: 'Только прямо.',
    answer_b: 'Налево и в обратном направлении.',
    answer_c: 'Прямо, налево и в обратном направлении.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 329,
    alias: null,
    position: 5,
    correct_answer: 'answer_b',
    image:
      '6faa8040da20ef399b63a72d0e4ab575_1584551892.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-15',
    created_at: null,
    updated_at: '2020-03-18 21:18:12',
    hint_for_correct_answer: '',
    question:
      'Какой знак требует уступить дорогу встречным транспортным средствам?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 696,
    alias: 'ticket696',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-61',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком случае правила не обязывают водителя автобуса подать предупредительный сигнал?',
    answer_a: 'Во время остановки у края проезжей части.',
    answer_b:
      'Перед закруглением участка дороги, обозначенной знаком «Опасный поворот».',
    answer_c:
      'Перед перестроением на соседнюю полосу движения.',
    answer_d: 'При движении по установленному маршруту.',
    answer_e: '',
  },
  {
    id: 636,
    alias: 'ticket636',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-1',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком случае Правила не требуют подачи предупредительного сигнала?',
    answer_a: 'Перед остановкой у края проезжей части.',
    answer_b:
      'Перед закруглением дороги, обозначенной знаком «Опасный поворот».',
    answer_c:
      'Перед перестроением на соседнюю полосу движения.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 650,
    alias: 'ticket650',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367318717-61.jpeg',
    image_original: '1367318717-69.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-15',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства имеет преимущество на первоочередное движение?',
    answer_a: 'Водитель дорожной машины.',
    answer_b: 'Водитель легкового автомобиля.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 347,
    alias: 'ticket347',
    position: 0,
    correct_answer: 'answer_b',
    image: '1371031957-85.png',
    image_original: '1366960236-07.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-33',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какой из указанных знаков устанавливается для обозначения автопоезда?',
    answer_a: 'Левый знак.',
    answer_b: 'Правый знак.',
    answer_c: 'Оба знака.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 263,
    alias: 'ticket263',
    position: 1,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_8',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Отсутствует хотя бы один болт крепления обода колеса.',
    answer_b:
      'На одну ось установлены шины с различными рисунками протектора.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 534,
    alias: 'ticket534',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367317181-93.jpeg',
    image_original: '1367237350-92.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-27',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли стоянка автомобиля в этом месте?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 662,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image: '1367318856-53.jpeg',
    image_original: '1367318856-59.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-27',
    created_at: null,
    updated_at: '2020-03-20 13:34:14',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли обгонять автопоезд в данной ситуации, если он движется со скоростью менее 30 км/ч?',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 70,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      '7cbbc409ec990f19c78c75bd1e06f215_1583475560.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_1',
    created_at: null,
    updated_at: '2020-03-06 10:19:20',
    hint_for_correct_answer: '',
    question:
      'Какой знак называется «Объезд препятствия слева»?',
    answer_a: 'Первый',
    answer_b: 'Второй',
    answer_c: 'Третий',
    answer_d: 'Четвертый',
    answer_e: 'Пятый',
  },
  {
    id: 551,
    alias: 'ticket551',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367317400-36.jpeg',
    image_original: '1367237847-09.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-44',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли водителю туристического автобуса двигаться по полосе «A»?',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 766,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      '959a557f5f6beb411fd954f3f34b21c3_1584558799.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 1,
    group: 4,
    label: '4-81',
    created_at: '2020-03-18 23:09:17',
    updated_at: '2020-03-18 23:13:19',
    hint_for_correct_answer: '',
    question:
      'Какой из нижепредставленных дорожных знаков запрещает въезд на территорию перекрестка, если впереди по направлению движения образовалась пробка, за исключением случаев поворота направо или налево',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: '',
  },
  {
    id: 493,
    alias: 'ticket493',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367230974-63.jpeg',
    image_original: '1367230974-81.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-38',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Автомобиль проедет перекресток:',
    answer_a: 'Первым.',
    answer_b: 'Вторым.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 418,
    alias: 'ticket418',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367007044-22.jpeg',
    image_original: '1367007044-38.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-24',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Третьим проедет перекресток:',
    answer_a: 'Желтый автомобиль.',
    answer_b: 'Красный автомобиль.',
    answer_c: 'Синий автомобиль.',
    answer_d: 'Зеленый автомобиль.',
    answer_e: '',
  },
  {
    id: 469,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image:
      'dc6a6489640ca02b0d42dabeb8e46bb7_1585127357.jpeg',
    image_original: '1367225630-53.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-14',
    created_at: null,
    updated_at: '2020-03-25 13:09:17',
    hint_for_correct_answer: '',
    question: 'Водитель красного автомобиля:',
    answer_a: 'Должен уступить дорогу.',
    answer_b: 'Имеет право на первоочередное движение.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 508,
    alias: 'ticket508',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367236444-92.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-1',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Что обозначает сплошная желтая линия горизонтальной разметки?',
    answer_a:
      'Место, где запрещается остановка и стоянка транспортных средств.',
    answer_b:
      'Место, где разрешена остановка транспортных средств для высадки пассажиров или разгрузки груза.',
    answer_c:
      'Место, где запрещена стоянка транспортных средств.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 695,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '1367319136-2.jpeg',
    image_original: '1367319136-26.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-60',
    created_at: null,
    updated_at: '2020-03-20 15:42:50',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли в данной ситуации водителю автопоезда проехать по мосту?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 260,
    alias: 'ticket260',
    position: 4,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_5',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Задние противотуманные фонари подключены к стоп - сигналам.',
    answer_b:
      'Не работает указатель температуры охлаждающей жидкости двигателя.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 501,
    alias: 'ticket501',
    position: 0,
    correct_answer: 'answer_d',
    image: '1367231257-86.jpeg',
    image_original: '1367231258-01.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-46',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Продолжить движение по обозначенным траекториям имеют право?',
    answer_a: 'Водитель грузового автомобиля.',
    answer_b: 'Водители автобуса и грузового автомобилей.',
    answer_c: 'Водители легкового автомобиля и автобуса.',
    answer_d: 'Водитель автобуса.',
    answer_e: '',
  },
  {
    id: 734,
    alias: 'ticket734',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-8',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Вы увидели лежащего на земле человека и заметили кровь и кость, торчащую из голени. Что надо предпринять в первую очередь?',
    answer_a: 'Вызвать скорую помощь.',
    answer_b:
      'Проверить находиться ли пострадавший в сознании и наличие дыхания.',
    answer_c: 'Обездвижить ногу.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 363,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      '00411460f7c92d2124a67ea0f4cb5f85_1583955681.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-49',
    created_at: null,
    updated_at: '2020-03-11 23:41:21',
    hint_for_correct_answer: '',
    question:
      'Какой из этих знаков является опознавательным знаком транспортных средств?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 631,
    alias: 'ticket631',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-58',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой максимальной скоростью разрешается движение междугородних автобусов на автомагистралях?',
    answer_a: '70 км/ч.',
    answer_b: '80 км/ч.',
    answer_c: '90 км/ч.',
    answer_d: '100 км/ч.',
    answer_e: '110 км/ч',
  },
  {
    id: 733,
    alias: 'ticket733',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-7',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Как следует поступить, если невозможно обеспечить безопасность на месте происшествия?',
    answer_a:
      'Соблюдая осторожность, оказать помощь всем пострадавшим.',
    answer_b:
      'Оказать помощь пострадавшему, находящемуся к Вам ближе всех.',
    answer_c:
      'Не подходить, немедленно сообщить о случившемся и не разрешать так же посторонним лицам подходить к месту происшествия.',
    answer_d:
      'Не подходить к месту происшествия, попросить других лиц оказать помощь пострадавшим.',
    answer_e: '',
  },
  {
    id: 552,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '1367317421-3.jpeg',
    image_original: '1367237874-48.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-45',
    created_at: null,
    updated_at: '2020-03-19 23:19:07',
    hint_for_correct_answer: '',
    question:
      'Что обозначает буква «А» , нанесенная на полосе проезжей части?',
    answer_a: 'Номер дороги (маршрута).',
    answer_b:
      'Специальную полосу, предназначенную для движения транспортных средств общего пользования.',
    answer_c:
      'Специальную полосу, предназначенную для движения транспортных средств категории «А».',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 407,
    alias: 'ticket407',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367006594-36.jpeg',
    image_original: '1367006594-53.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-13',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a: 'Мотоцикл, автомобиль, трамвай.',
    answer_b: 'Трамвай, автомобиль, мотоцикл.',
    answer_c: 'Трамвай, мотоцикл, автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 209,
    alias: 'ticket209',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_5',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      "В соответствии с законом РА «Об обеспечении безопасности дорожного движения'',,Вынужденная остановка'' это:",
    answer_a:
      'Прекращение движения, связанное с неожиданным включением запрещающего сигнала светофора.',
    answer_b:
      'Прекращение движения, из-за образовавшегося на дороге затора.',
    answer_c:
      'Приведение транспортного средства в состояние покоя, из-за его неисправности, физического и (или) душевного состояния водителя (пассажира), и (или) опасности, обус ловленной перевозимым грузом или появлением на дороге иного препятствия.',
    answer_d: 'Все перечисленные случаи.',
    answer_e: '',
  },
  {
    id: 334,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      '2f2b265625d76a6704b08093c652fd79_1583953864.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-20',
    created_at: null,
    updated_at: '2020-03-11 23:11:04',
    hint_for_correct_answer: '',
    question:
      'Какой знак указывает участок дороги с односторонним движением?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 751,
    alias: 'ticket751',
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-25',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Для проверки кровообращения в конечностях пострадавшего Вы нажимаете и отпускаете ноготь на пальце травмированной конечности и приходите к выводу, что кровообращение нарушено, так как:',
    answer_a: 'Пострадавший чувствует боль.',
    answer_b: 'Пострадавшего что-то беспокоит.',
    answer_c: 'Место нажатия под ногтем белеет с трудом.',
    answer_d: 'Место нажатия под ногтем вновь розовеет.',
    answer_e: '',
  },
  {
    id: 456,
    alias: 'ticket456',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367225177-31.jpeg',
    image_original: '1367225177-51.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-1',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Движение запрещено:',
    answer_a: 'Красному и белому автомобилям.',
    answer_b: 'Синему, зеленому и белому автомобилям.',
    answer_c: 'Белому, синему и желтому автомобилям.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 644,
    alias: 'ticket644',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367318578-68.png',
    image_original: '1367318578-82.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-9',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На каком рисунке водитель подает сигнал предупреждения о повороте налево:',
    answer_a: 'Первый',
    answer_b: 'Второй',
    answer_c: 'Третий',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 237,
    alias: 'ticket237',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_33',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Легковой автомобиль» , это:',
    answer_a:
      'Автомобиль, имеющий не более 8-и пассажирских мест для сидения и своей конструкцией и оборудованием предназначенный для безопасной перевозки пассажиров и багажа.',
    answer_b:
      'Автомобиль, имеющий не более 4-х пассажирских мест для сидения (без учета мест для детей до 12-ти летнего возраста), своей конструкцией и оборудованием предназначенный для безопасной перевозки пассажиров и багажа.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 682,
    alias: 'ticket682',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-47',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На автомагистралях движение транспортных средств, скорость которых по технической характеристике или состоянию менее 40 км/ч:',
    answer_a:
      'Разрешается только по крайней правой полосе.',
    answer_b: 'Запрещается.',
    answer_c:
      'Разрешается при отсутствии знака “Ограничение минимальной скорости».',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 495,
    alias: 'ticket495',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367231031-12.jpeg',
    image_original: '1367231031-29.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-40',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Движение разрешено:',
    answer_a: 'Красному автомобилю.',
    answer_b: 'Мотоциклу.',
    answer_c: 'Трамваю и красному автомобилю.',
    answer_d: 'Трамваю.',
    answer_e: 'Синему автомобилю.',
  },
  {
    id: 686,
    alias: 'ticket686',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-51',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На транспортном средстве аварийная световая сигнализация должна быть включена:',
    answer_a: 'При ослеплении водителя светом фар.',
    answer_b:
      'При буксировке (на буксируемом механическом транспортном средстве).',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 175,
    alias: 'ticket175',
    position: 0,
    correct_answer: 'answer_a',
    image: '1370591980-85.jpeg',
    image_original: '1366747169-62.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_33',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства должен уступить дорогу? ',
    answer_a: 'Водитель легкового автомобиля.',
    answer_b: 'Водитель грузового автомобиля.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 723,
    alias: 'ticket723',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367320025-6.jpeg',
    image_original: '1367320025-69.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-87',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли проехать железнодорожный переезд в данной ситуации?',
    answer_a: 'Разрешается, если не приближается поезд.',
    answer_b: 'Разрешается.',
    answer_c: 'Запрещается.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 603,
    alias: 'ticket603',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-30',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Груз размещается и при необходимости закрепляется на транспортном средстве так, чтобы он:',
    answer_a: 'Не выступал выше бортов платформы.',
    answer_b:
      'Не создавал шума, не поднимал пыли и не загрязнял окружающую среду.',
    answer_c:
      'Не выступал за габариты транспортного средства сзади более чем на 0.8 м.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 633,
    alias: 'ticket633',
    position: 0,
    correct_answer: 'answer_e',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-60',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой максимальной скоростью разрешается движение междугородним автобусам на автомагистралях?',
    answer_a: '70 км/ч.',
    answer_b: '80 км/ч.',
    answer_c: '110 км/ч.',
    answer_d: '100 км/ч.',
    answer_e: '90 км/ч.',
  },
  {
    id: 627,
    alias: 'ticket627',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367316796-73.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-54',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На автомобильных дорогах, обозначенных этим знаком, водители междугородних автобусов имеют право двигаться со скоростью не более чем:',
    answer_a: '60 км/ч.',
    answer_b: '80 км/ч.',
    answer_c: '90 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 404,
    alias: 'ticket404',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367005707-94.jpeg',
    image_original: '1367005708-11.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-10',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Последним проедет перекресток:',
    answer_a: 'Синий автомобиль.',
    answer_b: 'Желтый автомобиль.',
    answer_c: 'Зеленый автомобиль.',
    answer_d: 'Красный автомобиль.',
    answer_e: '',
  },
  {
    id: 147,
    alias: 'ticket147',
    position: 6,
    correct_answer: 'answer_a',
    image: '1370521518-19.jpeg',
    image_original: '1366715270-79.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_5',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли повернуть во двор в этом месте?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 244,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_40',
    created_at: null,
    updated_at: '2020-03-18 16:24:19',
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении без опасности дорожного движения» в подразделениях Дорожной полиции кандидат в водители допускается к экзаменам по практическому вождению, если ему исполнилось:',
    answer_a: '15 лет.',
    answer_b: '16 лет.',
    answer_c: '17 лет.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 463,
    alias: 'ticket463',
    position: 4,
    correct_answer: 'answer_b',
    image: '1367225408-17.jpeg',
    image_original: '1367225408-34.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-8',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Этот сигнал регулировщика означает, что:',
    answer_a:
      'Разрешено движение синему, зеленому автомобилям. Запрещено красному, желтому, белому.',
    answer_b:
      'Разрешено движение синему, красному, зеленому автомобилям. Запрещено желтому, белому.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 489,
    alias: 'ticket489',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367230830-26.jpeg',
    image_original: '1367230830-41.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-34',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Первым проедет перекресток:',
    answer_a: 'Красный автомобиль.',
    answer_b: 'Синий автомобиль.',
    answer_c: 'Зеленый автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 581,
    alias: 'ticket581',
    position: 4,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-8',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Движение грузовых автомобилей с разрешенной максимальной массой не более 3,5 т вне населенных пунктов разрешается со скоростью?',
    answer_a: 'Не более 90 км/ч.',
    answer_b: 'Не более 70 км/ч.',
    answer_c: 'Не более 80 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 579,
    alias: 'ticket579',
    position: 6,
    correct_answer: 'answer_c',
    image: '1367316628-49.jpeg',
    image_original: '1367261446-43.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-6',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'В каком направлении разрешено движение?',
    answer_a: 'Только прямо.',
    answer_b: 'Прямо и направо.',
    answer_c: 'Прямо, направо и налево.',
    answer_d: 'Во всех направлениях.',
    answer_e: '',
  },
  {
    id: 240,
    alias: 'ticket240',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_36',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» международное водительское удостоверение на право управления транспортными средствами категории «А» и «В» может быть выдано:',
    answer_a: 'Лицам, достигшим 16-летнего возраста.',
    answer_b: 'Лицам, достигшим 17-летнего возраста.',
    answer_c: 'Лицам, достигшим 18-летнего возраста.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 164,
    alias: 'ticket164',
    position: 0,
    correct_answer: 'answer_a',
    image: '1370591095-82.jpeg',
    image_original: '1366746520-54.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_22',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли водителю красного автомобиля двигаться по трамвайным путям?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 153,
    alias: 'ticket153',
    position: 0,
    correct_answer: 'answer_b',
    image: '1370588079-43.jpeg',
    image_original: '1366715703-39.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_11',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком ответе правильно указано разрешенное направление движения?',
    answer_a: 'Прямо и налево во двор.',
    answer_b: 'Только прямо.',
    answer_c: 'Только разворот.',
    answer_d: 'Прямо и разворот.',
    answer_e: '',
  },
  {
    id: 502,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image:
      'b5b41fac0361d157d9673ecb926af5ae_1585128261.jpeg',
    image_original: '1367231288-6.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-47',
    created_at: null,
    updated_at: '2020-03-25 13:24:21',
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a: 'Трамвай, легковой автомобиль, автобус.',
    answer_b: 'Легковой автомобиль, трамвай, автобус.',
    answer_c: 'Легковой автомобиль, автобус, трамвай.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 685,
    alias: 'ticket685',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-50',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На каком расстоянии от транспортного средства устанавливают знак »Аварийная остановка»?',
    answer_a:
      'В населенных пунктах- не менее чем за 15 м, вне населенных пунктов - 30 м.',
    answer_b:
      'В населенных пунктах- не менее чем за 10 м, вне населенных пунктов - 20 м.',
    answer_c:
      'В населенных пунктах- не менее чем за 5 м, вне населенных пунктов - 10 м.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 595,
    alias: 'ticket595',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-22',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При буксировке прикрепленных друг к другу механических транспортных средств скорость движения не должна превышать:',
    answer_a: '30 км/ч.',
    answer_b: '40 км/ч.',
    answer_c: '50 км/ч.',
    answer_d: '60 км/ч.',
    answer_e: '70 км/ч.',
  },
  {
    id: 254,
    alias: 'ticket254',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_50',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» водительское удостоверение на право управления транспортными средствами категории «D» и подкатегории «D1» может быть выдано лицам, которые имеют:',
    answer_a:
      'Водительское удостоверение категории » В» или » С» , или подкатегории » С1» и им исполнился 21 год.',
    answer_b:
      'Водительское удостоверение категории » В» или подкатегории » В1» и им исполнилось 18 лет.',
    answer_c:
      'Водительское удостоверение категории » АВ» или подкатегории » А1В1» и им исполнилось 18 лет.',
    answer_d:
      'Водительское удостоверение категории » В» или » С» , или подкатегории » С1» и им исполнилось 20 лет.',
    answer_e: '',
  },
  {
    id: 322,
    alias: null,
    position: 2,
    correct_answer: 'answer_c',
    image:
      '5737c6ec2e0716f3d8a7a5c4e0de0d9a_1583953143.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-8',
    created_at: null,
    updated_at: '2020-03-11 22:59:03',
    hint_for_correct_answer: '',
    question:
      'Какой знак обязывает уступить дорогу встречным транспортным средствам, находящимся на узком участке или противоположном подъезде к нему?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 725,
    alias: 'ticket725',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367320102-85.jpeg',
    image_original: '1367320102-92.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-89',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком месте разрешается начать обгон в данной ситуации?',
    answer_a: 'На железнодорожном проезде.',
    answer_b: 'После железнодорожного проезда.',
    answer_c: 'Через 100 м после железнодорожного проезда.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 444,
    alias: null,
    position: 1,
    correct_answer: 'answer_b',
    image: '1367009157-09.jpeg',
    image_original: '1367009157-26.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-50',
    created_at: null,
    updated_at: '2020-03-19 11:06:45',
    hint_for_correct_answer: '',
    question:
      'Какое транспортное средство должно уступить дорогу?',
    answer_a: 'Синий автомобиль.',
    answer_b: 'Красный автомобиль.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 289,
    alias: 'ticket289',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_34',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'В автобусе отсутствует знак «Аварийная остановка».',
    answer_b:
      'Сзади установлены фонари освещения учетного номерного знака с огнями белого цвета.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 625,
    alias: 'ticket625',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367316763-26.jpeg',
    image_original: '1367261683-84.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-52',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой скоростью может продолжать движение водитель автобуса по полосе, обозначенной данным знаком?',
    answer_a: 'Менее 60 км/ч.',
    answer_b: 'Не менее 60 км/ч, но не более 70 км/ч.',
    answer_c: 'Не менее 60 км/ч, но не более 90 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 145,
    alias: 'ticket145',
    position: 8,
    correct_answer: 'answer_b',
    image: '1370517109-66.jpeg',
    image_original: '1366716454-47.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_3',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Из какой полосы следует поворачивать направо в показанной ситуации?',
    answer_a: 'Только из второй полосы.',
    answer_b:
      'Только из крайней правой полосы, обозначенной разметкой »A».',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 622,
    alias: 'ticket622',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367316692-67.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-49',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой максимальной скоростью разрешается движение междугородних автобусов на автомобильных дорогах, обозначенных этим знаком.',
    answer_a: '70 км/ч.',
    answer_b: '90 км/ч.',
    answer_c: '110 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 519,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '1367236807-21.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-12',
    created_at: null,
    updated_at: '2020-03-19 22:01:48',
    hint_for_correct_answer: '',
    question:
      'Эта горизонтальная дорожная разметка обозначает:',
    answer_a:
      'Сужение проезжей части, где уменьшается количество полос движения в данном направлении.',
    answer_b:
      'Место, где водитель должен при необходимости остановиться, уступая дорогу транспортным средствам, движущимся по пересекаемой дороге.',
    answer_c:
      'Приближение к месту, где запрещена остановка.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 754,
    alias: 'ticket754',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-28',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'После наезда автомобиля на столб оборвавшийся электрический провод лежит на находящемся без сознания пострадавшем. При оказании помощи, в первую очередь следует:',
    answer_a: 'Оттащить пострадавшего от источника тока.',
    answer_b: 'Провести первичное обследование.',
    answer_c:
      'С помощью какого-либо изолирующего предмета удалить провод с пострадавшего.',
    answer_d:
      'Найти места входа и выхода электрического тока (места ожога) на теле пострадавшего.',
    answer_e: '',
  },
  {
    id: 216,
    alias: 'ticket216',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_12',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» со дня приобретения транспортое средство должно быть представлено для постановки на регистрации в органы Дорожной полиции:',
    answer_a: 'В течение 15 дней.',
    answer_b: 'В течение 10 дней.',
    answer_c: 'В течение 20 дней.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 522,
    alias: 'ticket522',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367317014-43.jpeg',
    image_original: '1367236877-48.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-15',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что означает эта разметка?',
    answer_a: 'Пешеходный переход.',
    answer_b:
      'Место, где велосипедная дорожка пересекает проезжую часть.',
    answer_c: 'Место перегона скота.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 748,
    alias: 'ticket748',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-22',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Оказывая помощь пострадавшему, при подозрении внутреннего кровоизлияния в брюшной полости, необходимо:',
    answer_a:
      'Уложить пострадавшего и наложить холодную примочку.',
    answer_b: 'Положить на живот горячую грелку.',
    answer_c: 'Наложить на брюшную полость тугую повязку.',
    answer_d: 'Пострадавшему дать обильное питье.',
    answer_e: '',
  },
  {
    id: 176,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image:
      '38af86134b65d0f10fe33d30dd76442e_1584738714.jpeg',
    image_original: '1366747265-75.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_34',
    created_at: null,
    updated_at: '2020-03-21 01:11:54',
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства должен уступить дорогу?',
    answer_a: 'Водитель автобуса.',
    answer_b: 'Водитель автомобиля.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 197,
    alias: 'ticket197',
    position: 0,
    correct_answer: 'answer_b',
    image: '1370669341-01.jpeg',
    image_original: '1366748741-12.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_55',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какому транспортному средству Вы должны уступить дорогу, если намерены совершить разворот на перекрестке?',
    answer_a: 'Легковому автомобилю.',
    answer_b: 'Всем транспортным средствам.',
    answer_c: 'Грузовому автомобилю.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 481,
    alias: 'ticket481',
    position: 6,
    correct_answer: 'answer_b',
    image: '1367230601-81.jpeg',
    image_original: '1367230601-97.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-26',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Движение запрещено:',
    answer_a: 'Зеленому и белому автомобилям.',
    answer_b: 'Белому, синему и зеленому автомобилям.',
    answer_c: 'Белому и желтому автомобилям.',
    answer_d: 'Зеленому и желтому автомобилям.',
    answer_e: '',
  },
  {
    id: 576,
    alias: 'ticket576',
    position: 9,
    correct_answer: 'answer_b',
    image: '1367261414-66.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-3',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На каком расстоянии до начала опасного участка устанавливается этот предупреждающий знак вне населенных пунктов?',
    answer_a: '50 - 100 м.',
    answer_b: '150 - 300 м.',
    answer_c: '300 - 500 м.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 683,
    alias: 'ticket683',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-48',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На транспортном средстве аварийная световая сигнализация должна быть включена:',
    answer_a: 'При дорожно-транспортном происшествии.',
    answer_b:
      'При вынужденной остановке в местах, где остановка запрещена.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 286,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_31',
    created_at: null,
    updated_at: '2020-03-18 17:25:07',
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Суммарный люфт в рулевом управлении легкового автомобиля превышает 10 градусов.',
    answer_b:
      'Отсутствуют предусмотренные конструкцией грязезащитные фартуки и брызговики.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 354,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image:
      '8dd48d6a2e2cad213179a3992c0be53c_1583955154.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-40',
    created_at: null,
    updated_at: '2020-03-11 23:32:34',
    hint_for_correct_answer: '',
    question:
      'Какой знак указывает направление движения на Т-образном перекрестке?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 561,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image: '1367318181-86.jpeg',
    image_original: '1367238803-27.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-54',
    created_at: null,
    updated_at: '2020-03-19 23:25:05',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли водителю междугороднего автобуса останавливаться в данном месте с целью посадки пассажиров?',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 632,
    alias: 'ticket632',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367261834-34.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-59',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С какой максимальной скоростью разрешается движение автобусов на участках дорог, обозначенных таким дорожным знаком?',
    answer_a: '70 км/ч.',
    answer_b: '80 км/ч.',
    answer_c: '90 км/ч.',
    answer_d: '100 км/ч.',
    answer_e: '110 км/ч.',
  },
  {
    id: 655,
    alias: 'ticket655',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-20',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель транспортного средства с включенными маячками бело-лунного цвета подает специальный звуковой сигнал, чтобы:',
    answer_a:
      'Получить преимущество в движении перед другими участниками движения.',
    answer_b:
      'Привлечь внимание служащих полиции и других лиц.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 515,
    alias: 'ticket515',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367236612-64.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-8',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Где наносится сплошная желтая линия, обозначающая места, запрещающие остановки и стоянки?',
    answer_a: 'На проезжей части.',
    answer_b: 'У края проезжей части.',
    answer_c:
      'У края проезжей части или по верху бордюров.',
    answer_d: 'Только по верху бордюра.',
    answer_e: '',
  },
  {
    id: 647,
    alias: 'ticket647',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-12',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При приближении транспортного средства с включенными проблесковым маячком синего цвета и специальным звуковым сигналом водители обязаны:',
    answer_a:
      'Уступить дорогу для обеспечения беспрепятственного проезда указанного транспортного средства.',
    answer_b:
      'Снизить скорость и уступить дорогу для обеспечения беспрепятственного проезда указанного транспортного средства.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 562,
    alias: 'ticket562',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367318200-79.jpeg',
    image_original: '1367238835-82.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-55',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Имеет ли право водитель туристического автобуса на стоянку в данном месте с целью длительного отдыха?',
    answer_a: 'Не имеет право.',
    answer_b: 'Имеет право.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 157,
    alias: 'ticket157',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366715853-51.png',
    image_original: '1366715854-18.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_15',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На каком рисунке водитель правильно выполняет маневр?',
    answer_a: 'Первый',
    answer_b: 'Второй',
    answer_c: 'Третий',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 168,
    alias: 'ticket168',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_26',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При одновременном перестроении попутно движущихся транспортных средств дорогу должен уступить водитель:',
    answer_a:
      'Водитель транспортного средства, находящийся слева.',
    answer_b:
      'Водитель транспортного средства, находящийся справа.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 356,
    alias: null,
    position: 0,
    correct_answer: 'answer_d',
    image:
      '6c524f9d5d7027454a783c841250ba71_1583955231.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-42',
    created_at: null,
    updated_at: '2020-03-11 23:33:51',
    hint_for_correct_answer: '',
    question:
      'Действие какого знака не распространяется на транспортные средства общего пользования?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 425,
    alias: 'ticket425',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367007314-57.jpeg',
    image_original: '1367007314-73.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-31',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Красный автомобиль проедет перекресток:',
    answer_a: 'Первым.',
    answer_b: 'Вторым.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 629,
    alias: 'ticket629',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-56',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли перевозка пассажиров в буксируемом автобусе?',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается, при жесткой сцепке.',
    answer_c: 'Разрешается.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 729,
    alias: 'ticket729',
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-3',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Как надо поступить оказывая помощь при ожогах?',
    answer_a: 'Оставить место ожога открытым.',
    answer_b:
      'Вскрыть волдыри с жидкостью, после чего туго перевязать.',
    answer_c: 'Смазать место ожога растительным маслом.',
    answer_d:
      'Охладить место ожога водой, после чего накрыть стерильной перевязочной материей или чистой тканью.',
    answer_e: '',
  },
  {
    id: 423,
    alias: 'ticket423',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367007214-05.jpeg',
    image_original: '1367007214-21.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-29',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Вторым проедет перекресток:',
    answer_a: 'Красный автомобиль.',
    answer_b: 'Синий автомобиль.',
    answer_c: 'Зеленый автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 150,
    alias: 'ticket150',
    position: 3,
    correct_answer: 'answer_a',
    image: '1370588353-77.jpeg',
    image_original: '1366715529-02.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_8',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'В каком направлении запрещено движение?',
    answer_a: 'Налево и направо.',
    answer_b: 'Прямо и в обратном направлении.',
    answer_c: 'Только прямо.',
    answer_d: 'Во всех направлениях.',
    answer_e: '',
  },
  {
    id: 601,
    alias: 'ticket601',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-28',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли буксировка мотоциклов с боковым прицепом?',
    answer_a: 'Разрешается-только на жесткой сцепке.',
    answer_b: 'Запрещается.',
    answer_c: 'Разрешается.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 758,
    alias: 'ticket758',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-32',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Если пострадавший находится в бессознательном состоянии, следует:',
    answer_a:
      'Обеспечить пострадавшему положение полусидя.',
    answer_b: 'Уложить и приподнять ноги.',
    answer_c: 'Уложить и согнуть ноги в коленных суставах.',
    answer_d: 'Уложить и приподнять голову.',
    answer_e: '',
  },
  {
    id: 665,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image: '1367318924-14.jpeg',
    image_original: '1367318924-2.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-30',
    created_at: null,
    updated_at: '2020-03-20 13:36:08',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли обгонять автобус в этом месте?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 379,
    alias: 'ticket379',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366971744-86.jpeg',
    image_original: '1366971745-04.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-65',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Обязан ли в данной ситуации водитель уступить дорогу грузовому автомобилю?',
    answer_a: 'Обязан.',
    answer_b: 'Не обязан.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 706,
    alias: 'ticket706',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-71',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Обязан ли водитель включить указатель поворота перед началом движения в населенной зоне?',
    answer_a: 'Не обязан.',
    answer_b: 'Обязан.',
    answer_c:
      'Обязан, при наличии других транспортных средств.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 540,
    alias: null,
    position: 0,
    correct_answer: 'answer_e',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-33',
    created_at: null,
    updated_at: '2020-03-19 23:03:20',
    hint_for_correct_answer: '',
    question:
      'На каком расстоянии от «Стоп-линии» или знака «Движение без остановки запрещено» должен остановиться водитель для пропуска приближающегося поезда?',
    answer_a: '1,5 м.',
    answer_b: '2,5 м.',
    answer_c: '5 м.',
    answer_d: '10 м.',
    answer_e:
      'Непосредственно у «Стоп-Линии» и (или) знака.',
  },
  {
    id: 207,
    alias: 'ticket207',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_3',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» водительское удостоверение на право управления транспортными средствами категории «E» может быть выдано лицам, достигшим:',
    answer_a: '17 - летнего возраста.',
    answer_b: '18 - летнего возраста.',
    answer_c: '19 - летнего возраста.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 626,
    alias: 'ticket626',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367316781-89.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-53',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На автомобильных дорогах, обозначенных этим знаком водители междугородних автобусов имеют право двигаться со скоростью не более чем:',
    answer_a: '60 км/ч.',
    answer_b: '80 км/ч.',
    answer_c: '90 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 273,
    alias: 'ticket273',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_18',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'На мотоцикле с боковым прицепом отсутствует медицинская аптечка.',
    answer_b:
      'Неисправно опорно-сцепное устройство тягача.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 461,
    alias: 'ticket461',
    position: 6,
    correct_answer: 'answer_d',
    image: '1367225328-31.jpeg',
    image_original: '1367225328-46.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-6',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком ответе названы транспортные средства, которым разрешено движение?',
    answer_a: 'Мотоцикл.',
    answer_b: 'Грузовой автомобиль.',
    answer_c: 'Автобус.',
    answer_d: 'Легковой автомобиль.',
    answer_e: 'Легковой и грузовой автомобили.',
  },
  {
    id: 220,
    alias: 'ticket220',
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_16',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» водитель транспортного средства, имеющего отношение к дорожно-транспортному происшествию, обязан:',
    answer_a:
      'Незамедлительно остановить транспортное средство.',
    answer_b: 'Включить аварийную сигнализацию.',
    answer_c: 'О происшествии сообщить в полицию.',
    answer_d: 'Совершить все перечисленные действия.',
    answer_e: '',
  },
  {
    id: 531,
    alias: 'ticket531',
    position: 2,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-24',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Стоянка запрещена:',
    answer_a: 'На мостах, эстакадах и путепроводах.',
    answer_b: 'Под мостами, эстакадами и путепроводами.',
    answer_c: 'Во всех перечисленных случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 677,
    alias: 'ticket677',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-42',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком месте разрешается пересекать железнодорожные линии?',
    answer_a:
      'Там, где видимость с обоих сторон менее 1000 м.',
    answer_b:
      'По усмотрению водителя в удобном для него месте.',
    answer_c: 'В предусмотренном для этого месте.',
    answer_d:
      'На расстоянии менее 1000 м от железнодорожных вокзалов.',
    answer_e: '',
  },
  {
    id: 353,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image:
      '138bb0696595b338afbab333c555292a_1583955078.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-39',
    created_at: null,
    updated_at: '2020-03-11 23:31:18',
    hint_for_correct_answer: '',
    question:
      'Какой из указанных знаков обозначает конец зоны запрещения обгона?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 637,
    alias: 'ticket637',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-2',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Когда должен быть подан предупредительный сигнал перед перестроением?',
    answer_a:
      'Непосредственно перед началом выполнения маневра.',
    answer_b: 'Сразу после начала выполнения маневра.',
    answer_c:
      'Заблаговременно до начала выполнения маневра.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 378,
    alias: 'ticket378',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366971704-06.jpeg',
    image_original: '1366971704-23.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-64',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Данный дорожный знак показывает, что?',
    answer_a:
      'На перекрестке следует двигаться налево или направо.',
    answer_b:
      'На пересекаемой дороге организовано реверсивное движение.',
    answer_c:
      'На пересекаемой дороге организовано одностороннее движение.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 149,
    alias: 'ticket149',
    position: 4,
    correct_answer: 'answer_c',
    image: '1370587690-67.jpeg',
    image_original: '1366715469-96.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_7',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком ответе правильно указано разрешенное направление движения?',
    answer_a: 'Только разворот.',
    answer_b: 'Прямо и разворот.',
    answer_c: 'Только прямо.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 557,
    alias: 'ticket557',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367318102-81.jpeg',
    image_original: '1367238691-73.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-50',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель автобуса совершил остановку для посадки пассажиров. Легковой автомобиль движется со скоростью 70 км/ч. Водитель какого транспортного средства нарушил требования правил дорожного движения?',
    answer_a: 'Никто.',
    answer_b: 'Водитель автобуса.',
    answer_c: 'Водитель легкового автомобиля.',
    answer_d: 'Оба водителя.',
    answer_e: '',
  },
  {
    id: 550,
    alias: 'ticket550',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-43',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Если движение через железнодорожный переезд запрещено и на нем отсутствуют светофор, дорожные знаки и разметка, то водитель должен остановиться:',
    answer_a: 'Не ближе 5 метров от шлагбаума.',
    answer_b: 'Не ближе 3 метров от шлагбаума.',
    answer_c: 'Непосредственно перед шлагбаумом.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 630,
    alias: 'ticket630',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-57',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При буксировке на буксируемом транспортном средстве должны быть включены:',
    answer_a: 'Дальний свет фар.',
    answer_b: 'Ближний свет фар.',
    answer_c: 'Аварийная световая сигнализация.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 416,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '1367006986-02.jpeg',
    image_original: '1367006986-18.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-22',
    created_at: null,
    updated_at: '2020-03-19 10:04:42',
    hint_for_correct_answer: '',
    question: 'Красный автомобиль:',
    answer_a:
      'Имеет преимущество в движении, т.к. приблизился к перекрестку с круговым движением с правой стороны синего автомобиля.',
    answer_b:
      'Должен пропустить синий автомобиль, движущийся по дороге с круговым движением.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 513,
    alias: 'ticket513',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367316971-06.jpeg',
    image_original: '1367236575-02.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-6',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'О чем предупреждает разметка в виде стрелок на проезжей части?',
    answer_a:
      'Предупреждают водителя о приближении к опасному участку дороги.',
    answer_b:
      'Предупреждают о приближении к концу полосы движения.',
    answer_c:
      'Указывают направление опасного поворота дороги.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 727,
    alias: 'ticket727',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-1',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Во время движения водитель внезапно начинает жаловаться на сильную давящую боль в грудной клетке и затруднённое дыхание. Как надо поступить?',
    answer_a:
      'Предложить ему обратиться в ближайшую больницу.',
    answer_b:
      'Дать ему 2 таблетки валерианы и стакан воды.',
    answer_c:
      'Предложить незамедлительно остановить транспортное средство и включить аварийную сигнализацию.',
    answer_d:
      'Посоветовать ему пройтись и подышать свежим воздухом.',
    answer_e: '',
  },
  {
    id: 524,
    alias: 'ticket524',
    position: 9,
    correct_answer: 'answer_c',
    image: '1367236943-65.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-17',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что означает эта разметка?',
    answer_a:
      'Полосу для движения транспортных средств общего пользования.',
    answer_b: 'Полосу движения специальных автомобилей.',
    answer_c:
      'Обозначает границы полос движения, на которых осуществляется реверсивное регулирование.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 612,
    alias: 'ticket612',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-39',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Перевозка людей запрещается, если:',
    answer_a:
      'Число пассажиров в салоне автобуса, движущегося по туристическим маршрутам, превышает число мест, оборудованных для сидения.',
    answer_b:
      'Число пассажиров в салоне междугороднего автобуса превышает число мест, оборудованных для сидения.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 717,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '1367319587-79.jpeg',
    image_original: '1367319587-85.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-82',
    created_at: null,
    updated_at: '2020-03-20 17:30:28',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли водителю грузового автомобиля обгонять автобус, двигающийся со скоростью 60 км/ч?',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 437,
    alias: 'ticket437',
    position: 8,
    correct_answer: 'answer_b',
    image: '1367008712-92.jpeg',
    image_original: '1367008713-09.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-43',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Автомобили проедут перекресток в следующем порядке:',
    answer_a: 'Синий, зеленый, красный.',
    answer_b: 'Красный, синий, зеленый.',
    answer_c: 'Зеленый, красный, синий.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 523,
    alias: 'ticket523',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367236921-69.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-16',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Где должен водитель остановить транспортное средство при наличии этой разметки?',
    answer_a: 'У данной разметки.',
    answer_b: 'На данной разметке.',
    answer_c: 'Не ближе 5 метров перед данной разметкой.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 726,
    alias: 'ticket726',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367320135-61.jpeg',
    image_original: '1367320135-66.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-90',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли совершить обгон в данной ситуации?',
    answer_a:
      'Разрешается, поскольку нет встречного транспортного средства.',
    answer_b: 'Запрещается.',
    answer_c:
      'Разрешается, если гужевая повозка движется со скоростью менее 30 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 452,
    alias: 'ticket452',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367010175-39.jpeg',
    image_original: '1367010175-54.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-58',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Легковой автомобиль проедет перекресток:',
    answer_a: 'Первым.',
    answer_b: 'Вторым, после автобуса.',
    answer_c: 'Третьим.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 370,
    alias: 'ticket370',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366966482-29.jpeg',
    image_original: '1366966482-46.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-56',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Как должен поступить водитель в данной ситуации?',
    answer_a: 'Продолжать движение по прямой.',
    answer_b:
      'Перестроиться на полосу встречного движения.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 470,
    alias: 'ticket470',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367230230-95.jpeg',
    image_original: '1367230231-17.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-15',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Каким транспортным средствам разрешено движение?',
    answer_a: 'Желтому и красному автомобилям.',
    answer_b: 'Зеленому, красному и белому автомобилям.',
    answer_c: 'Белому и зеленому автомобилям.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 293,
    alias: 'ticket293',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_38',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a: 'Не работает звуковой сигнал.',
    answer_b:
      'Система охлаждения не обеспечивает стабильный тепловой режим работы двигателя.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 238,
    alias: 'ticket238',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_34',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» к пешеходам приравниваются:',
    answer_a:
      'Инвалиды, передвигающиеся со скоростью пешехода в инвалидных колясках с двигателем.',
    answer_b:
      'Лица, ведущие велосипед, мопед или мотоцикл.',
    answer_c: 'Все перечисленные лица.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 764,
    alias: 'ticket764',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_52',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Начиная с пятого года выпуска автомобиля, второй и каждый следующий технический осмотр транспортного средства проводится следующим интервалом.',
    answer_a: 'Каждые шесть месяцев.',
    answer_b: 'Каждый год.',
    answer_c: 'Два раза в год.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 383,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      'beed13602b9b0e6ecb5b568ff5058f07_1583956240.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-69',
    created_at: null,
    updated_at: '2020-03-11 23:50:40',
    hint_for_correct_answer: '',
    question:
      'Какой дорожный знак принуждает водителя ехать только налево или направо?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 305,
    alias: 'ticket305',
    position: 9,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_50',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация автобусов запрещается, если:',
    answer_a:
      'В автобусе имеются не менее 2 противооткатных упора.',
    answer_b:
      'Сзади установлены светоотражающие приспособления белого цвета.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 424,
    alias: 'ticket424',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367007258-8.jpeg',
    image_original: '1367007258-96.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-30',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства должен уступить дорогу?',
    answer_a: 'Водитель трамвая.',
    answer_b: 'Водитель грузового автомобиля.',
    answer_c: 'Водители обоих автомобилей.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 539,
    alias: 'ticket539',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-32',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В населенных пунктах, на дорогах с одной полосой движения в каждом направлении, при отсутствии трамвайных путей посередине, остановка и стоянка на левой стороне дороги:',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 711,
    alias: 'ticket711',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-76',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Аварийный световой сигнал включается:',
    answer_a: 'Перед въездом в тоннель.',
    answer_b: 'При дорожное транспортном происшествии.',
    answer_c:
      'При движении в составе организованной колонны.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 205,
    alias: 'ticket205',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_1',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» пассажиром является:',
    answer_a:
      'Лицо, кроме водителя и обучающего вождению, находящееся в салоне (кабине) транспортного средства (на нем).',
    answer_b:
      'Лицо, кроме водителя и обучающего вождению, находящееся в салоне (кабине) транспортного средства (на нем), а также лицо, которое входит в транспортное средство (садится на него) или выходит из транспортного средства (сходит с него).',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 222,
    alias: 'ticket222',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_18',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Полоса движения», это:',
    answer_a:
      'Обозначенная разметкой полоса проезжей части, имеющая ширину, достаточную для движения транспортных средств в один ряд.',
    answer_b:
      'Обозначенная или не обозначенная разметкой полоса проезжей части, имеющая ширину, достаточную для движения транспортных средств в один ряд.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 732,
    alias: 'ticket732',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-6',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель продолжительное время, сидя на корточках, заменял колесо автомобиля. Резко привстав, хватается за голову и потеряв сознание, падает. Как следует поступить?',
    answer_a: 'Попытаться посадить его.',
    answer_b: 'Приподнять ноги.',
    answer_c: 'Обрызгать лицо холодной водой.',
    answer_d: 'Дать пощечину.',
    answer_e: '',
  },
  {
    id: 243,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_39',
    created_at: null,
    updated_at: '2020-03-14 20:35:40',
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» международные водительские удостоверения выдаются сроком на:',
    answer_a: '1 год.',
    answer_b: '3 года.',
    answer_c: '5 лет.',
    answer_d: 'Бессрочно.',
    answer_e: '',
  },
  {
    id: 451,
    alias: 'ticket451',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367010127-15.jpeg',
    image_original: '1367010127-33.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-57',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a:
      'Грузовой автомобиль, легковой автомобиль, автобус, автоцистерна.',
    answer_b:
      'Грузовой автомобиль, автобус, легковой автомобиль, автоцистерна.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 712,
    alias: 'ticket712',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367319317-19.jpeg',
    image_original: '1367319317-24.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-77',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'О чем информирует сигнал, поданный рукой водителя мотоцикла?',
    answer_a:
      'Продолжает движение налево или в обратную сторону.',
    answer_b: 'Продолжает движение прямо или направо.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 195,
    alias: 'ticket195',
    position: 0,
    correct_answer: 'answer_a',
    image: '1370668111-72.jpeg',
    image_original: '1366748602-98.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_53',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какому транспортному средству Вы должны уступить дорогу, продолжая движения прямо?',
    answer_a: 'Только легковому автомобилю.',
    answer_b: 'Никому.',
    answer_c: 'Только легковому автомобилю и мотоциклу.',
    answer_d: 'Всем транспортным средствам.',
    answer_e: '',
  },
  {
    id: 144,
    alias: 'ticket144',
    position: 9,
    correct_answer: 'answer_b',
    image: '1370516123-25.jpeg',
    image_original: '1366715147-53.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_2',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли автобусу въезжать на перекресток в данной ситуации?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c:
      'Разрешается, если автобус движется по установленному маршруту.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 258,
    alias: 'ticket258',
    position: 6,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_3',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'В рулевом управлении имеются не предусмотренные конструкцией перемещения деталей и узлов или резьбовые соединения не затянуты.',
    answer_b:
      'В грузовом автомобиле отсутствует огнетушитель.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 566,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image: '1367318294-9.jpeg',
    image_original: '1367238972-29.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-59',
    created_at: null,
    updated_at: '2020-03-19 23:38:13',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли совершать остановку с целью посадки пассажиров в зоне действия указанных дорожных знаков?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 245,
    alias: 'ticket245',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_41',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Обязан ли во время вождения обучающийся вождению пристегнуть ремни безопасности:',
    answer_a: 'Обязан.',
    answer_b: 'Не обязан.',
    answer_c:
      'Не обязан, если это затрудняет вождение автомобиля.',
    answer_d:
      'Не обязан, если разрешает обучающий вождению.',
    answer_e: '',
  },
  {
    id: 259,
    alias: 'ticket259',
    position: 5,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_4',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Не работают в установленном режиме внешние световые приборы.',
    answer_b:
      'Шины мотоцикла имеют остаточную высоту рисунка протектора 0.6 мм.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 344,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image: '1366959146-69.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-30',
    created_at: null,
    updated_at: '2020-03-18 21:33:17',
    hint_for_correct_answer: '',
    question:
      'Таким опознавательным знаком обозначают транспортное средство:',
    answer_a: 'Управляемое инвалидом.',
    answer_b:
      'Перевозящее тяжеловесные и крупногабаритные грузы.',
    answer_c: 'Перевозящее опасные грузы.',
    answer_d:
      'Управляемое глухонемым или глухим водителем.',
    answer_e: '',
  },
  {
    id: 476,
    alias: 'ticket476',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-21',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Если правая рука регулировщика вытянута вперед, то движение безрельсовым транспортным средствам со стороны левого бока разрешено:',
    answer_a: 'Во всех направлениях.',
    answer_b: 'Только налево.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 728,
    alias: 'ticket728',
    position: 0,
    correct_answer: 'answer_d',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-2',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Как надо оказывать помощь пострадавшему при судорожном припадке?',
    answer_a:
      'Удерживать пострадавшего, стараясь ослабить судороги.',
    answer_b:
      'Попытаться раскрыть рот и удерживая язык, вложить какой- нибудь предмет между зубов.',
    answer_c:
      'Попытаться освободить дыхательные пути, приподняв голову пострадавшего.',
    answer_d:
      'Не дотрагиваться до пострадавшего, подождать пока судороги не прекратятся.',
    answer_e: '',
  },
  {
    id: 533,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image: '1367317161-92.jpeg',
    image_original: '1367237308-03.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-26',
    created_at: null,
    updated_at: '2020-03-19 22:11:24',
    hint_for_correct_answer: '',
    question:
      'Действует ли запрещающий знак на тот участок дороги, где остановился водитель?',
    answer_a: 'Действует.',
    answer_b: 'Не действует.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 639,
    alias: 'ticket639',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-4',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Подача водителем предупредительного сигнала рукой прекращается:',
    answer_a:
      'Непосредственно перед началом выполнения маневра.',
    answer_b:
      'Непосредственно после завершения выполнения маневра.',
    answer_c: 'Во время выполнения маневра.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 545,
    alias: 'ticket545',
    position: 0,
    correct_answer: 'answer_e',
    image: '1367317306-7.jpeg',
    image_original: '1367237589-82.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-38',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Остановка запрещена, если расстояние между сплошной линией разметки и остановившимся транспортным средством составляет:',
    answer_a: '6 м.',
    answer_b: '5.5 м.',
    answer_c: '4 м.',
    answer_d: '3.5 м.',
    answer_e: '2.5 м.',
  },
  {
    id: 247,
    alias: 'ticket247',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_43',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Остановка» это:',
    answer_a:
      'Приведение транспортного средства в недвижимое состояние, связанное с требованием пассажира.',
    answer_b:
      'Приведение транспортного средства в недвижимое состояние на время более 5 минут, если это не связано с посадкой или высадкой пассажиров либо загрузкой, разгрузкой транспортного средства.',
    answer_c:
      'Приведение транспортного средства в недвижимое состояние на время до 5 минут и (или) на время, необходимое для посадки или высадки пассажиров либо загрузки или разгрузки транспортного средства.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 658,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-23',
    created_at: null,
    updated_at: '2020-03-20 13:30:08',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли обгон транспортных средств в зоне перекрестка на дороге, являющейся главной по отношению к пересекаемой?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 746,
    alias: 'ticket746',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-20',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Частота дыхания у взрослого человека в состоянии покоя составляет:',
    answer_a: '12-18 дыхательных движений в минуту.',
    answer_b: '20-30 дыхательных движений в минуту.',
    answer_c: '40-60 дыхательных движений в минуту.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 582,
    alias: null,
    position: 3,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-9',
    created_at: null,
    updated_at: '2020-03-20 10:30:28',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли в населенных пунктах водителю междугороднего, межобластного и пригородного автобуса превышать скорость 60 км/ч?',
    answer_a:
      'Разрешается, только при движении по дороге, имеющей две и более полосы для движения в данном направлении.',
    answer_b: 'Разрешается.',
    answer_c: 'Запрещается.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 532,
    alias: 'ticket532',
    position: 1,
    correct_answer: 'answer_b',
    image: '1367237270-58.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-25',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли произвести высадку пассажиров в месте, где нанесена по верху бордюра сплошная желтая линия в сочетании со знаком «Остановка запрещена»?.',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c:
      'Разрешается в отсутствии транспортных средств общего пользования.',
    answer_d:
      'Разрешается только транспортным средствам общего пользования.',
    answer_e: '',
  },
  {
    id: 375,
    alias: 'ticket375',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366966798-03.jpeg',
    image_original: '1366966798-19.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-61',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что показывают данные дорожные знаки?',
    answer_a:
      'Съезжать на обочину опасно в связи с ремонтными работами.',
    answer_b: 'На дороге ведутся ремонтные работы.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 235,
    alias: 'ticket235',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_31',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Темное время суток» , это:',
    answer_a:
      'Промежуток времени суток осенью и зимой - с 20.00 вечера до 8.00 часов утра и весной и летом -с 22.00 до 6.00 часов утра.',
    answer_b:
      'Промежуток времени суток от начала вечерних сумерек до конца утренних сумерек.',
    answer_c:
      'Промежуток времени отсутствии солнечного света.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 427,
    alias: 'ticket427',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367007388-57.jpeg',
    image_original: '1367007388-74.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-33',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства имеет преимущество на первоочередное движение?',
    answer_a: 'Водитель автомобиля.',
    answer_b: 'Водитель велосипеда.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 577,
    alias: 'ticket577',
    position: 8,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-4',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Движение транспортных средств, перевозящих организованные группы детей, разрешается со скоростью:',
    answer_a: 'Не более 60 км/ч.',
    answer_b: 'Не более 70 км/ч.',
    answer_c: 'Не более 80 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 753,
    alias: 'ticket753',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-27',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Кровотечение считается наиболее опасным, если:',
    answer_a: 'Кровь свертывается в течение 10 минут.',
    answer_b: 'Кровь бьет из раны струей.',
    answer_c: 'Кровь тёмно-красного цвета.',
    answer_d: 'Кровь из раны вытекает непрерывно.',
    answer_e: '',
  },
  {
    id: 548,
    alias: 'ticket548',
    position: 0,
    correct_answer: 'answer_d',
    image: '1367317329-61.jpeg',
    image_original: '1367237742-38.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-41',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком ответе указаны все водители, нарушившие правила остановки?',
    answer_a: 'Водитель красного автомобиля и мотоцикла.',
    answer_b: 'Водитель синего автомобиля.',
    answer_c: 'Водитель мотоцикла.',
    answer_d: 'Водители всех транспортных средств.',
    answer_e: '',
  },
  {
    id: 323,
    alias: null,
    position: 1,
    correct_answer: 'answer_e',
    image:
      'bc6dc48b743dc5d013b1abaebd2faed2_1583953238.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-9',
    created_at: null,
    updated_at: '2020-03-11 23:00:38',
    hint_for_correct_answer: '',
    question:
      'Какой знак предупреждает о приближении к перекрестку равнозначных дорог?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 485,
    alias: 'ticket485',
    position: 2,
    correct_answer: 'answer_a',
    image: '1367230731-25.jpeg',
    image_original: '1367230731-4.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-30',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком ответе правильно названы все транспортные средства, которым разрешено движение?',
    answer_a: 'Автомобили и мотоцикл.',
    answer_b: 'Все транспортные средства.',
    answer_c: 'Автомобили и трамвай.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 265,
    alias: 'ticket265',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_10',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Содержание вредных веществ в отработавших газах превышает нормы, установленные законодательством РА.',
    answer_b:
      'На мотоцикле отсутствуют предусмотренные конструкцией подножки.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 527,
    alias: 'ticket527',
    position: 6,
    correct_answer: 'answer_b',
    image: '1367237044-84.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-20',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Что обозначает разметка в виде широкой прерывистой линии?',
    answer_a: 'Границу между проезжей частью и обочиной.',
    answer_b:
      'Границу между полосой разгона и основной полосой проезжей части.',
    answer_c:
      'Границу между полосой торможения и основной полосой проезжей части.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 316,
    alias: null,
    position: 8,
    correct_answer: 'answer_d',
    image:
      '3fe94a002317b5f9259f82690aeea4cd_1584549816.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-2',
    created_at: null,
    updated_at: '2020-03-18 20:46:44',
    hint_for_correct_answer: '',
    question:
      'Какой знак предоставляет водителю преимущество по отношению к встречным транспортным средствам?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 326,
    alias: 'ticket326',
    position: 8,
    correct_answer: 'answer_a',
    image: '1366981750-76.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-12',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что означают эти знаки?',
    answer_a: 'Движение мотоциклов направо запрещено.',
    answer_b: 'Движение мотоциклов направо разрешено.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 346,
    alias: 'ticket346',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366960060-05.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-32',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком случае водитель правильно выполнил требования этого знака?',
    answer_a:
      'Уступил дорогу механическим транспортным средствам, движущимся по пересекаемой дороге.',
    answer_b:
      'Уступил дорогу транспортным средствам, движущимся по пересекаемой дороге.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 719,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image: '1367319748-51.jpeg',
    image_original: '1367319748-58.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-84',
    created_at: null,
    updated_at: '2020-03-20 17:32:39',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли въезжать на железнодорожный переезд в данной ситуации?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 262,
    alias: 'ticket262',
    position: 2,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_7',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'На мотоцикле без бокового прицепа отсутствует знак «Аварийная остановка».',
    answer_b:
      'Шины по размеру или допустимой нагрузке не соответствуют модели транспортного средства.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 440,
    alias: 'ticket440',
    position: 5,
    correct_answer: 'answer_d',
    image: '1367008936-89.jpeg',
    image_original: '1367008937-05.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-46',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Желтый автомобиль проедет перекресток:',
    answer_a: 'Первым.',
    answer_b: 'Вторым.',
    answer_c: 'Третьим.',
    answer_d: 'Последним.',
    answer_e: '',
  },
  {
    id: 276,
    alias: 'ticket276',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_21',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Механическое транспортное средство, используемое для обучения практическому вождению, не оборудовано соответствующим опознавательным знаком.',
    answer_b: 'Не работает указатель уровня топлива.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 457,
    alias: 'ticket457',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367225211-54.jpeg',
    image_original: '1367225211-71.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-2',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Кто из водителей имеет право двигаться в прямом направлении?',
    answer_a: 'Водители автобуса и мотоцикла.',
    answer_b: 'Водители легкового и грузового автомобилей.',
    answer_c: 'Водитель легкового автомобиля.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 395,
    alias: 'ticket395',
    position: 0,
    correct_answer: 'answer_d',
    image: '1367000954-61.jpeg',
    image_original: '1367000954-77.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-1',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Первым проедет перекресток:',
    answer_a: 'Красный автомобиль.',
    answer_b: 'Синий автомобиль.',
    answer_c: 'Желтый автомобиль.',
    answer_d: 'Зеленый автомобиль.',
    answer_e: '',
  },
  {
    id: 516,
    alias: 'ticket516',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367236734-74.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-9',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'С каким дорожным знаком может быть применена разметка в виде желтой прерывистой линии?',
    answer_a: ',,Остановка запрещена» .',
    answer_b: ',,Стоянка запрещена».',
    answer_c:
      ',,Стоянка по нечетным числам месяца запрещена».',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 304,
    alias: 'ticket304',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_49',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация автобусов запрещается, если:',
    answer_a:
      'Сзади установлены светоотражающие приспособления белого цвета.',
    answer_b:
      'Сзади установлены светоотражающие приспособления красного цвета.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 290,
    alias: 'ticket290',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_35',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Шины прицепа легкого автомобиля имеют остаточную высоту рисунка протектора менее 1.6 мм.',
    answer_b:
      'Сзади установлены указатели поворота с огнями оранжевого цвета.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 345,
    alias: null,
    position: 0,
    correct_answer: 'answer_d',
    image:
      'd81f9c1be2e08964bf9f24b15f0e4900_1583954737.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-31',
    created_at: null,
    updated_at: '2020-03-11 23:25:37',
    hint_for_correct_answer: '',
    question:
      'Какой из указанных знаков отменяет все ранее введенные ограничения?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 272,
    alias: 'ticket272',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_17',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'На грузовом автомобиле отсутствует медицинская аптечка.',
    answer_b:
      'Спереди установлены светоотражающие приспособления белого цвета.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 599,
    alias: 'ticket599',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-26',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При буксировке на жесткой сцепке расстояние между транспортными средствами должно быть не более:',
    answer_a: '4 м.',
    answer_b: '5 м.',
    answer_c: '6 м.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 720,
    alias: 'ticket720',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367319927-82.jpeg',
    image_original: '1367319927-92.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-85',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли въезжать на железнодорожный переезд в данной ситуации?',
    answer_a: 'Разрешается, если не приближается поезд.',
    answer_b: 'Разрешается, если открыт шлагбаум.',
    answer_c: 'Запрещается.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 675,
    alias: 'ticket675',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367319055-82.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-40',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На каком расстоянии до начала опасного участка устанавливается этот предупреждающий знак в населенных пунктах?',
    answer_a: '25 - 50 м.',
    answer_b: '50 - 100 м.',
    answer_c: '100 - 150 м.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 297,
    alias: 'ticket297',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_42',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещается, если:',
    answer_a:
      'Не действует манометр пневматического тормозного привода.',
    answer_b:
      'Шины автобусов имеют остаточную высоту рисунка протектора 1.6 мм.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 701,
    alias: 'ticket701',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-66',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водителями транспортных средств общего пользования звуковые сигналы могут применяться:',
    answer_a:
      'Для получения преимущества по отношению к другим участникам дорожного движения.',
    answer_b:
      'В населенных пунктах, для предупреждения других водителей о намерении произвести обгон.',
    answer_c:
      'Когда это необходимо для предотвращения дорожно- транспортного происшествия.',
    answer_d: 'Во всех случаях.',
    answer_e: '',
  },
  {
    id: 167,
    alias: 'ticket167',
    position: 0,
    correct_answer: 'answer_d',
    image: '1370591390-19.jpeg',
    image_original: '1366746644-53.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_25',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водители каких транспортных средств нарушили требования дорожного знака?',
    answer_a: 'Водители мотоциклов.',
    answer_b:
      'Водители автомобиля и мотоцикла с боковым прицепом.',
    answer_c: 'Только водитель автомобиля.',
    answer_d: 'Водители всех транспортных средств.',
    answer_e: '',
  },
  {
    id: 492,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      '55a7cf9c71f1c9c495413f934dd1a158_1584618008.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-37',
    created_at: null,
    updated_at: '2020-03-19 15:40:08',
    hint_for_correct_answer: '',
    question:
      'Данный светофор применяется для регулирования движения:',
    answer_a: 'Трамваев и троллейбусов.',
    answer_b: 'Только трамваев.',
    answer_c:
      'Трамваев, а также других транспортных средств общего пользования по обособленной полосе.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 446,
    alias: 'ticket446',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367009227-52.jpeg',
    image_original: '1367009227-66.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-52',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a:
      'Автобус, легковой автомобиль и грузовой автомобиль одновременно.',
    answer_b:
      'Легковой автомобиль и грузовой автомобиль одновременно, автобус.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 349,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      '0bb4aec1710521c12ee76289d9440817_1583954881.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-35',
    created_at: null,
    updated_at: '2020-03-11 23:28:01',
    hint_for_correct_answer: '',
    question:
      'Какой знак (табличка) указывает способ постановки транспортного средства на стоянку?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 454,
    alias: 'ticket454',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367010270-57.jpeg',
    image_original: '1367010270-74.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-60',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке:',
    answer_a:
      'Грузовой автомобиль, легковой автомобиль, автобус.',
    answer_b:
      'Автобус, грузовой автомобиль, легковой автомобиль.',
    answer_c:
      'Автобус, легковой автомобиль, грузовой автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 587,
    alias: 'ticket587',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-14',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли перевозка людей в буксируемом автомобиле?',
    answer_a: 'Разрешается в автобусе.',
    answer_b: 'Разрешается в легковом автомобиле.',
    answer_c:
      'Разрешается в кузове грузового автомобиля при буксировке на жесткой сцепке.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 755,
    alias: 'ticket755',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-29',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Чтобы обезопасить себя от заражения при оказании первой помощи следует:',
    answer_a:
      'Постараться избежать прямого контакта с раной и помощь оказывать только в стерильных перчатках.',
    answer_b:
      'Не оказывать помощь тем пострадавшим, у которых наблюдается сильное кровотечение.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 300,
    alias: 'ticket300',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_45',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация автобусов запрещается, если:',
    answer_a: 'Отсутствует медицинская аптечка.',
    answer_b:
      'Шины имеют минимальную остаточную высоту рисунка протектора 2.2 мм.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 668,
    alias: 'ticket668',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-33',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком случае на мотоцикле должен быть включен ближний свет фар в светлое время суток?',
    answer_a:
      'При движении в условиях недостаточной видимости.',
    answer_b:
      'На имеющем неисправности мотоцикле, следующего к месту стоянки.',
    answer_c: 'В любом случае, при нахождении в движении.',
    answer_d: 'При перевозке больного пассажира.',
    answer_e: '',
  },
  {
    id: 704,
    alias: 'ticket704',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367319173-58.jpeg',
    image_original: '1367319173-63.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-69',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Имеет ли право водитель междугороднего автобуса совершать обгон мотоцикла, двигающегося со скоростью 70 км/ч?',
    answer_a: 'Не имеет право.',
    answer_b: 'Имеет право.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 678,
    alias: 'ticket678',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-43',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли самовольно открывать шлагбаум или объезжать его при выполнении служебного задания?',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается.',
    answer_c:
      'Разрешается по усмотрению водителя, если вблизи нет приближающего поезда.',
    answer_d:
      'Разрешается при отсутствии дежурного по переезду.',
    answer_e: '',
  },
  {
    id: 248,
    alias: 'ticket248',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_44',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Транспортное средство общего пользования» , это:',
    answer_a:
      'Транспортное средство (трамвай, троллейбус, автобус), перевозящее пассажиров и (или) багаж и движущееся по маршрутам, имеющим места остановки (остановки), а также легковой автомобиль-такси.',
    answer_b:
      'Транспортное средство (трамвай, троллейбус, автобус), перевозящее пассажиров и (или) багаж и движущееся по маршрутам, имеющим места остановки (остановки).',
    answer_c:
      'Транспортное средство, движущееся по туристическим маршрутам и перевозящее пассажиров и (или) багаж.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 278,
    alias: 'ticket278',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_23',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Спереди установлены указатели поворота с огнями желтого цвета.',
    answer_b:
      'Отсутствует хотя бы один болт крепления обода колеса.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 661,
    alias: 'ticket661',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-26',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Обгон запрещен:',
    answer_a: 'На регулируемых перекрестках.',
    answer_b: 'На нерегулируемых перекрестках.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 190,
    alias: 'ticket190',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366748020-84.jpeg',
    image_original: '1366747957-2.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_48',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Обязан ли водитель мотоцикла уступить дорогу в данной ситуации?',
    answer_a: 'Не обязан.',
    answer_b: 'Обязан.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 555,
    alias: 'ticket555',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367318060-54.jpeg',
    image_original: '1367238629-87.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-48',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Такой вертикальной разметкой обозначаются:',
    answer_a: 'Нижний край моста, тоннеля.',
    answer_b: 'Въезд в неосвещенные тоннели.',
    answer_c:
      'Любой элемент дорожных сооружений, который создает опасность для движения.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 218,
    alias: 'ticket218',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_14',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» водитель транспортного средства перед выездом обязан проверить:',
    answer_a:
      'Исправность тормозной системы и рулевого управления транспортного средства.',
    answer_b:
      'Соответствие остаточной высоты рисунка протектора шин транспортного средства установленным нормам.',
    answer_c: 'Все перечисленное.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 560,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image: '1367318160-05.jpeg',
    image_original: '1367238775-18.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-53',
    created_at: null,
    updated_at: '2020-03-19 23:24:49',
    hint_for_correct_answer: '',
    question:
      'Автобус остановился, уступая дорогу пешеходам. Нарушает ли требования правил дорожного движения водитель легкового автомобиля в данной ситуации?',
    answer_a: 'Нарушает.',
    answer_b: 'Не нарушает.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 403,
    alias: 'ticket403',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367005673-24.jpeg',
    image_original: '1367005673-41.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-9',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Вторым проедет перекресток:',
    answer_a: 'Белый автомобиль одновременно с желтым.',
    answer_b: 'Красный автомобиль.',
    answer_c: 'Зеленый автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 169,
    alias: 'ticket169',
    position: 0,
    correct_answer: 'answer_a',
    image: '1370591584-58.jpeg',
    image_original: '1366746735-53.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_27',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства имеет преимущество на первоочередное движение?',
    answer_a: 'Водитель грузового автомобиля.',
    answer_b: 'Водитель автобуса.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 435,
    alias: 'ticket435',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367008596-28.jpeg',
    image_original: '1367007789-46.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-41',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Последним проедет перекресток:',
    answer_a: 'Красный автомобиль.',
    answer_b: 'Синий автомобиль.',
    answer_c: 'Зеленый автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 569,
    alias: 'ticket569',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367318377-96.jpeg',
    image_original: '1367239057-69.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-62',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что обозначает данная дорожная разметка?',
    answer_a: 'Место для посадки-высадки пассажиров.',
    answer_b:
      'Место для остановки транспортных средств общего пользования.',
    answer_c:
      'Место остановки транспортных средств общего пользования и стоянки такси.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 488,
    alias: 'ticket488',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367230800-68.jpeg',
    image_original: '1367230800-83.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-33',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'В каком направлении разрешено движение?',
    answer_a: 'Прямо и направо в первый проезд.',
    answer_b: 'Направо в первый проезд.',
    answer_c: 'Направо во второй проезд.',
    answer_d: 'Направо в первый и второй проезды.',
    answer_e: '',
  },
  {
    id: 699,
    alias: 'ticket699',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-64',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Приближаясь к стоящему транспортному средству с включенным проблесковым маячком красного цвета водители транспортных средств общего пользования, движущихся в данном направлении, обязаны:',
    answer_a:
      'Остановиться и продолжить движение, лишь получив на это разрешение.',
    answer_b:
      'Снизить скорость, чтобы при необходимости иметь возможность незамедлительно остановиться.',
    answer_c:
      'Продолжить движение, поскольку двигаются по установленному маршруту.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 158,
    alias: 'ticket158',
    position: 0,
    correct_answer: 'answer_b',
    image: '1370589726-21.jpeg',
    image_original: '1366715889-06.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_16',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства правильно выполняет разворот?',
    answer_a: 'Водитель синего автомобиля.',
    answer_b: 'Водитель красного автомобиля.',
    answer_c: 'Оба водителя.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 287,
    alias: 'ticket287',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_32',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a: 'Затруднен пуск двигателя.',
    answer_b: 'В автобусе отсутствует медицинская аптечка.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 200,
    alias: 'ticket200',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366748915-48.jpeg',
    image_original: '1366748899-7.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_58',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какому транспортному средству Вы должны уступить дорогу, если на перекрестке намерены совершить разворот?',
    answer_a: 'Только грузовому автомобилю.',
    answer_b: 'Только легковому автомобилю.',
    answer_c: 'Всем транспортным средствам.',
    answer_d: 'Никому.',
    answer_e: '',
  },
  {
    id: 433,
    alias: 'ticket433',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367007589-23.jpeg',
    image_original: '1367007589-38.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-39',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Укажите очередность проезда перекрестка:',
    answer_a: 'Синий, красный, одновременно с зеленым.',
    answer_b: 'Красный, синий, зеленый.',
    answer_c: 'Красный одновременно с зеленым, синий.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 431,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image: '1367007530-22.jpeg',
    image_original: '1367007530-38.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-37',
    created_at: null,
    updated_at: '2020-03-19 10:34:51',
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства правильно въезжает на перекресток с круговым движением?',
    answer_a: 'Оба водителя.',
    answer_b: 'Только водитель автобуса.',
    answer_c: 'Только водитель легкового автомобиля.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 185,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image: '1370602989-72.jpeg',
    image_original: '1366747696-89.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_43',
    created_at: null,
    updated_at: '2020-03-17 12:08:37',
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства имеет преимущество в движении в данной ситуации?',
    answer_a: 'Водитель автобуса.',
    answer_b: 'Водитель легкового автомобиля.',
    answer_c:
      'Водитель легкового автомобиля не имеет право переехать на правую полосу.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 429,
    alias: 'ticket429',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367007450-23.jpeg',
    image_original: '1367007450-39.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-35',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства должен уступить дорогу?',
    answer_a: 'Водитель синего автомобиля.',
    answer_b: 'Водитель красного автомобиля.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 628,
    alias: 'ticket628',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367316814-73.jpeg',
    image_original: '1367261810-54.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-55',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли перевозка пассажиров в салоне автобуса в данной ситуации?',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается.',
    answer_c:
      'Разрешается, только в соответствии с количеством мест для сидения.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 559,
    alias: 'ticket559',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367318140-57.jpeg',
    image_original: '1367238747-66.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-52',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Где должен останавливаться водитель в данной ситуации?',
    answer_a: 'Останавливаться не обязательно.',
    answer_b: 'Перед светофором.',
    answer_c: 'Перед дорожной разметкой » Стоп-линия» .',
    answer_d: 'Перед пересечением полос движения.',
    answer_e: '',
  },
  {
    id: 472,
    alias: 'ticket472',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367233439-21.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-17',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Что означает желтый и красный сигналы светофора, включенные одновременно?',
    answer_a: 'Можно начинать движение.',
    answer_b:
      'Запрещают движение и предупреждают, что вскоре будет включен зеленый сигнал.',
    answer_c:
      'К перекрестку приближается транспортное средство, подающее специальные звуковые или проблесковые световые сигналы.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 146,
    alias: 'ticket146',
    position: 7,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_4',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На перекрестке организовано круговое движение. Проезжая часть, по которой Вы подъезжаете к перекрестку имеет две полосы для движения. Какую полосу Вы обязаны занять для поворота при въезде на перекресток?',
    answer_a: 'Правую полосу.',
    answer_b: 'Левую полосу.',
    answer_c: 'Правую или левую полосу.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 484,
    alias: null,
    position: 3,
    correct_answer: 'answer_b',
    image:
      'eba0dc302bcd9a273f8bbb72be3a687b_1585127853.jpeg',
    image_original: '1367230699-75.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-29',
    created_at: null,
    updated_at: '2020-03-25 13:17:33',
    hint_for_correct_answer: '',
    question:
      'Транспортные средства проедут перекресток в следующем порядке?',
    answer_a: 'Трамвай, красный, зеленый автомобили.',
    answer_b:
      'Красный автомобиль, трамвай одновременно с зеленым автомобилем.',
    answer_c:
      'Трамвай одновременно с зеленым автомобилем, красный автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 736,
    alias: 'ticket736',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-10',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'При травме грудной клетки необходимо:',
    answer_a:
      'Уложить пострадавшего в горизонтальном положении.',
    answer_b:
      'Посадить, подперев его с травмированной стороны.',
    answer_c: 'Посадить, подперев его со здоровой стороны.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 588,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-15',
    created_at: null,
    updated_at: '2020-03-20 10:40:44',
    hint_for_correct_answer: '',
    question:
      'С какой максимальной скоростью разрешается буксировка транспортных средств?',
    answer_a: '30 км/ч.',
    answer_b: '40 км/ч.',
    answer_c: '50 км/ч.',
    answer_d: '60 км/ч.',
    answer_e: '70 км/ч.',
  },
  {
    id: 317,
    alias: 'ticket317',
    position: 7,
    correct_answer: 'answer_c',
    image: '1366978142-56.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-3',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли заезжать на полосу, обозначенную этим знаком при выполнении правого поворота?',
    answer_a: 'Разрешается.',
    answer_b: 'Запрещается.',
    answer_c:
      'Разрешается, если полоса не отделена от остальной проезжей части сплошной линией разметки.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 643,
    alias: 'ticket643',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-8',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Сигналом общей тревоги на железнодорожном переезде служат серии из:',
    answer_a: 'Двух длинных и двух коротких сигналов.',
    answer_b: 'Одного длинного и трех короткий сигналов.',
    answer_c: 'Трех длинных и трех коротких сигналов.',
    answer_d: 'Трех длинных и одного короткого сигнала.',
    answer_e: '',
  },
  {
    id: 744,
    alias: 'ticket744',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 10,
    label: '10-18',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Если в ране пострадавшего находится инородный предмет, то при оказании помощи, необходимо:',
    answer_a: 'Достать из раны инородный предмет.',
    answer_b: 'Не препятствовать кровотечению.',
    answer_c:
      'Зафиксировать инородный предмет в неподвижном положении.',
    answer_d: 'Область раны обработать спиртом.',
    answer_e: '',
  },
  {
    id: 768,
    alias: null,
    position: 0,
    correct_answer: 'answer_b',
    image:
      '3a835d3215755c435ef4fe9965a3f2a0_1584559792.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 1,
    group: 4,
    label: '4-83',
    created_at: '2020-03-18 23:29:52',
    updated_at: '2020-03-18 23:30:01',
    hint_for_correct_answer: '',
    question: 'О чем предупреждает данный дорожный знак?',
    answer_a: 'Остановка запрещается․',
    answer_b:
      'Запрещается въезд на территорию перекрестка, если впереди по направлению движения образовалась пробка, которая принудит водителя остановиться․',
    answer_c:
      'Запрещается въезд на территорию перекрестка, если впереди по направлению движения образовалась пробка․',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 616,
    alias: 'ticket616',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-43',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Движение междугородних автобусов в населенных пунктах разрешается со скоростью не более чем:',
    answer_a: '60 км/ч.',
    answer_b: '70 км/ч.',
    answer_c: '90 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 308,
    alias: 'ticket308',
    position: 6,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_53',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация автобусов запрещается, если:',
    answer_a:
      'Шины автобусов имеют остаточную высоту рисунка протектора 1.6 мм.',
    answer_b:
      'Не работает указатель температуры охлаждающей жидкости двигателя.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 528,
    alias: 'ticket528',
    position: 5,
    correct_answer: 'answer_d',
    image: '1367317100-63.jpeg',
    image_original: '1367237171-39.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-21',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какому автомобилю разрешается остановка в зоне действия этих знаков?',
    answer_a: 'Красному.',
    answer_b: 'Обоим автомобилям.',
    answer_c: 'Ни одному.',
    answer_d:
      'Желтому, обозначенному опознавательным знаком «Инвалид».',
    answer_e: '',
  },
  {
    id: 337,
    alias: null,
    position: 0,
    correct_answer: 'answer_d',
    image:
      '357a6fdf7642bf815a88822c447d9dc4_1583953987.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-23',
    created_at: null,
    updated_at: '2020-03-11 23:13:07',
    hint_for_correct_answer: '',
    question:
      'Какой из знаков указывает зону действия дорожных знаков, запрещающих остановку и стоянку транспортных средств?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 302,
    alias: 'ticket302',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_47',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещается, если:',
    answer_a:
      'Суммарный люфт в рулевом управлении автобуса, изготовленном на базе легкового автомобиля, превышает 10 градусов.',
    answer_b:
      'Отсутствуют предусмотренные конструкцией грязезащитные фартуки и брызговики.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 691,
    alias: 'ticket691',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367319108-93.png',
    image_original: '1367319109-06.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-56',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На каком рисунке показаны разрешенные направления движения?',
    answer_a: 'На левом рисунке.',
    answer_b: 'На среднем рисунке.',
    answer_c: 'На правом рисунке.',
    answer_d: 'На среднем и правом рисунке.',
    answer_e: '',
  },
  {
    id: 651,
    alias: 'ticket651',
    position: 0,
    correct_answer: 'answer_b',
    image: '1485348959-0681.jpeg',
    image_original: '1367318741-41.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-16',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Черный автомобиль проедет перекресток:',
    answer_a: 'Первым.',
    answer_b: 'Вторым.',
    answer_c: 'Последним.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 660,
    alias: 'ticket660',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-25',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Обгон запрещен:',
    answer_a: 'На перекрестках.',
    answer_b:
      'Ближе, чем за 150 м до железнодорожного переезда.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 279,
    alias: 'ticket279',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_24',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эксплуатация транспортных средств запрещена, если:',
    answer_a:
      'Спереди установлены указатели поворота с огнями оранжевого цвета.',
    answer_b:
      'Неисправно тягово-сцепное устройство тягача.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 546,
    alias: 'ticket546',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-39',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Если движение через железнодорожный переезд запрещено и на нем отсутствуют светофор, дорожные знаки, разметка и шлагбаум, то водитель должен остановиться:',
    answer_a: 'Не ближе 5 метров от ближайшего рельса.',
    answer_b: 'Не ближе 7 метров от ближайшего рельса.',
    answer_c: 'Не ближе 10 метров от ближайшего рельса.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 376,
    alias: 'ticket376',
    position: 0,
    correct_answer: 'answer_c',
    image: '1366971645.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-62',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Как должен поступать водитель в том случае, когда перед перекрестком установлен данный дорожный знак?',
    answer_a:
      'Проехать перекресток, соблюдая правила безопасности.',
    answer_b:
      'Уступить дорогу транспортным средствам, двигающимся по пересекаемой дороге.',
    answer_c:
      'Остановиться перед знаком и уступить дорогу транспортным средствам, двигающимся по пересекаемой дороге.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 385,
    alias: null,
    position: 0,
    correct_answer: 'answer_c',
    image:
      'dc912a253d1e9ba40e2c597ed2376640_1584556806.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-71',
    created_at: null,
    updated_at: '2020-03-18 22:40:06',
    hint_for_correct_answer: '',
    question:
      'Действие данных дорожных знаков распространяются:',
    answer_a: 'На левую сторону дороги.',
    answer_b: 'На правую сторону дороги.',
    answer_c: 'На ту сторону дороги, где они установлены.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 487,
    alias: 'ticket487',
    position: 0,
    correct_answer: 'answer_a',
    image: '1367230772-52.jpeg',
    image_original: '1367230772-67.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-32',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Движение запрещено:',
    answer_a: 'Сине-желтому автомобилю-налево.',
    answer_b:
      'Сине-желтому автомобилю-прямо, красному автомобилю-прямо и направо.',
    answer_c: 'Красному автомобилю.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 208,
    alias: 'ticket208',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_4',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Проезжая часть дороги» это:',
    answer_a:
      'Элемент дороги, предназначенный для движения транспортных средств.',
    answer_b:
      'Элемент дороги, предназначенный для движения безрельсовых транспортных средств.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 232,
    alias: 'ticket232',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_28',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Мопед» , это:',
    answer_a:
      'Двух или трехколесное транспортное средство, с двигателем, имеющим рабочий объем не более 50 куб.см и максимальную скорость не более 50 км/час.',
    answer_b:
      'Двух или трехколесное транспортное средство, с двигателем, имеющим рабочий объем не более 60 куб.см и максимальную скорость не более 60 км/час.',
    answer_c:
      'Двух или трехколесное транспортное средство, с двигателем, имеющим рабочий объем не более 70 куб.см и максимальную скорость не более 70 км/час.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 564,
    alias: 'ticket564',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367318243-22.jpeg',
    image_original: '1367238911-58.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-57',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Где должен остановиться водитель в данной ситуации?',
    answer_a: 'Перед первым дорожным знаком.',
    answer_b: 'Перед дорожной разметкой »Стоп-линия».',
    answer_c: 'Перед вторым дорожным знаком.',
    answer_d: 'Останавливаться не обязательно.',
    answer_e: '',
  },
  {
    id: 194,
    alias: 'ticket194',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366748478-19.jpeg',
    image_original: '1366748373-87.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_52',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Обязаны ли Вы, начиная движение с обочины, уступить дорогу легковому автомобилю, который делает разворот?',
    answer_a: 'Обязаны.',
    answer_b: 'Не обязаны.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 480,
    alias: 'ticket480',
    position: 7,
    correct_answer: 'answer_b',
    image: '1367230574-46.jpeg',
    image_original: '1367230574-61.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-25',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства имеет преимущество в движении?',
    answer_a: 'Водитель автомобиля.',
    answer_b: 'Водитель трамвая.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 640,
    alias: 'ticket640',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-5',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Когда водитель обязан подавать предупредительный сигнал перед остановкой?',
    answer_a:
      'Только в случае, если сзади него движется другое транспортное средство.',
    answer_b: 'Только в населенных пунктах.',
    answer_c: 'Во всех случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 364,
    alias: 'ticket364',
    position: 0,
    correct_answer: 'answer_a',
    image: '1366964260-93.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-50',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Движение каких транспортных средств запрещает этот дорожный знак?',
    answer_a: 'Механических транспортных средств.',
    answer_b: 'Только автомобилей.',
    answer_c: 'Всех легковых автомобилей.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 417,
    alias: 'ticket417',
    position: 0,
    correct_answer: 'answer_b',
    image: '1367007016-92.jpeg',
    image_original: '1367007017-07.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-23',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Автомобили проедут перекресток в следующем порядке:',
    answer_a: 'Желтый, зеленый, синий автомобиль.',
    answer_b: 'Синий одновременно с зеленым, желтый.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 443,
    alias: 'ticket443',
    position: 2,
    correct_answer: 'answer_b',
    image: '1367009051-33.jpeg',
    image_original: '1367009051-48.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-49',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства должен уступить дорогу?',
    answer_a: 'Водитель легкового автомобиля.',
    answer_b: 'Водитель автобуса.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 703,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-68',
    created_at: null,
    updated_at: '2020-03-20 16:56:30',
    hint_for_correct_answer: '',
    question:
      'Должен ли быть включен ближний свет фар на транспортном средстве общего пользования при движении в светлое время суток по специально выделенной полосе против основного потока движения?',
    answer_a: 'Должен.',
    answer_b: 'Не должен.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 419,
    alias: 'ticket419',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367007109-43.jpeg',
    image_original: '1367007109-58.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-25',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Первым проедет перекресток:',
    answer_a: 'Зеленый автомобиль.',
    answer_b: 'Синий автомобиль.',
    answer_c: 'Красный автомобиль.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 543,
    alias: 'ticket543',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367317285-2.jpeg',
    image_original: '1367237561-67.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-36',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Водитель какого транспортного средства нарушил правила стоянки?',
    answer_a: 'Водитель синего автомобиля.',
    answer_b: 'Водитель красного автомобиля.',
    answer_c: 'Оба водителя нарушили.',
    answer_d: 'Оба водителя не нарушили.',
    answer_e: '',
  },
  {
    id: 572,
    alias: null,
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-65',
    created_at: null,
    updated_at: '2020-03-19 22:11:38',
    hint_for_correct_answer: '',
    question:
      'Разрешается ли остановка транспортных средств общего пользования вне мест остановок?',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 466,
    alias: 'ticket466',
    position: 1,
    correct_answer: 'answer_a',
    image: '1367225521-14.jpeg',
    image_original: '1367225521-31.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 6,
    label: '6-11',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Движение разрешено:',
    answer_a: 'Направо в первый проезд.',
    answer_b: 'Прямо и направо в первый проезд.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 441,
    alias: 'ticket441',
    position: 4,
    correct_answer: 'answer_a',
    image: '1367008969-68.jpeg',
    image_original: '1367008969-84.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 5,
    label: '5-47',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В каком ответе правильно указана очередность проезда?',
    answer_a: 'Мотоцикл, автобус, грузовой автомобиль.',
    answer_b: 'Автобус, мотоцикл, грузовой автомобиль.',
    answer_c: 'Автобус, грузовой автомобиль, мотоцикл.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 373,
    alias: 'ticket373',
    position: 0,
    correct_answer: 'answer_c',
    image: '1366966601-24.jpeg',
    image_original: '1366966601-39.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-59',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Что показывают данные дорожные знаки?',
    answer_a: 'Остановка запрещена по субботам.',
    answer_b: 'Остановка запрещена по воскресеньям.',
    answer_c:
      'Остановка запрещена по субботам, воскресеньям и по праздничным дням.',
    answer_d: 'Остановка запрещена во время снегопада.',
    answer_e: '',
  },
  {
    id: 249,
    alias: 'ticket249',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_45',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Разрешенная максимальная масса» транспортного средства это:',
    answer_a:
      'Масса максимально укомплектованного и заправленного транспортного средства.',
    answer_b:
      'Масса укомплектованного и заправленного транспортного средства с водителем, пассажирами и грузом, установленного предприятием-изготовителем в качестве максимально допустимой.',
    answer_c:
      'Масса укомплектованного и заправленного транспортного средства с водителем, пассажирами и грузом, установленная предприятием-изготовителем.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 217,
    alias: 'ticket217',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_13',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» за сохранение транспортного средства в технически исправном состоянии ответственность несет:',
    answer_a:
      'Владелец или лицо, пользующееся транспортным средством.',
    answer_b:
      'Организация, которая продала транспортное средство.',
    answer_c:
      'Организация, которая проводила последний годовой технический осмотр транспортного средства.',
    answer_d: 'Все перечисленное лица и организации.',
    answer_e: '',
  },
  {
    id: 570,
    alias: 'ticket570',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367318401-42.jpeg',
    image_original: '1367239086-75.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-63',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Для каких транспортных средств выделена полоса движения, обозначенная буквой «А» ?',
    answer_a:
      'Только для автобусов, которые передвигаются по установленному маршруту.',
    answer_b: 'Для троллейбусов и такси.',
    answer_c:
      'Для транспортных средств общего пользования.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 671,
    alias: 'ticket671',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-36',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При движении в темное время суток на неосвещенных участках дорог на механическом транспортном средстве должен быть включен:',
    answer_a: 'Ближний или дальний свет фар.',
    answer_b: 'Только ближний свет фар.',
    answer_c: 'Только дальний свет фар.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 224,
    alias: 'ticket224',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_20',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» «Регулировщик» , это:',
    answer_a:
      'Лицо, уполномоченное регулировать дорожное движение и осуществляющее это регулирование в установленном законодательством порядке.',
    answer_b:
      'Любой участник дорожного движения (водитель, пешеход, пассажир), который, при возникновении необходимости, осуществляет регулировочные действия.',
    answer_c: 'Все перечисленные лица.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 239,
    alias: 'ticket239',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 2,
    label: '2_35',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'В соответствии с законом РА «Об обеспечении безопасности дорожного движения» право управления транспортными средствами наступает:',
    answer_a:
      'С момента положительной сдачи экзамена по практическому вождению транспортных средств в подразделениях Дорожной полиции полиции РА.',
    answer_b:
      'С момента получения водительского удостоверения.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 310,
    alias: 'ticket310',
    position: 4,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 3,
    label: '3_55',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Эксплуатация автобусов запрещается, если:',
    answer_a:
      'Не работают аварийные выходы и устройства приведения их в действие.',
    answer_b: 'Не работает сигнал требования остановки.',
    answer_c: 'В обоих случаях.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 179,
    alias: 'ticket179',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_37',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'При встречном разъезде, на крутых спусках, необходимо уступить дорогу:',
    answer_a:
      'Водителю транспортного средства общего пользования.',
    answer_b:
      'Водителю транспортного средства, движущегося на подъем.',
    answer_c:
      'Водителю транспортного средства, движущегося под уклон.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 674,
    alias: 'ticket674',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-39',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question: 'Фарой-прожектором разрешается пользоваться:',
    answer_a:
      'Только вне населенных пунктов при отсутствии встречных и попутных транспортных средств.',
    answer_b: 'Только в условиях недостаточной видимости.',
    answer_c:
      'В любых местах, если в этом есть необходимость.',
    answer_d:
      'В темное время суток на всех участках дорог.',
    answer_e: '',
  },
  {
    id: 621,
    alias: 'ticket621',
    position: 0,
    correct_answer: 'answer_b',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-48',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Разрешается ли перевозка пассажиров в буксирующем автобусе?',
    answer_a: 'Запрещается.',
    answer_b: 'Разрешается.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 327,
    alias: null,
    position: 7,
    correct_answer: 'answer_e',
    image:
      'b83aac23b9528732c23cc7352950e880_1583953482.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-13',
    created_at: null,
    updated_at: '2020-03-11 23:04:42',
    hint_for_correct_answer: '',
    question:
      'Какой знак запрещает стоянку по четным числам месяца?',
    answer_a: 'Первый.',
    answer_b: 'Второй.',
    answer_c: 'Третий.',
    answer_d: 'Четвертый.',
    answer_e: 'Пятый.',
  },
  {
    id: 193,
    alias: 'ticket193',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366748273-89.jpeg',
    image_original: '1366748299-83.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_51',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Обязаны ли Вы уступить дорогу легковому автомобилю, если продолжаете движение прямо?',
    answer_a: 'Обязаны.',
    answer_b: 'Не обязаны.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 518,
    alias: 'ticket518',
    position: 0,
    correct_answer: 'answer_c',
    image: '1367236788-37.png',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 7,
    label: '7-11',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Эта дорожная разметка имеет следующее назначение:',
    answer_a:
      'Обозначение стояночных мест, где указаны способы постановки механических транспортных средств на околотротуарной стоянке.',
    answer_b:
      'Обозначение мест, где запрещена остановка механических транспортных средств.',
    answer_c:
      'Обозначение остановок транспортных средств общего пользования и стоянки такси.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 610,
    alias: 'ticket610',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-37',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Буксировка автобуса при гололеде запрещается:',
    answer_a: 'На гибкой сцепке.',
    answer_b: 'На жесткой сцепке.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 192,
    alias: 'ticket192',
    position: 0,
    correct_answer: 'answer_c',
    image: '1366748194-95.jpeg',
    image_original: '1366748177-7.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_50',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какому транспортному средству Вы должны уступить дорогу, продолжая движение прямо.',
    answer_a: 'Только легковому автомобилю.',
    answer_b: 'Только грузовому автомобилю.',
    answer_c: 'Двум транспортным средствам.',
    answer_d: 'Никому.',
    answer_e: '',
  },
  {
    id: 196,
    alias: 'ticket196',
    position: 0,
    correct_answer: 'answer_c',
    image: '1370669156-95.jpeg',
    image_original: '1366748665-12.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 1,
    label: '1_54',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Какому транспортному средству Вы должны уступить дорогу, если намерены совершить поворот налево?',
    answer_a: 'Мотоциклу.',
    answer_b: 'Патрульному автомобилю.',
    answer_c: 'Всем транспортным средствам.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 638,
    alias: 'ticket638',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-3',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Перед маневром предупредительный сигнал должен быть подан:',
    answer_a:
      'Непосредственно перед началом выполнения маневра.',
    answer_b: 'Одновременно с началом выполнения маневра.',
    answer_c:
      'Заблаговременно, до начала выполнения маневра.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 394,
    alias: 'ticket394',
    position: 0,
    correct_answer: 'answer_b',
    image: '1366973614-22.jpeg',
    image_original: '1366973614-37.jpeg',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 4,
    label: '4-80',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Как должен поступить водитель в данной ситуации?',
    answer_a:
      'В случае необходимости уступить дорогу транспортному средству, двигающемуся по пересекаемой дороге.',
    answer_b:
      'Остановиться и уступить дорогу транспортному средству, двигающемуся по пересекаемой дороге.',
    answer_c: '',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 589,
    alias: 'ticket589',
    position: 0,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-16',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Буксировка в условиях гололедицы запрещается:',
    answer_a: 'На гибкой сцепке.',
    answer_b: 'На жесткой сцепке.',
    answer_c: 'Путем частичной погрузки.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 697,
    alias: 'ticket697',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 9,
    label: '9-62',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Перед перестроением водитель автобуса должен подавать предупредительный сигнал?',
    answer_a:
      'Непосредственно перед началом выполнения маневра.',
    answer_b: 'Сразу после начала выполнения маневра.',
    answer_c: 'Заранее - перед началом выполнения маневра.',
    answer_d:
      'Не обязан, если автобус движется по установленному маршруту.',
    answer_e: '',
  },
  {
    id: 578,
    alias: 'ticket578',
    position: 7,
    correct_answer: 'answer_a',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-5',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'Движение транспортных средств в населенных пунктах разрешается со скоростью:',
    answer_a: 'Не более 60 км/ч.',
    answer_b: 'Не более 80 км/ч.',
    answer_c: 'Не более 90 км/ч.',
    answer_d: '',
    answer_e: '',
  },
  {
    id: 604,
    alias: 'ticket604',
    position: 0,
    correct_answer: 'answer_c',
    image: '',
    image_original: '',
    image_answer_a: '',
    image_answer_b: '',
    image_answer_c: '',
    image_answer_d: '',
    image_answer_e: '',
    active: '1',
    checked: 0,
    group: 8,
    label: '8-31',
    created_at: null,
    updated_at: null,
    hint_for_correct_answer: '',
    question:
      'На переднем сиденье легкового автомобиля, не оборудованного устройством для удерживания детей, разрешается перевозить детей, достигших:',
    answer_a: '10-тилетнего возраста.',
    answer_b: '11-тилетнего возраста.',
    answer_c: '12-тилетнего возраста.',
    answer_d: '',
    answer_e: '',
  },
];
